import Axios from "axios";

import MTLLoader from "./three/MTLLoader";
import OBJLoader from "./three/OBJLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import { Measure } from "./Measure.js";
import { Annotation } from "./Annotation.js";
import { AnnotationTool } from "./AnnotationTool.js";
import { MeasuringToolXC } from "./MeasuringTool.js";

import { consoleError } from "../middleware";

import DxfParser from "dxf-parser";
import { ConvertDXFToThree } from "./three/ConvertDXFToThree.js";

import { FlatVolume } from "./Volume";
import { makeSectionDxf } from "./dxf/dxfUtils";
import _ from "lodash";

//add redux-store
import { store } from "../store/store";
import { setAddRequestList, setIsShow, setRemoveRequestList } from "../store/actions/app";
import {
  setCesiumId,
  setDetailAssets,
  setFleetModalRender,
  setTaskVisible,
} from "../store/actions/fleet.asset";

import { message } from "antd";
import { visibleHandleOnChange } from "../components/blocks/model/utils/modelVisible";
import moment from "moment";
import { calculateDestinationPoint3D, getLLA } from "utils/CesiumUtils";
import { ROUND_OFF_THE_NUMBERS_AREA } from "config/measure";

import i18next from "i18next";

const _font = require("./three/DoHyeon_Regular.json");
// const  _font =  require( './three/NanumGothic_Light_Regular.json' )

const $ = window.jQuery;
const THREE = window.THREE;
const Cesium = window.Cesium;
const proj4 = window.proj4;
const Potree = window.Potree;

// const heartBeat = function() {
//   // $('.model-loading-bar').hide();

//   Axios.get("/heartBeat", function() {
//     $(".model-loading-bar").show();
//   });
// };

// const intHeartBeat = setInterval(heartBeat, 1000);

export const FLEET_BASE_COLOR = [
  "#FF0000",
  "#FF7F00",
  "#FFFF00",
  "#00FFFF",
  "#00FF00",
  "#0000FF",
  "#FF00FF",
  "#FEFEFE",
  "#7F7FFF",
  "#007F00",
  "#007CA5",
  "#A50000",
  "#004C4C",
  "#91A552",
  "#581358",
  "#A55200",
  "#7FBFFF",
  "#CCCCCC",
  "#FF7FFF",
  "#FF7F7F",
];
export const FLEET_ASSET_TYPES = [
  "AST001",
  "AST002",
  "AST003",
  "AST004",
  "AST005",
  "AST006",
  "AST037",
  "AST040",
  "AST042",
];

export const xitecloud = {
  max3DVolModelVal: 4000000, // 최대 성토량 기준 (4백만 제곱미터)
  max3DVolModelPlySize: 200 * 1024 * 1024, // 최대 PLY 파일 용량 (200 MB)
  imgScreen: undefined,
  isProcessing: false,
  CurrentCodinate: {},
  GprojectData: {},
  GProject: {},
  GmakeDate: {},

  GTerrainMode: false, // 초기 2D Terrain
  GFlyrocklayer: false,
  bore_zmin: 0,

  initTopoBound: undefined,
  Globaltrans: [0, 0, 0],
  defaultTexture: undefined,
  textGeoOption: {},
  fontmaterials: new THREE.MeshBasicMaterial({ color: 0x035b59 }),
  UNIT: {
    M: [1, "m"], //미터(M)
    INCH: [39.37, "inch"], //인치(Inch)
    FT: [3.2808, "ft"], //피트(Feet)
    YD: [1.0936, "yard"], //야드(Yard)
    MILE: [0.0006, "mile"], //마일(Mile)
  },
  ArrColorDefault: [
    0xf5f507, //yellow
    0xe3821b, //탁한 오렌지
    0xf51f05, //dark red
    0x0e129e, //dark blue
    0x585858, //gray
    0xd8d8d8, //light gray
  ],
  ArrColor: [
    0xf5f507, //yellow
    0xe3821b, //탁한 오렌지
    0xf51f05, //dark red
    0x0e129e, //dark blue
    0x585858, //gray
    0xd8d8d8, //light gray
  ],
  /* https://www.color-hex.com/color-palette/88229 */
  elevetionColorMap: {
    mangojuice: ["#8ca405", "#f3b900", "#ea9e06", "#d56700", "#bd3100"],

    ego: ["#330066", "#6f31a6", "#795c96", "#ccbddb", "#ece2f6"],
    red: ["#ff0000", "#ff4d00", "#ff7400", "#ff9a00", "#ffc100", "#ffc111"],
  },
  targetColor: {
    faceColor: "#0101DF",
    lineColor: "#B6B6B6",
  },
  defaultColor: {
    faceColor: "#00001a",
    lineColor: "#B6B6B6",
  },
  _color: {
    cut: [230, 28, 38],
    fill: [84, 96, 229],
    na: [201, 185, 37],
  },

  MeshStandardMaterial_options: {
    //wireframe:false,
    //transparent: true,
    //opacity: 0.9,
    //vertexColors: 2,
    color: 0xffffff,
    side: THREE.DoubleSide,
    //blending: THREE.AdditiveBlending,
    flatShading: true,
  },

  activeShapePoints: [],
  activeShapePointsWGS84: [],
  activeShape: {},
  floatingPoint: {},
  measurements: [],

  viewDataSet: {
    project: {},
    layer: {
      topo: [],
      subsurface: [],
      target: [],
      overlay: [],
    },
    annotations: {
      onsite: [],
      offsite: [],
      analytics: [],
    },
  },
  toolAttribute: {
    p0: {
      value: "p0",
      label: "Point Properties",
      measureType: "point",
      pickAreatarget: "model",
      annotationGroup: "onsite",
    },
    p1: {
      value: "p1",
      label: "Out side point",
      measureType: "point",
      pickAreatarget: "geo",
      annotationGroup: "offsite",
    },
    p2: {
      value: "p2",
      label: "Geofence & Annotation",
      measureType: "annotation",
      pickAreatarget: "model",
      annotationGroup: "analytics",
    },

    l0: {
      value: "l0",
      label: "Distance",
      measureType: "line",
      pickAreatarget: "model",
      annotationGroup: "onsite",
    },
    l1: {
      value: "l1",
      label: "Route",
      measureType: "line",
      pickAreatarget: "geo",
      annotationGroup: "offsite",
    },
    l2: {
      value: "l2",
      label: "Profile & Crossection",
      measureType: "line",
      pickAreatarget: "model",
      annotationGroup: "onsite",
      crossection: true,
    },

    a1: {
      value: "a1",
      label: "Area of User Selection (Topo)",
      measureType: "area",
      pickAreatarget: "model",
      annotationGroup: "onsite",
      crossection: false,
      volume: false,
      srcTarget: "TOPO",
      children: [
        {
          value: "TOPO",
          label: "Curent Topographic Model PCD",
        },
      ],
    },
    a2: {
      value: "a2",
      label: "Volume(Target Layer)",
      measureType: "area",
      pickAreatarget: "model",
      annotationGroup: "onsite",
      crossection: false,
      volume: true,
      srcTarget: "SUBLAYER",
      targetGeom: "TARGET",
      children: [
        {
          value: "SUBLAYER",
          label: "Target Layer",
        },
      ],
    },
    a3: {
      value: "a3",
      label: "Cut&Fill(Target Layer)",
      measureType: "area",
      pickAreatarget: "model",
      annotationGroup: "analytics",
      crossection: false,
      volume: true,
      srcTarget: "SUBLAYER",
      targetGeom: "TARGET",
      children: [
        {
          value: "SUBLAYER",
          label: "Target Layer",
        },
      ],
    },
  },
  imageryProvider: [
    new Cesium.OpenStreetMapImageryProvider({
      url: "//a.tile.openstreetmap.org/",
    }),
    new Cesium.ArcGisMapServerImageryProvider({
      url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer",
    }),
    new Cesium.ArcGisMapServerImageryProvider({
      url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
    }),
  ],
  wmsLayer: null,
  loaddingShow: true,
  svrResourceRoot: "/uploads",
  IonDefaultAccessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1OWFiMTkzMC05NGIxLTQxZDctODM5Zi1iYzAzMDBhY2YxNWIiLCJpZCI6Mjk3NjUsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1OTI1NzYwMTB9.fXEcnp1-eSNgueZF0zKAw68Gdcom9z_MrqKJBVCWY3M",
  _BASELENGTH: 40.0, //crossection baseline length
  updateLayerListInComponent: function () {},
  detailfleet: function (status) {
    store.dispatch(setTaskVisible(true));
    store.dispatch(setFleetModalRender("card"));
    store.dispatch(setDetailAssets(Number(status.assetId)));
    store.dispatch(setCesiumId(status));
  },
  AssetModels: {},
  Extent: null,
  SelectedKeys: [],
  Companies: [],
  BaseColor: FLEET_BASE_COLOR,
};

const getCurrentDistance = () => {
  const width = window.cesiumViewer.container.clientWidth;
  const height = window.cesiumViewer.container.clientHeight;
  const ray = window.cesiumViewer.camera.getPickRay(new Cesium.Cartesian2(width / 2, height / 2));
  const position = window.cesiumViewer.scene.globe.pick(ray, window.cesiumViewer.scene);
  if (position !== undefined) {
    return Cesium.Cartesian3.distance(window.cesiumViewer.camera.positionWC, position);
  }
};
export const getCurrentExtent = () => {
  const scratchRectangle = new Cesium.Rectangle();
  const rect = window.cesiumViewer.camera.computeViewRectangle(
    window.cesiumViewer.scene.globe.ellipsoid,
    scratchRectangle
  );
  const west = Number(Cesium.Math.toDegrees(rect.west).toFixed(4));
  const south = Number(Cesium.Math.toDegrees(rect.south).toFixed(4));
  const east = Number(Cesium.Math.toDegrees(rect.east).toFixed(4));
  const north = Number(Cesium.Math.toDegrees(rect.north).toFixed(4));

  return [west, south, east, north];
};

export const isCoordIn = (lat, lng) => {
  const coord = xitecloud.Extent;
  return coord[0] <= lng && coord[2] >= lng && coord[1] <= lat && coord[3] >= lat;
};

var LoaddingManager = new THREE.LoadingManager();

let dispose = function (o) {
  try {
    if (o && typeof o === "object") {
      if (Array.isArray(o)) {
        o.forEach(dispose);
      } else if (typeof o.dispose === "function") {
        o.dispose();
      } else {
        o = null;
      }

      // if (o instanceof THREE.Object3D) {
      //     dispose(o.geometry);
      //     dispose(o.material);
      //     if (o.parent) {
      //         o.parent.remove(o);
      //     }

      //     //dispose(o.children);

      // } else
      //     if (o instanceof THREE.Geometry) {
      //         o.dispose();
      //     } else
      //         if (o instanceof THREE.Material) {
      //             o.dispose();
      //             dispose(o.materials);
      //             dispose(o.map);
      //             dispose(o.lightMap);
      //             dispose(o.bumpMap);
      //             dispose(o.normalMap);
      //             dispose(o.specularMap);
      //             dispose(o.envMap);
      //         } else
      //             if (o instanceof Annotation) {
      //                 o.visible = false;
      //                 o = null;
      //             } else
      //                 if (typeof o.dispose === 'function') {
      //                     o.dispose();
      //                 }
      //                 else {
      //                     Object.values(o).forEach(dispose);
      //                 }
    }
  } catch (error) {
    console.log(error);
  }
};

export const initViewDataSet = () => {
  const reduxViewDataset = store.getState().ViewDataSetReducer.projectViewDataSetModel;
  const pointcloudIterator = () => {
    return new Promise((resolve, reject) => {
      try {
        window.viewer.scene.pointclouds.forEach((layer) => {
          window.viewer.scene.scenePointCloud.remove(layer);
        });
        window.viewer.scene.pointclouds = [];
        return resolve();
      } catch (err) {
        return reject(err);
      }
    });
  };

  const resetDataSetIterator = () => {
    return new Promise((resolve, reject) => {
      try {
        //3d object in scence.
        window.viewer.scene.scene.children = [];
        // for (var _3dobject of window.viewer.scene.scene.children) {
        //     window.viewer.scene.scene.remove(_3dobject);
        //     dispose(_3dobject);
        // }

        for (const [key, value] of Object.entries(reduxViewDataset)) {
          //key : [ layers, annotations]
          //value : :[{topo, ...rest /onsite, ...rest}]
          for (const [childrenKey, childrenValue] of Object.entries(value)) {
            childrenValue.map((_item) => {
              if (_item.measure) dispose(_item.measure);
              if (_item.potreeAnnotation) dispose(_item.potreeAnnotation);

              return dispose(_item._3DObject);
            });
          }
        }

        // //clean layer
        // for (var _item of reduxViewDataset.layer.topo) {
        //     dispose(_item._3DObject);
        // }

        // for (var _item of reduxViewDataset.layer.subsurface) {
        //     dispose(_item._3DObject);
        // }

        // for (var _item of reduxViewDataset.layer.target) {
        //     dispose(_item._3DObject);
        // }

        // for (var _item of reduxViewDataset.layer.overlay) {
        //     dispose(_item._3DObject);
        // }

        // //clean annotations
        // for (var _item of reduxViewDataset.annotations.onsite) {
        //     dispose(_item._3DObject);
        //     dispose(_item.measure);
        // }

        // for (var _item of reduxViewDataset.annotations.offsite) {
        //     dispose(_item._3DObject);
        //     dispose(_item.measure);
        // }

        // for (var _item of reduxViewDataset.annotations.analytics) {
        //     dispose(_item._3DObject);
        //     dispose(_item.measure);
        //     dispose(_item.potreeAnnotation);
        // }

        // xitecloud.viewDataSet.layer.overlay = [];
        // xitecloud.viewDataSet.layer.target = [];
        // xitecloud.viewDataSet.layer.subsurface = [];
        // xitecloud.viewDataSet.layer.topo = [];
        // xitecloud.viewDataSet.annotations.onsite = [];
        // xitecloud.viewDataSet.annotations.offsite = [];
        // xitecloud.viewDataSet.annotations.analytics = [];
        xitecloud.viewDataSet.layer = {
          overlay: [],
          target: [],
          subsurface: [],
          topo: [],
        };

        xitecloud.viewDataSet.annotations = {
          onsite: [],
          offsite: [],
          analytics: [],
        };

        return resolve();
      } catch (err) {
        return reject(err);
      }
    });
  };

  const removeMarkers = () => {
    return new Promise((resolve, reject) => {
      window.viewer.scene.removeAllMeasurements();
      window.viewer.scene.removeAllClipVolumes();
      window.viewer.scene.annotations.removeAllChildren();
      window.viewer.scene.initialize();

      for (const [key, value] of Object.entries(reduxViewDataset)) {
        //key : [ layers, annotations]
        //value : :[{topo, ...rest /onsite, ...rest}]
        for (const [childrenKey, childrenValue] of Object.entries(value)) {
          childrenValue.map((_item) => {
            return dispose(_item._3DObject);
          });
        }
      }

      // let scene = new Scene(this.window.viewer.renderer);
      // window.viewer.setScene(new Potree.Scene(window.viewer.renderer));
      window.viewer.setScene(new Potree.Scene(window.viewer.prenderer));

      return resolve();
    });
  };

  const treeNodeIterator = () => {
    return new Promise((resolve, reject) => {
      try {
        //potree clean tree 전체
        var treeNode = window.sceneTree.get_json();

        $(treeNode).each((idx, val) => {
          //트리 카테고리 별
          let _node = treeNode[idx].children;

          $(_node).each((nodeIdx, nodeVal) => window.sceneTree.delete_node(nodeVal));
        });
        return resolve();
      } catch (err) {
        //
        return resolve(err);
      }
    });
  };

  return new Promise((resolve, reject) => {
    pointcloudIterator()
      .then(removeMarkers)
      // .then(resetDataSetIterator)
      // .then(treeNodeIterator)
      .then(resolve)
      .catch(reject);
  });
};

export const xiteCloud = () => {
  LoaddingManager.onStart = function (url, itemsLoaded, itemsTotal) {
    if (xitecloud.loaddingShow) {
      /**
       * add http list
       */
      store.dispatch(
        setAddRequestList({
          requestId: "load_ply",
        })
      );

      /**
       * loadding bar visible true
       */
      store.dispatch(setIsShow(true));
    }
  };
  LoaddingManager.onLoad = function () {
    if (xitecloud.loaddingShow) {
      /**
       * remove http list
       */

      store.dispatch(
        setRemoveRequestList({
          requestId: "load_ply",
        })
      );

      /**
       * loadding bar visible false
       */

      store.dispatch(setIsShow(false));
    }
  };

  LoaddingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
    //$('.model-loading-bar').removeClass('display-none')
    if (xitecloud.loaddingShow) {
      store.dispatch(setIsShow(true));
    }
  };

  LoaddingManager.onError = function (url) {
    if (xitecloud.loaddingShow) {
      store.dispatch(setIsShow(false));
    }
  };

  $(document)
    .bind("contextmenu", function (event) {
      event.preventDefault();
    })
    .bind("click", function (event) {});

  Cesium.Ion.defaultAccessToken = xitecloud.IonDefaultAccessToken;

  const options = {
    useDefaultRenderLoop: false,
    animation: false,
    baseLayerPicker: false,
    fullscreenButton: false,
    geocoder: false,
    homeButton: false,
    infoBox: false,
    sceneModePicker: false,
    selectionIndicator: false,
    timeline: false,
    navigationHelpButton: false,
    imageryProvider: false, //xitecloud.imageryProvider[0], //openstreet
    //infoBox: false,
    selectionIndicator: false,
    // terrainProvider: (xitecloud.GTerrainMode) ? Cesium.createWorldTerrain() : null,
    contextOptions: {
      webgl: {
        preserveDrawingBuffer: true,
      },
    },
  };
  window.cesiumViewer = new window.Cesium.Viewer("cesiumContainer", options);

  // extent change event
  window.cesiumViewer.camera.changed.addEventListener(function () {
    xitecloud.Extent = getCurrentExtent() || xitecloud.Extent;
    // console.log("hk cesiumViewer", window.cesiumViewer);
  });

  //cesium default imageryLayer [openstreet map 사용으로 주석]
  //xitecloud.imageryProvider[0] = window.cesiumViewer.imageryLayers.get(0).imageryProvider;

  if (!window.cesiumViewer.scene.pickPositionSupported) {
    window.alert("This browser does not support pickPosition.");
  }

  //이벤트 발생은 potree canvas
  //var handler = new Cesium.ScreenSpaceEventHandler(window.viewer.canvas);
  var handler = new Cesium.ScreenSpaceEventHandler($("#potree_render_area")[0]);
  var floatingPoint;

  //Cesium Left_Click
  handler.setInputAction(function (event) {
    var earthPosition;
    // if (window.cesiumViewer.baseLayerPicker._viewModel.selectedTerrain.name === "Cesium World Terrain") {
    //earthPosition = window.cesiumViewer.scene.pickPosition(event.position);
    // } else {
    earthPosition = window.cesiumViewer.camera.pickEllipsoid(
      event.position,
      window.cesiumViewer.scene.globe.ellipsoid
    );
    // }

    if (Cesium.defined(earthPosition)) {
      if (xitecloud.activeShapePoints.length === 0) {
        //floatingPoint = createPoint(earthPosition);
        xitecloud.activeShapePoints.push(earthPosition);

        var dynamicPositions = new Cesium.CallbackProperty(function () {
          if (window.drawingMode === "polygon") {
            return new Cesium.PolygonHierarchy(xitecloud.activeShapePoints);
          }
          return xitecloud.activeShapePoints;
        }, false);

        //  activeShape = drawShape(dynamicPositions);
      }

      xitecloud.activeShapePoints.push(earthPosition);
      //createPoint(earthPosition);
    }

    /* pick cesium entities [전종수 2021.04.05] */
    var pickedObject = window.cesiumViewer.scene.pick(event.position);

    if (pickedObject) {
      //console.log( pickedObject )
      let _tmpPickObject = undefined;

      for (let x in xitecloud.AssetModels) {
        if (pickedObject.id === xitecloud.AssetModels[x]) {
          _tmpPickObject = pickedObject.id;
          // alert('Asset Id : ' + x );
          window.xitecloud.detailfleet({ status: true, assetId: x });
          break;
        }
      }
    }

    // if (Cesium.defined(pickedObject) && pickedObject.id === entity) {
    //     entity.billboard.scale = 2.0;
    //     entity.billboard.color = Cesium.Color.YELLOW;
    // } else {
    //     entity.billboard.scale = 1.0;
    //     entity.billboard.color = Cesium.Color.WHITE;
    // }
  }, window.Cesium.ScreenSpaceEventType.LEFT_CLICK);

  handler.setInputAction(function (event) {
    var movement = event;
    var newPosition = window.cesiumViewer.scene.pickPosition(movement.endPosition);

    //cesium  초기화 이전 오류
    try {
      // if (window.viewer.baseLayerPicker._viewModel.selectedTerrain.name === "Cesium World Terrain") {
      //newPosition = window.cesiumViewer.scene.pickPosition(movement.position);
      // } else {
      newPosition = window.cesiumViewer.camera.pickEllipsoid(
        movement.endPosition,
        window.cesiumViewer.scene.globe.ellipsoid
      );
      // }

      var cartographic = window.Cesium.Cartographic.fromCartesian(newPosition);

      var longitudeString = window.Cesium.Math.toDegrees(cartographic.longitude);
      var latitudeString = window.Cesium.Math.toDegrees(cartographic.latitude);

      let xy = [longitudeString, latitudeString];
      let height = cartographic.height;
      let scenePosition = window.toScene.forward(xy);
      //let _threePt = new THREE.Vector3(...scenePosition, _height);

      xitecloud.CurrentCodinate = {
        mapCodinate: [Number(xy[0]).toFixed(5), Number(xy[1]).toFixed(5)],
        modelCodinate: [Number(scenePosition[0]).toFixed(2), Number(scenePosition[1]).toFixed(2)],
      };
    } catch (e) {
      xitecloud.CurrentCodinate = {
        mapCodinate: [0, 0],
        modelCodinate: [0, 0],
      };
    }

    if (Cesium.defined(floatingPoint)) {
      var newPosition = window.cesiumViewer.scene.pickPosition(movement.endPosition);

      // if (window.viewer.baseLayerPicker._viewModel.selectedTerrain.name === "Cesium World Terrain") {
      //newPosition = window.cesiumViewer.scene.pickPosition(movement.position);
      // } else {
      newPosition = window.cesiumViewer.camera.pickEllipsoid(
        movement.endPosition,
        window.cesiumViewer.scene.globe.ellipsoid
      );
      // }

      if (Cesium.defined(newPosition)) {
        floatingPoint.position.setValue(newPosition);
        xitecloud.activeShapePoints.pop();
        xitecloud.activeShapePoints.push(newPosition);
      }

      // console.log(xitecloud.CurrentCodinate);
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

  function terminateShape() {
    xitecloud.activeShapePoints.pop();
    xitecloud.activeShapePointsWGS84.pop();
  }

  //Cesium Right_click
  handler.setInputAction(function (event) {
    var param = "";
    var param_first = "";

    // if (drawingMode === 'polygon' && xitecloud.activeShapePoints.length > 3) {

    xitecloud.activeShapePointsWGS84 = [];

    for (var _i = 0; _i < xitecloud.activeShapePoints.length; _i++) {
      //var cartesian = window.viewer.camera.pickEllipsoid(activeShapePoints[_i], scene.globe.ellipsoid);

      if (xitecloud.activeShapePoints[_i]) {
        var cartographic = Cesium.Cartographic.fromCartesian(xitecloud.activeShapePoints[_i]);

        var longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
        var latitudeString = Cesium.Math.toDegrees(cartographic.latitude);

        xitecloud.activeShapePointsWGS84.push({
          long: longitudeString,
          lat: latitudeString,
          height: cartographic.height,
        });

        if (_i != 0) param += ",";
        else {
          param_first = longitudeString + " " + latitudeString + " " + cartographic.height + " ";
        }

        param += longitudeString + " " + latitudeString + " " + cartographic.height + " ";

        // console.log( param );
      }
    }

    // }

    terminateShape();
  }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

  window.viewer = new Potree.Viewer(document.getElementById("potree_render_area"), {
    /* -0----------------------- */
    useDefaultRenderLoop: false,
    /* -0----------------------- */
  });
  window.viewer.setEDLEnabled(true);
  window.viewer.setFOV(60);
  window.viewer.setPointBudget(4 * 1000 * 1000);
  window.viewer.setMinNodeSize(0);
  window.viewer.loadSettingsFromURL();

  /* -0----------------------- */
  window.viewer.setBackground(null);
  //window.viewer.useHQ = true;
  /* -0----------------------- */

  // let light = new THREE.SpotLight();
  // 	light.distance = 40;
  // 	light.angle = (40 / 180) * Math.PI;
  // 	// light.position.set(-22.124, 15.918, 3.518);
  // 	// light.lookAt(new THREE.Vector3(-5.306, 5.288, 3.084));
  //     window.viewer.scene.scene.add(light);

  xitecloud.defaultTexture = new THREE.Texture(generateTexture());
  xitecloud.defaultTexture.needsUpdate = true;

  //debugger;

  let loaderJson = new THREE.FontLoader();
  let font = loaderJson.parse(_font);

  xitecloud.textGeoOption = {
    font: font,
    size: 1,
    height: 0,
  };

  // let loader = new THREE.FontLoader();
  // // // loader.load('/libs/three.js/extra/fonts/helvetiker_regular.typeface.json', function (_font) {
  //     function test () {
  //         return new Promise((resolve, reject) => {
  //             loader.load('/libs/three.js/extra/fonts/DoHyeon_Regular.json', function (_font) {
  //                 //loader.load('/libs/three.js/extra/fonts/NanumGothic_Light_Regular.json.json', function (_font) {
  //                 return resolve(_font)
  //             });
  //         })
  //     }
  //     (async () => {
  //         const _font = await test()
  //         window.xitecloud.textGeoOption = {
  //             font: _font,
  //             size: 1,
  //             height: 0
  //         }
  //     })()

  window.viewer.annotationTool = new AnnotationTool(window.viewer);
  window.viewer.measuringTool = new MeasuringToolXC(window.viewer);

  // window.viewer.loadGUI(() => {
  //     $('#potree_render_area > canvas').css('left', '0px');
  //     window.sceneTree = $("#jstree_scene").jstree();
  //     // window.viewer.volumeTool = new VolumeToolXC(window.viewer);
  // });

  let hasContext = true;
  const canvasEl = window.viewer.renderer.getContext().canvas;
  canvasEl.addEventListener("webglcontextlost", (event) => {
    hasContext = false;
    cancelAnimationFrame(loop);
    event.preventDefault();
  });

  canvasEl.addEventListener(
    "webglcontextrestored",
    function (event) {
      // Do something
      console.log("@", event);
    },
    false
  );

  //하단 loop문 내부에 있던 로컬 함수.
  const toCes = (pos) => {
    let xy = [pos.x, pos.y];
    let height = pos.z;

    let deg = window.toMap.forward(xy);
    let cPos = Cesium.Cartesian3.fromDegrees(...deg, height);

    return cPos;
  };

  function loop(timestamp) {
    if (hasContext) {
      requestAnimationFrame(loop);
      window.viewer.update(window.viewer.clock.getDelta(), timestamp);
      window.viewer.render();

      if (window.toMap !== undefined) {
        {
          let camera = window.viewer.scene.getActiveCamera();

          let pPos = new THREE.Vector3(0, 0, 0).applyMatrix4(camera.matrixWorld);
          let pRight = new THREE.Vector3(600, 0, 0).applyMatrix4(camera.matrixWorld);
          let pUp = new THREE.Vector3(0, 600, 0).applyMatrix4(camera.matrixWorld);
          let pTarget = window.viewer.scene.view.getPivot();

          let cPos = toCes(pPos);
          let cUpTarget = toCes(pUp);
          let cTarget = toCes(pTarget);

          let cDir = Cesium.Cartesian3.subtract(cTarget, cPos, new Cesium.Cartesian3());
          let cUp = Cesium.Cartesian3.subtract(cUpTarget, cPos, new Cesium.Cartesian3());

          cDir = Cesium.Cartesian3.normalize(cDir, new Cesium.Cartesian3());
          cUp = Cesium.Cartesian3.normalize(cUp, new Cesium.Cartesian3());

          /**
           * 김신후 추가
           * 값이 제대로 동작 시에만 맵 이동.
           */
          if (pPos.x !== 0 && pPos.y !== 0 && pPos.z !== 0) {
            window.cesiumViewer.camera.setView({
              destination: cPos,
              orientation: {
                direction: cDir,
                up: cUp,
              },
            });
          }
        }

        let aspect = window.viewer.scene.getActiveCamera().aspect;
        if (aspect < 1) {
          let fovy = Math.PI * (window.viewer.scene.getActiveCamera().fov / 180);
          window.cesiumViewer.camera.frustum.fov = fovy;
        } else {
          let fovy = Math.PI * (window.viewer.scene.getActiveCamera().fov / 180);
          let fovx = Math.atan(Math.tan(0.5 * fovy) * aspect) * 2;
          window.cesiumViewer.camera.frustum.fov = fovx;
        }
      }

      window.cesiumViewer.render();
    }
  }

  //기본모드 openstreetmap + terrain
  fnChangeImageMap(0);
  fnChangeTerrainMode(xitecloud.GTerrainMode);
  requestAnimationFrame(loop);
};

export const makeSvrResource = function (_type, _item) {
  let rtnPath = xitecloud.svrResourceRoot;

  if (_type == "POINTCLOUD") {
    //"/uploads/data_pcd/13/20200218/Pointcloud/cloud.js"
    rtnPath += `/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/Pointcloud/cloud.js`;
  } else if (_type == "ROCKLAYER") {
    rtnPath += `/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/${_item.f_file_path}`;
  } else if (_type == "CONTOUR") {
    rtnPath += `/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/${_item.f_contour_geojson_file_nm}`;
  } else {
    rtnPath += `/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/`;
  }

  return rtnPath;
};

//load potree pointcloud and add geom to global viewDataset
export const loadPointCloud = function (_item, pcdTreeName, dataset, _pgLoadCallback) {
  return new Promise((resolve, reject) => {
    const pcdUrl = makeSvrResource("POINTCLOUD", _item);
    Potree.loadPointCloud(
      pcdUrl,
      pcdTreeName,
      function (e) {
        //react 에서 map init 함
        // setProjection();

        var Globaltrans = xitecloud.Globaltrans;
        // console.log(Globaltrans)
        let scene = window.viewer.scene;
        let pointcloud = e.pointcloud;

        window.viewer.scene.addPointCloud(e.pointcloud);

        let material = e.pointcloud.material;
        material.size = 1;
        material.pointSizeType = Potree.PointSizeType.ADAPTIVE;

        const { max, min } = e.pointcloud.pcoGeometry.tightBoundingBox;
        let _min = Math.abs(max.z - min.z) + e.pointcloud.position.z;

        // xitecloud.bore_zmin = e.pointcloud.position.z;
        xitecloud.bore_zmin = _min;
        xitecloud.bore_zmin = 70;

        e.pointcloud.position.set(
          e.pointcloud.position.x + Globaltrans[0],
          e.pointcloud.position.y + Globaltrans[1],
          e.pointcloud.position.z + Globaltrans[2]
        );

        window.viewer.fitToScreen();
        $("#lds-roller-container").hide();

        xitecloud.initTopoBound = window.viewer.getBoundingBox();

        //light
        window.viewer.scene.scene.add(new THREE.HemisphereLight(0xffffff, 0xffffff, 0.7));

        var directionalLight = new THREE.DirectionalLight(0xffffff, 0.7);
        //directionalLight.position.set(e.pointcloud.position.x, e.pointcloud.position.y, e.pointcloud.position.z + 100);
        window.viewer.scene.scene.add(directionalLight);

        directionalLight.castShadow = true;

        dataset._3DObject = e.pointcloud;
        return resolve(dataset);
      },
      (err) => {
        /**
         * map freeze
         */
        window.toMap = undefined;
        window.cesiumViewer.camera.lookAt(
          Cesium.Cartesian3.fromDegrees(0, 0),
          new Cesium.Cartesian3(0.0, 0.0, 20000000.0)
        );

        return reject(err);
      }
    );
  });
};

//potree measureringtool link or switch measurementtool
export const startInsertion = function (option, _finishCallback) {
  if (xitecloud.isProcessing) {
    alert("Sorry now Processing...");
    return;
  }

  //area
  var potreeMeasureOption;

  //potree measurement
  let measurement;

  let _callback = function (gbn) {
    if (measurement.firstTime && gbn?.type !== "point") measurement.firstTime = false;
    _finishCallback(option, measurement);

    if (gbn && gbn === "cancel") {
      /**
       * Potree Annotation -> cancel.callback
       */
      measurement.dispose();
    }
  };

  if (option.measureType == "area") {
    potreeMeasureOption = {
      type: "line",
      showDistances: true,
      showArea: true,
      closed: true,
      name: "Area",
      pickAreatarget: option.pickAreatarget,
      callback: _callback,
    };
  } else if (option.measureType == "line") {
    //line
    potreeMeasureOption = {
      type: "line",
      showDistances: true,
      showArea: false,
      closed: false, //area option
      name: option.label,
      pickAreatarget: option.pickAreatarget,
      callback: _callback,
    };
  } else {
    //point, annotation
    potreeMeasureOption = {
      type: "point",
      showDistances: false,
      showAngles: false,
      showCoordinates: true,
      showArea: false,
      closed: true,
      maxMarkers: 1,
      name: option.label,
      pickAreatarget: option.pickAreatarget,
      pickCrosspointMeasure: null, //window.viewer.scene.measurements[0], //option.pickCrosspointMeasure,
      cancelToken: true,
      callback: _callback,
    };

    if (option.measureType === "crossSectionPoint") {
      potreeMeasureOption.pickCrosspointMeasure = option.pickCrosspointMeasure;
    }
  }

  //annotation
  // if (option.measureType === "annotation") {
  //     measurement = window.viewer.annotationTool.startInsertion(potreeMeasureOption);

  //     //potree annotation에서 콜백처리안됨 (전종수 20.02.26)
  //     //if( _callback )
  //     //_callback (option, measurement);

  //     //route (cesium point )
  // } else {
  //measurement 통합 [전종수 20200506]
  //if (option.pickAreatarget === "geo") {
  //자체 이벤트 처리용 전종수 2020.01.15
  //measurement = drawInit(potreeMeasureOption);
  //potree point, line, area
  //} else if (option.pickAreatarget === "model") {
  console.log(potreeMeasureOption);
  measurement = window.viewer.measuringTool.startInsertion(potreeMeasureOption);
  // }

  //window.xitecloud.measurements.push({"option" : option, "measurement" : measurement, "calback" : _callback});

  return measurement;
};

//cesium 좌표 measurment 용
export const drawInit = (args) => {
  let domElement = window.viewer.renderer.domElement;

  let cancel = {
    callback: args.callback || null,
  };

  var _measure = new Measure();

  const pick = (defaul, alternative) => {
    if (defaul != null) {
      return defaul;
    } else {
      return alternative;
    }
  };

  _measure.showDistances = args.showDistances === null ? true : args.showDistances;

  _measure.showArea = pick(args.showArea, false);
  _measure.showAngles = pick(args.showAngles, false);
  _measure.showCoordinates = pick(args.showCoordinates, false);
  _measure.showHeight = pick(args.showHeight, false);
  _measure.showCircle = pick(args.showCircle, false);
  _measure.showAzimuth = pick(args.showAzimuth, false);
  _measure.showEdges = pick(args.showEdges, true);
  _measure.closed = pick(args.closed, false);
  _measure.maxMarkers = pick(args.maxMarkers, Infinity);

  _measure.name = args.name || "Measurement";

  //전종수 measuring 이후 callback 함수 호출 추가
  _measure.type = args.type;
  _measure._calback = args.callback;

  window.viewer.scene.addMeasurement(_measure);

  let insertionCallback = (e) => {
    if (e.button === THREE.MOUSE.LEFT) {
      let _pt = new Cesium.Cartesian2(e.layerX, e.layerY);
      let earthPosition = window.cesiumViewer.camera.pickEllipsoid(
        _pt,
        window.cesiumViewer.scene.globe.ellipsoid
      );

      var cartographic = Cesium.Cartographic.fromCartesian(earthPosition);

      var longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
      var latitudeString = Cesium.Math.toDegrees(cartographic.latitude);

      let xy = [longitudeString, latitudeString];
      let height = cartographic.height;
      let scenePosition = window.toScene.forward(xy);

      //potree 용 좌표
      _measure.addMarker(new THREE.Vector3(...scenePosition, height));
      _measure.update();
    } else if (e.button === THREE.MOUSE.RIGHT) {
      cancel.callback();
    }
  };

  cancel.callback = (e) => {
    // if (cancel.removeLastMarker) {
    //     measure.removeMarker(measure.points.length - 1);
    // }
    // domElement.removeEventListener('mouseup', insertionCallback, true); chrome 89 fixed
    domElement.removeEventListener("mouseup", insertionCallback, false);
    window.viewer.removeEventListener("cancel_insertions", cancel.callback);

    //전종수 2020.01.07
    if (args.callback) {
      args.callback(_measure);
    }
  };

  window.viewer.addEventListener("cancel_insertions", cancel.callback);
  // domElement.addEventListener('mouseup', insertionCallback, true); chrome 89 fixed
  domElement.addEventListener("mouseup", insertionCallback, false);

  return _measure;
};

export const drawFinish = function () {};

//potree and cesium projection link update
export const setProjection = function (projObj) {
  xitecloud.Globaltrans = [0, 0, 0];

  if (projObj === undefined) projObj = xitecloud.viewDataSet.project;

  const _project = projObj;

  let pointcloudProjection = proj4.defs("WGS84"); //EPSG
  let mapProjection = proj4.defs("WGS84");

  if (_project) {
    pointcloudProjection = _project.f_coord_system;
  } else {
    alert("invaild project !!");
    return;
  }

  if (pointcloudProjection) {
    window.toMap = proj4(pointcloudProjection, mapProjection);
    window.toScene = proj4(mapProjection, pointcloudProjection);
  }

  {
    let bb = window.viewer.getBoundingBox();

    let minWGS84 = proj4(pointcloudProjection, mapProjection, bb.min.toArray());
    let maxWGS84 = proj4(pointcloudProjection, mapProjection, bb.max.toArray());
  }

  //potree tree init
  window.viewer.scene.pointclouds.forEach(function (layer) {
    window.viewer.scene.scenePointCloud.remove(layer);
  });
  window.viewer.scene.pointclouds = [];
};

export const fnMakeRockLayer = async function (_projectLayerInfo, cancelHandler) {
  return Promise.all(
    _projectLayerInfo.subsurface.map(
      (_item, idx) =>
        new Promise((resolve, reject) => {
          (async () => {
            try {
              const params =
                idx === 0
                  ? {
                      targetTable: _projectLayerInfo.target[0].f_geometry_tbl_nm,
                      topTable: _projectLayerInfo.topo[0].f_ply_geom_tbl_nm,
                      bottomTable: _projectLayerInfo.subsurface[0].f_geometry_tbl_nm,
                    }
                  : {
                      targetTable: _projectLayerInfo.target[0].f_geometry_tbl_nm,
                      topTable: _projectLayerInfo.subsurface[idx - 1].f_geometry_tbl_nm,
                      bottomTable: _projectLayerInfo.subsurface[idx].f_geometry_tbl_nm,
                    };

              const { data } = await Axios.get(
                "/api/makeWallPlan",
                { params },
                {
                  cancelToken: cancelHandler(),
                }
              );

              let geomGroup = new THREE.Object3D();
              let _rtnGeom = fnMakeLayerAreaGeom(
                data.features[0].geometry,
                xitecloud.ArrColor[idx]
              );
              geomGroup.add(_rtnGeom);
              let _rtnGeom2 = fnMakeLayerAreaGeom(
                data.features[1].geometry,
                xitecloud.ArrColor[idx]
              );
              geomGroup.add(_rtnGeom2);
              let _rtnGeom3 = fnMakeLayerAreaGeom(
                data.features[2].geometry,
                xitecloud.ArrColor[idx]
              );
              geomGroup.add(_rtnGeom3);

              window.viewer.scene.scene.add(geomGroup);

              return resolve({
                title: _item.f_layer_nm + " Rock Volume Layer " + idx,
                dbObj: _item,
                _3DObject: geomGroup,
                visible: true,
                gbn: "Layers", //sidebar pannel tab  Layers/Annotations
                group: "subsurface",
                dataType: "3DObject",
              });
            } catch (err) {
              return reject(err);
            }
          })();
        })
    )
  );
};

export const fnLoadPly = function (prjObj, _item, name, path, _color, _plyLoadCallBack) {
  return new Promise((resolve, reject) => {
    (async () => {
      let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
      _option.color = _color;

      //$('#lds-roller-container').show();

      let Globaltrans = xitecloud.Globaltrans;
      let loader = new THREE.PLYLoader(LoaddingManager);
      let plyGeom = new THREE.Object3D();

      path = makeSvrResource("ROCKLAYER", _item);
      const filePath = `uploads/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/${_item.f_file_path}`;
      /**
       * 20200716 김신후 추가
       * 파일 있는지 확인 후 없을 경우 에러.
       * 수정 추가 0901
       *  서버 파일 확인 path 추가
       */
      const checkFile = await Axios.get(`/fileCheck?filePath=${filePath}`);
      if (!checkFile.data) return reject(checkFile);

      /**
       * 20200510 김신후 추가.
       *  THREE.Loader 의 arguments 기준 프로그레스, 에러 핸들러 추가.
       *  추후 에러 시 동작을 reject로 전환 후 에러에 따른 에러 핸들 추가 필요.
       *
       *  변경 전.
       *   - loader의 에러 핸들이 없어 들어온 후 물려 있던 함수들이 전부 멈춰버림
       *  변경 후
       *   - 에러 발생 시에도 우선 다음 함수 실행
       */
      const onLoaded = (geometry) => {
        geometry.computeVertexNormals();

        // if (Globaltrans && Globaltrans.length == 3) {
        //     console.log(Globaltrans)
        //     geometry.applyMatrix(new THREE.Matrix4().makeTranslation(Globaltrans[0], Globaltrans[1], Globaltrans[2]));
        // }

        {
          //var material = new THREE.MeshBasicMaterial(  _option   ); //vertexColors:THREEVertexColor
          let material = new THREE.MeshStandardMaterial(_option);
          let _plyGeom = new THREE.Mesh(geometry, material);

          plyGeom.add(_plyGeom);

          plyGeom.name = name;
          window.viewer.scene.scene.add(plyGeom);

          ////////////////////////////////////////////////
          //delay test [전종수 20200818]
          return resolve({
            title: _item.f_layer_nm,
            dbObj: _item,
            _3DObject: plyGeom,
            visible: true,
            gbn: "Layers", //sidebar pannel tab  Layers/Annotations
            group: "subsurface",
            dataType: "ply",
          });
        }
      };

      const onProgress = () => {
        //  resolve()
      };
      const onError = (err) => {
        console.log(arguments, "err");
        reject();
      };

      loader.load(path, onLoaded, onProgress, onError);

      // return resolve({
      //     'title': _item.f_layer_nm,
      //     'dbObj': _item,
      //     '_3DObject': plyGeom,
      //     'visible': true,
      //     //추후 개별 로딩을 위함.
      //     // modelDraw: true,
      //     // _color,
      //     'gbn': 'Layers', //sidebar pannel tab  Layers/Annotations
      //     'group': 'subsurface',
      //     'dataType': 'ply'
      // });
    })();
  });
};

export const fnLoadGLTF = function (prjObj, _item, name, path, _color, _plyLoadCallBack) {
  return new Promise((resolve, reject) => {
    (async () => {
      let Globaltrans = xitecloud.Globaltrans;

      const loader = new GLTFLoader();

      const filePath = `/uploads/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/${_item.f_file_path}`;

      // Load a glTF resource
      loader.load(
        // resource URL
        filePath,
        // called when the resource is loaded
        function (gltf) {
          var newMaterial = new THREE.MeshStandardMaterial({
            // transparent: true,
            // opacity: 0.9,
            color: _color,
            side: THREE.DoubleSide,
            flatShading: true,
          });

          var geo = new THREE.EdgesGeometry(gltf.scene.children[0].geometry); // or WireframeGeometry
          var mat = new THREE.LineBasicMaterial({
            color: 0x000000,
            side: THREE.DoubleSide,
            // blending: THREE.AdditiveBlending,
            transparent: true,
            opacity: 0.8,
            flatShading: true,
          });

          var wireframe = new THREE.LineSegments(geo, mat);
          gltf.scene.add(wireframe);

          gltf.scene.traverse((o) => {
            if (o.isMesh) {
              o.material = newMaterial;
              // o.castShadow = true;
              // o.receiveShadow = true;
              // if (o.material.map) n.material.map.anisotropy = 16;
            }
          });

          const light = new THREE.DirectionalLight(0xffffff);
          light.distance = 40;
          light.angle = (40 / 180) * Math.PI;
          light.castShadow = true;
          light.lookAt(new THREE.Vector3(-5.306, 5.288, 3.084));

          gltf.scene.add(light);

          window.viewer.scene.scene.add(gltf.scene);

          resolve({
            title: _item.f_layer_nm,
            dbObj: _item,
            _3DObject: gltf.scene,
            visible: true,
            hasArrow: false,
            gbn: "Layers",
            group: "subsurface",
            dataType: "glb",
          });
        },
        // called while loading is progressing
        function (xhr) {
          // console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
        },
        // called when loading has errors
        function (error) {
          reject(error);
        }
      );
    })();
  });
};

export const fnLoadGLTFForVertexColor = function (
  prjObj,
  _item,
  name,
  path,
  _color,
  _plyLoadCallBack
) {
  return new Promise((resolve, reject) => {
    (async () => {
      let Globaltrans = xitecloud.Globaltrans;

      const loader = new GLTFLoader();

      const filePath = `/uploads/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/${_item.f_file_path}`;

      // Load a glTF resource
      loader.load(
        // resource URL
        filePath,
        // called when the resource is loaded
        function (gltf) {
          window.viewer.scene.scene.add(gltf.scene);
          resolve({
            title: _item.f_layer_nm,
            dbObj: _item,
            _3DObject: gltf.scene,
            visible: true,
            hasArrow: false,
            gbn: "Layers",
            group: "subsurface",
            dataType: "glb",
          });
        },
        // called while loading is progressing
        function (xhr) {
          // console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
        },
        // called when loading has errors
        function (error) {
          //console.log("An error happened");
        }
      );
    })();
  });
};

//(_item, pcdUrl, pcdTreeName, _pgLoadCallback )
export const loadShapeFile = async function (_item, shapeUrl, shapeTreeName, _shapeLoadCallback) {
  const loader = new Potree.ShapefileLoader(LoaddingManager);

  // add roads.shp and change colors to yellow
  await loader.load(shapeUrl).then(function (shpRoads) {
    //shapeNode.add(shpRoads.node);

    // shpRoads.node.traverse(node => {
    //     if(node.material){
    //         node.material.color.setRGB(1, 1, 0)
    //     }
    // });

    window.viewer.scene.scene.add(shpRoads.node); //3dobject

    ////////////////////////////////////////////////

    window.xitecloud.viewDataSet.layer.topo.push({
      gbn: "Layers",
      group: "topo",
      dataType: "shape",
      title: _item.f_description,
      dbObj: _item,
      _3DObject: shpRoads.node,
      visible: true,
    });

    //project component in function
    window.xitecloud.updateLayerListInComponent();

    ////////////////////////////////////////////////

    if (_shapeLoadCallback) {
      _shapeLoadCallback(_item, shpRoads.node);
    }
  });
};

export const loadImageFile = function (_item, imageUrl, shapeTreeName, _imageLoadCallback) {
  return new Promise((resolve, reject) => {
    // let _option = Object.assign({},  xitecloud.MeshStandardMaterial_options);
    // _option.color =  _color;

    //$('#lds-roller-container').show();

    let Globaltrans = xitecloud.Globaltrans;
    const loader = new THREE.ImageLoader(LoaddingManager);

    loader.load(
      imageUrl,
      function (image) {
        // onLoad callback

        var texture = new THREE.CanvasTexture(image);
        var material = new THREE.MeshBasicMaterial({
          //  color: 0x0000ff,
          map: texture,
          opacity: 0.9,
        });

        let camera = window.viewer.scene.getActiveCamera();

        let pPos = new THREE.Vector3(0, 0, 0).applyMatrix4(camera.matrixWorld);
        let pRight = new THREE.Vector3(600, 0, 0).applyMatrix4(camera.matrixWorld);
        let pUp = new THREE.Vector3(0, 600, 0).applyMatrix4(camera.matrixWorld);
        let pTarget = window.viewer.scene.view.getPivot();

        var geometry = new THREE.BoxBufferGeometry(
          window.viewer.scene.pointclouds[0].boundingBox.max.x,
          window.viewer.scene.pointclouds[0].boundingBox.max.y,
          0
        );

        var cube = new THREE.Mesh(geometry, material);

        cube.position.set(pTarget.x, pTarget.y, pTarget.z);

        window.viewer.scene.scene.add(cube);

        // window.xitecloud.viewDataSet.layer.topo.push(
        //     {
        //         'gbn': 'Layers',
        //         'group': 'overlay',
        //         'dataType': 'shape',
        //         'title': _item.f_description + ' (Ortho Photo)',
        //         'dbObj': _item,
        //         '_3DObject': cube,
        //         visible: true,

        //     });

        return resolve({
          gbn: "Layers",
          group: "overlay",
          dataType: "shape",
          title: _item.f_description + " (Ortho Photo)",
          dbObj: _item,
          _3DObject: cube,
          visible: true,
        });
        //project component in function
        //window.xitecloud.updateLayerListInComponent();
      },

      // onProgress callback currently not supported
      undefined,

      // onError callback
      function (err) {
        console.log(err);
        return reject(err);
        consoleError("An error happened.");
      }
    );
  });
};

export const loadMTL = async function (_item, url, shapeTreeName, _LoadCallback) {
  var manager = new THREE.LoadingManager();

  new MTLLoader(manager)
    .setPath("/uploads/tmp/3d_mesh/")
    .load("1st_simplified_3d_mesh.mtl", function (materials) {
      materials.preload();

      new OBJLoader(manager)
        .setMaterials(materials)
        .setPath("/uploads/tmp/3d_mesh/")
        .load(
          "1st_simplified_3d_mesh.obj",
          function (object) {
            object.position.y = -95;
            //scene.add( object );

            window.viewer.scene.scene.add(object);

            window.xitecloud.viewDataSet.layer.topo.push({
              gbn: "Layers",
              group: "topo",
              dataType: "shape",
              title: _item.f_description,
              dbObj: _item,
              _3DObject: object,
              visible: true,
            });

            //project component in function
            window.xitecloud.updateLayerListInComponent();
          },
          function (xhr) {
            if (xhr.lengthComputable) {
              var percentComplete = (xhr.loaded / xhr.total) * 100;
              // console.log(Math.round(percentComplete, 2) + '% downloaded');
            }
          },
          function () {}
        );
    });
};

export async function loadContourGeoJSON(_item, path, _callBack) {
  let _elevetionColorMap = xitecloud.elevetionColorMap.red;

  const { data } = await Axios.get(path, {
    params: {},
  });

  const planet = new THREE.Object3D();

  console.log(data);
  window.drawThreeGeo(
    data,
    10,
    "line",
    {
      color: xitecloud.defaultColor.lineColor,
      //trans: xitecloud.Globaltrans,
      side: THREE.DoubleSide,
    },
    planet
  );

  planet.applyMatrix(
    new THREE.Matrix4().makeTranslation(
      xitecloud.Globaltrans[0],
      xitecloud.Globaltrans[1],
      xitecloud.Globaltrans[2]
    )
  );

  let _a = new THREE.Box3().expandByObject(planet);
  let baseTerm = Math.ceil((_a.max.z - _a.min.z) / _elevetionColorMap.length);

  for (var node of planet.children) {
    let _b = new THREE.Box3().expandByObject(node);
    node.visible = _b.min.z % 5 == 0; //default 5m

    let _color = _elevetionColorMap[Math.floor(_b.min.z / baseTerm)];
    node.material.color = new THREE.Color(_color);
  }

  class DataViewObj {
    constructor(_item, _planet) {
      this.planet = _planet;

      this.title = _item.f_layer_nm + " ContourLine";
      this.dbObj = _item;
      this._3DObject = _planet;
      this.visible = true;
      this.gbn = "Layers";
      this.group = "topo";
      this.dataType = "geojson";
      this.indexTerm = 5;
      this.indexColor = "#ff0000";
      this.indexType = 1;
      this.indexThickness = 2;
      this.interTerm = 1;
      this.interColor = "#00ff00";
      this.interThickness = 1;
      this.interType = 1;

      this.changeTerm = (term) => {
        term %= 9;

        for (var node of this.planet.children) {
          let _b = new THREE.Box3().expandByObject(node);
          node.visible = _b.min.z % term === 0;
        }
      };

      this.update = () => {
        // term %= 9;

        for (var node of this.planet.children) {
          let _b = new THREE.Box3().expandByObject(node);

          if (_b.min.z % this.indexTerm === 0) {
            node.material.linewidth = this.indexThickness;
            node.material.color = new THREE.Color(this.indexColor);
            node.visible = true;
          } else if (_b.min.z % this.interTerm === 0) {
            node.material.linewidth = this.interThickness;
            node.material.color = new THREE.Color(this.interColor);
            node.visible = true;
          } else {
            //                         node.material.linewidth = this.interThickness;
            //                         node.material.color = new THREE.Color(this.interColor);
            node.visible = false;
          }
        }
      };

      this.resetColor = () => {
        this.changeTerm(1);

        for (var node of this.planet.children) {
          let _b = new THREE.Box3().expandByObject(node);

          let _color = _elevetionColorMap[Math.floor(_b.min.z / baseTerm)];
          node.material.color = new THREE.Color(_color);
        }
      };

      this.setIndexColor = (_color) => {
        this.indexColor = _color;
      };
      this.getIndexColor = () => {
        return this.indexColor;
      };
      this.setIndexTerm = (val) => {
        this.indexTerm = val;
      };
      this.getIndexTerm = () => {
        return this.indexTerm;
      };

      this.setInterColor = (_color) => {
        this.interColor = _color;
      };
      this.getInterColor = () => {
        return this.interColor;
      };
      this.setInterTerm = (val) => {
        this.interTerm = val;
      };
      this.getInterTerm = () => {
        return this.interTerm;
      };
    }
  }

  let dataViewObj = new DataViewObj(_item, planet);

  //dataViewObj.changeTerm(1);
  dataViewObj.update();
  dataViewObj.resetColor();

  window.viewer.scene.scene.add(planet);

  return dataViewObj;
}

export const drawThreeGeoJSON = function (data, rtnGeom, callback, _color) {
  rtnGeom = new THREE.Object3D();

  _color = _color ? _color : xitecloud.defaultColor.faceColor;

  //window.drawThreeGeo(json, radius, shape, materalOptions, container)
  //#99ff33
  window.drawThreeGeo(
    data,
    10,
    "line",
    {
      color: _color,
      //0xFF0000,
      //linewidth: 30,
      //trans: xitecloud.Globaltrans,
      side: THREE.DoubleSide,
    },
    rtnGeom
  );

  rtnGeom.applyMatrix(
    new THREE.Matrix4().makeTranslation(
      xitecloud.Globaltrans[0],
      xitecloud.Globaltrans[1],
      xitecloud.Globaltrans[2]
    )
  );

  window.viewer.scene.scene.add(rtnGeom);

  // Add entries to object list in sidebar
  let tree = $("#jstree_scene");
  let parentNode = "other";

  let crop_mesh = tree.jstree(
    "create_node",
    parentNode,
    {
      text: "cross",
      //"icon": '${Potree.resourcePath}/icons/triangle.svg',
      data: rtnGeom,
    },
    "last",
    false,
    false
  );

  tree.jstree(rtnGeom.visible ? "check_node" : "uncheck_node", crop_mesh);

  if (callback) {
    callback(data, rtnGeom);
  }
};

//target load (table geom load )
export const fnLoadTarget = function (_item, dataset) {
  return new Promise((resolve, reject) => {
    if (!_item.f_geometry_tbl_nm) {
      return reject(new Error("target"));
      // return resolve({
      //     'title': '데이터 준비중',
      //     'dbObj': _item,
      //     '_3DObject': {},
      //     'visible': false,
      //     'gbn': 'Layers', //sidebar pannel tab  Layers/Annotations
      //     'group': 'target',
      //     'dataType': 'geojson'
      // });
    } else {
      Axios.get("/api/loadTableGeom", {
        params: {
          target: _item.f_geometry_tbl_nm,
        },
      })
        .then(({ data }) => {
          /**
           * 20200929 김신후
           * server err
           */
          if (data.status && data.status === 500) return reject(new Error("target"));
          /**
           * 20200716 김신후
           * 에러 처리해야할 부분이지만,
           * 유저가 데이터 업로드 이후 전처리, 3D모델, 쿼리연산 등의 이유들로 인해
           * 오류가 발생한 것이기 때문에 데이터 자체는 화면으로 넘김
           */
          if (!data.data.the_geom) return reject(new Error("target"));
          // if (!data.data.the_geom) return resolve({
          //     'title': '데이터 준비중',
          //     'dbObj': _item,
          //     '_3DObject': {},
          //     'visible': false,
          //     'gbn': 'Layers', //sidebar pannel tab  Layers/Annotations
          //     'group': 'target',
          //     'dataType': 'geojson'
          // });

          let _geom = fnMakeLayerAreaGeom(data.data.the_geom, xitecloud.targetColor.faceColor);
          _geom.name = "target_" + _item.f_layer_nm;
          window.viewer.scene.scene.add(_geom);

          dataset._3DObject = _geom;

          return resolve(dataset);
        })
        .catch((error) => console.log(error));
    }
  });
};

export const fnLoadOveray = function (file) {
  return new Promise((resolve, reject) => {
    (async () => {
      if (file.name.indexOf("dxf") > -1) {
        fnLoadDXF(file);
      } else if (file.name.indexOf("ply") > -1) {
        const rtnGeom = fnLoadPLYforOveray(file);
      } else if (
        ["png", "jpg", "jpeg", "dxf", "ply"].filter((img) => file.name.indexOf(img)).length > 0
      ) {
        // return resolve( await fnLoadIMGforOveray(file) );

        return resolve(await fnLoadIMGforOverayAndTransform(file));

        //  return resolve( loadIMGForOverayFromURL() );
      }
      return reject("File Type is Not Supported");
    })();
  });
};

// export const loadIMGForOverayFromURL = function (imageUrl) {

//     imageUrl = '/uploads/data_pcd/29/20200615/pcd_29_20200615_original.png'

//     let rtnGeom = (async () => {
//         let Globaltrans = xitecloud.Globaltrans;
//         const loader = new THREE.ImageLoader(LoaddingManager);

//         let image = await loader.load(imageUrl);

//         var texture = new THREE.CanvasTexture(image);
//         var material = new THREE.MeshBasicMaterial({
//             //  color: 0x0000ff,
//             map: texture
//             , opacity: 0.9
//         });

//         let camera = window.viewer.scene.getActiveCamera();

//         let pPos = new THREE.Vector3(0, 0, 0).applyMatrix4(camera.matrixWorld);
//         let pRight = new THREE.Vector3(600, 0, 0).applyMatrix4(camera.matrixWorld);
//         let pUp = new THREE.Vector3(0, 600, 0).applyMatrix4(camera.matrixWorld);
//         let pTarget = window.viewer.scene.view.getPivot();

//         var geometry = new THREE.BoxBufferGeometry(window.viewer.scene.pointclouds[0].boundingBox.max.x
//             , window.viewer.scene.pointclouds[0].boundingBox.max.y
//             , 0);

//         var cube = new THREE.Mesh(geometry, material);
//         cube.position.set(pTarget.x, pTarget.y, pTarget.z);

//         window.viewer.scene.scene.add(cube);

//         return cube;
//     })();

//     return rtnGeom;
// }

//image load local Object File readAsDataURL 을 통해 base64 변환 texture에서 image
export const fnLoadIMGforOverayAndTransform = function (file) {
  //window.viewer.scene.volumes
  //         position, scale, rotation

  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.addEventListener("error", reject);
    reader.addEventListener(
      "load",
      function (progressEvent) {
        let img = new Image();
        img.src = reader.result;

        let cube = window.viewer.volumeTool.startInsertion({
          type: FlatVolume,
          image: img,
          showVolumeLabel: false,
        });
        cube.addEventListener("drop", (e) => {
          return resolve(e.target);
        });

        // return resolve(cube);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  });
};

//image load list
export const fnLoadIMGforOveray = function (file, option) {
  //window.viewer.scene.volumes
  //         position, scale, rotation
  return new Promise((resolve, reject) => {
    let _rtnGeom;
    let reader = new FileReader();

    reader.addEventListener("error", reject);
    reader.addEventListener(
      "load",
      function (progressEvent) {
        console.time("draw");
        let img = new Image();
        img.src = reader.result;
        // if ( option ) {
        // position: {x: 216168.09296093788, y: 534736.4369888306, z: 185.31005287265626}
        // rotation: {x: 0, y: 0, z: 0}
        // scale: {x: 457.64297091935293, y: 457.64297091935293, z: "357.64297091935293"}
        // __proto__: Object

        // option.position  = { x: , y: , z: }
        // option.rotation = { x: , y: , z: }
        // option.scale = { x: , y: , z: }
        // }

        if (!option) {
          option = {};
          let pTarget = window.viewer.scene.view.getPivot();
          let wp = window.viewer.scene.pointclouds[0]
            .getWorldPosition()
            .applyMatrix4(window.viewer.scene.getActiveCamera().matrixWorldInverse);
          let w = Math.abs(wp.z / 5);

          option.position = new THREE.Vector3(pTarget.x, pTarget.y, pTarget.z);
          option.rotation = new THREE.Vector3(0, 0, 0); //x:0,y:0,z:0
          option.scale = new THREE.Vector3(w, w, w);
        }

        // VOLUME visible
        let volume = new FlatVolume({ type: FlatVolume, image: img, showVolumeLabel: false });
        volume.name = option.name;
        volume.clip = false;

        if (option.rotation.x !== 0) volume.rotateX(option.rotation.x);
        if (option.rotation.y !== 0) volume.rotateY(option.rotation.y);
        if (option.rotation.z !== 0) volume.rotateZ(option.rotation.z);

        volume.scale.set(option.scale.x, option.scale.y, option.scale.z);
        volume.position.set(option.position.x, option.position.y, option.position.z);

        window.viewer.scene.addVolume(volume);
        console.timeEnd("draw");
        return resolve(volume);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  });
};

//ply load local
export const fnLoadPLYforOveray = function (file) {
  return new Promise((resolve, reject) => {
    (async () => {
      //const fileContent = await file.text();
      const fileContent = await file.arrayBuffer();
      var plyLoader = new THREE.PLYLoader();

      let geometry = plyLoader.parse(fileContent);
      geometry.computeVertexNormals();
      // geometry.applyMatrix(new THREE.Matrix4().makeTranslation(Globaltrans[0], Globaltrans[1], Globaltrans[2]));

      let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
      _option.color = undefined;
      _option.vertexColors = THREE.VertexColors;

      var material = new THREE.MeshStandardMaterial(_option);
      let plyGeom = new THREE.Mesh(geometry, material);
      // plyGeom.name = name;

      window.viewer.scene.scene.add(plyGeom);
      return resolve(plyGeom);
    })().catch(reject);
  });
};

//tif load local
export const fnLoadTIFforOveray = function (file) {
  return new Promise((resolve, reject) => {
    (async () => {
      resolve(new THREE.Object3D());
    })().catch(reject);
  });
};

//DXF load (local html File )
export const fnLoadDXF = function (file) {
  return new Promise((resolve, reject) => {
    (async () => {
      // .text() transforms the file into a stream and then into a string
      const fileContent = await file.text();
      let parser = new DxfParser();
      let data = parser.parseSync(fileContent);

      let con = new ConvertDXFToThree(data);
      con.convert();
      window.viewer.scene.scene.add(con.rtnGeometry);
      //con.rtnGeometry.applyMatrix(new THREE.Matrix4().makeTranslation(0, 0, xitecloud.bore_zmin));
      return resolve(con.rtnGeometry);
      /*
            // .stream() returns a ReadableStream
            const fileContentStream = await file.stream();
            console.log(await streamToText(fileContentStream));
            // logs "File content!"
          
            const buffer = await file.arrayBuffer();
            console.log(bufferToText(buffer))
            // logs "File content!"
          
            // .slice() allows you to get slices of the file here we take a slice of the entire file
            const fileSliceBlob = file.slice(0, file.length);
            // we convert to blob to a stream
            const fileSliceBlobStream = await fileSliceBlob.stream();
            console.log(await streamToText(fileSliceBlobStream));
            // logs "File content!"
          */
    })().catch(reject);
  });

  // We just use this function to convert streams to text
  const streamToText = async (blob) => {
    const readableStream = await blob.getReader();
    const chunk = await readableStream.read();
    return new TextDecoder("utf-8").decode(chunk.value);
  };

  // Not the best way to get text from a file!
  const bufferToText = (buffer) => {
    const bufferByteLength = buffer.byteLength;
    const bufferUint8Array = new Uint8Array(buffer, 0, bufferByteLength);
    return new TextDecoder().decode(bufferUint8Array);
  };
};

//load dxf file with path (url)
// export const fnLoadDXFLocalPath = function (path) {

//     function readTextFile(file)
//     {
//         var rawFile = new XMLHttpRequest();
//         rawFile.open("GET", file, false);
//         rawFile.onreadystatechange = function ()
//         {
//             if(rawFile.readyState === 4)
//             {
//                 if(rawFile.status === 200 || rawFile.status == 0)
//                 {
//                     var allText = rawFile.responseText;

//                     let parser = new DxfParser();
//                     let data = parser.parseSync(allText);
//                     let con = new ConvertDXFToThree(data, xitecloud.textGeoOption.font);

//                     let objThree = con.convert()
//                     window.viewer.scene.scene.add(con.rtnGeometry)

//                 }
//             }
//         }
//         rawFile.send(null);
//     }

//     readTextFile(path);
// }

export const fnAddAnnotation = function (
  _position,
  _title,
  { classNames, customHighlighted, customCallback }
) {
  var centroid = new THREE.Vector3();
  for (let i = 0; i <= _position.length - 1; i++) {
    let point = _position[i];
    centroid.add(point.position);
  }
  centroid.divideScalar(_position.length);
  let _anotation = new Annotation({
    position: [centroid.x, centroid.y, centroid.z],
    title: _title,
    customHighlighted,
    classNames,
    customCallback,
  });

  window.viewer.scene.annotations.add(_anotation);

  return _anotation;
};

export const fnMakeMeshGeom = function (rtnGeom, data, _color, _trans) {
  let arrVertices = [];
  let arrColors = [];

  _color = _color ? _color : xitecloud._color.na;

  _trans = _trans ? _trans : [0, 0, 0];

  let geometry = new THREE.BufferGeometry();

  for (var _i = 0; _i < data.length; _i++) {
    for (var _vet = 0; _vet < data[_i].geometry.coordinates[0].length; _vet++) {
      arrVertices.push(data[_i].geometry.coordinates[0][_vet][0]);
      arrVertices.push(data[_i].geometry.coordinates[0][_vet][1]);
      arrVertices.push(data[_i].geometry.coordinates[0][_vet][2]);

      arrColors.push(_color[0]);
      arrColors.push(_color[1]);
      arrColors.push(_color[2]);
    }
  }

  var vertices = new Float32Array(arrVertices);
  geometry.addAttribute("position", new THREE.BufferAttribute(vertices, 3));
  var colors = new Uint8Array(arrColors);
  geometry.addAttribute("color", new THREE.BufferAttribute(colors, 3, true));

  let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
  _option.vertexColors = THREE.VertexColors;

  var material = new THREE.MeshBasicMaterial(_option);

  let Globaltrans = xitecloud.Globaltrans;

  //pointcloud z 만큼 더 하기
  Globaltrans[2] = window.viewer.scene.pointclouds[0].boundingBox.max.z;

  if (Globaltrans && Globaltrans.length == 3)
    geometry.applyMatrix(
      new THREE.Matrix4().makeTranslation(
        Globaltrans[0] + _trans[0],
        Globaltrans[1] + _trans[1],
        Globaltrans[2] + _trans[2]
      )
    );

  //if (xitecloud.Globaltrans && xitecloud.Globaltrans.length == 3)
  //    geometry.applyMatrix(new THREE.Matrix4().makeTranslation(xitecloud.Globaltrans[0]+_trans[0], xitecloud.Globaltrans[1]+_trans[1], xitecloud.Globaltrans[2])+_trans[2]);

  rtnGeom = new THREE.Mesh(geometry, material);

  window.viewer.scene.scene.add(rtnGeom);

  return rtnGeom;
};

export const makeParamPoints = (_measure) => {
  let _paramPoints = "";
  let _trancePosition;

  //모델 flyrock에 따른 z값 조정 여부
  if (window.xitecloud.GFlyrocklayer) {
    _trancePosition = [0, 0, window.xitecloud.bore_zmin];
  } else {
    _trancePosition = [0, 0, 0];
  }

  //potree measrue
  if (_measure.points instanceof Array) {
    for (let _points of _measure.points) {
      _paramPoints += `${_points.position.x - _trancePosition[0]},${
        _points.position.y - _trancePosition[1]
      },${_points.position.z - _trancePosition[2]}|`;
    }
  }
  //potree annotation
  else {
    _paramPoints += `${_measure.position.x - _trancePosition[0]},${
      _measure.position.y - _trancePosition[1]
    },${_measure.position.z - _trancePosition[2]}|`;
  }
  return _paramPoints;
};

export const fnMakeParamFromMeasure = function (measure, _ynClose) {
  _ynClose = _ynClose ? _ynClose : "true";

  var param = "";

  if (measure && measure.points.length > 2) {
    var param = "";

    for (var tmpi = 0; tmpi < measure.points.length; tmpi++) {
      if (tmpi != 0) param += ",";
      param +=
        measure.points[tmpi].position.x +
        " " +
        measure.points[tmpi].position.y +
        " " +
        measure.points[tmpi].position.z +
        " ";
    }

    if (_ynClose) {
      param +=
        ", " +
        measure.points[0].position.x +
        " " +
        measure.points[0].position.y +
        " " +
        measure.points[0].position.z +
        " ";
    }
  }

  return param;
};

export const fnMakePopParamFromMeasure = function (measure, _ynClose) {
  _ynClose = _ynClose ? _ynClose : "true";

  var param = "";

  if (measure.points.length > 2) {
    var param = "";

    for (var tmpi = 0; tmpi < measure.points.length; tmpi++) {
      if (tmpi != 0) param += ",";
      param +=
        measure.points[tmpi].position.x +
        " " +
        measure.points[tmpi].position.y +
        " " +
        measure.points[tmpi].position.z +
        " ";
    }

    if (_ynClose) {
      param +=
        ", " +
        measure.points[0].position.x +
        " " +
        measure.points[0].position.y +
        " " +
        measure.points[0].position.z +
        " ";
    }
  }

  return param;
};

//계산 대상 사전 확인
export const fnPreCalc = function (param, xitecloudViewDataSet, _callBack, _cancelCallbak) {
  // Polgon Area에서 호출시 파라미터 누락으로 임시 처리
  if (param.targetLayer == "" || param.targetLayer == undefined) {
    param.targetLayer = xitecloudViewDataSet.layer.target[0].dbObj;
  }

  if (param.boundryLayer == "" || param.boundryLayer == undefined) {
    param.boundryLayer = xitecloudViewDataSet.layer.target[0].dbObj;
  }

  let objParamPre = {
    srid: param.srid,
    points: param.points,
    topoLayer: param.topoLayer.f_ply_geom_tbl_nm,
    targetLayer: param.targetLayer.f_geometry_tbl_nm,
    targetBoundUse: param.targetBoundUse,
    boundryLayer: param.boundryLayer.f_geometry_tbl_nm,
  };

  Axios.get("/api/preCalc", {
    params: objParamPre,
  })
    .then(({ data }) => {
      if (_callBack) _callBack(data);
    })
    .catch((error) => console.log(error));
};

export const fnBGCalc = (param, xitecloudViewDataSet, _callBack, _cancelCallbak) => {
  return new Promise((resolve, reject) => {
    const state = store.getState();
    // Polgon Area에서 호출시 파라미터 누락으로 임시 처리
    if (param.targetLayer === "" || param.targetLayer === undefined) {
      param.targetLayer = xitecloudViewDataSet.layer.target[0].dbObj;
    }

    if (param.boundryLayer === "" || param.boundryLayer === undefined) {
      param.boundryLayer = xitecloudViewDataSet.layer.target[0].dbObj;
    }

    let objParamPre = {
      srid: param.srid,
      points: param.points,
      // "topoLayer": param.topoLayer.f_ply_geom_tbl_nm,
      topoLayer: `layer_${state.currentProjectReducer.currentProject.project_mng_sq}_${state.currentProjectReducer.selectedDate}_original`,

      targetLayer: param.targetLayer.f_geometry_tbl_nm,
      targetBoundUse: param.targetBoundUse,
      boundryLayer: param.boundryLayer.f_geometry_tbl_nm,
      gbnFitPlan: param.gbnFitPlan,
    };

    Axios.get("/api/BGCalc", {
      params: objParamPre,
    })
      .then(({ data }) => {
        fnLoadBGCalc(data.fnbgcalc_fit, objParamPre).then((returnData) => {
          resolve({ _3dData: returnData, calVolume: data.fnbgcalc_fit });
        });
      })
      .catch((error) => {
        console.log(error);
        message.warning(error);
      });
  });
};

/* 저장된 볼륨 결과 Load */
const fnLoadBGCalc = (data, org_data) => {
  return new Promise((resolve, reject) => {
    // data 확인
    if (data === undefined) reject();

    /**
     * (20240126) 계획모델(Target) 선택 여부에 따른 변수 (메시징, PLY 로드 여부 판별)
     * (20240404) 사용자 설정 영역 선택 여부에 따른 변수(targetBoundUse) 조건 추가("custom")
     * (org_data.targetBoundUse - "true": 계획모델(Target), "false": 사용자 설정 + 계획모델 고도, "custom": 사용자 설정 + 최저점/최고점/지정고도)
     */
    const isLoadPlyTargetBound = org_data.targetBoundUse
      ? org_data.targetBoundUse === "false" || org_data.targetBoundUse === "custom"
        ? true
        : false
      : true; // 실시간이 아닌 분석("저장") 결과 표시할 때 (Annotation)

    /**
     * (20240126) PLY 로드 및 매핑 등 진행조건 설정 변수
     *  - 결과 Data 존재
     *  - isLoadPlyTargetBound true
     *  - 절토 및 성토량이 4,000,000 입방미터 미만 (기준 변수: xitecloud.max3DVolModelVal)
     *  - PLY 파일 크기 200MB 미만 (기준 변수: xitecloud.max3DVolModelPlySize)
     */
    const isProgressLoad =
      data.length > 0 &&
      isLoadPlyTargetBound &&
      data.filter(
        (item) => item.cut > xitecloud.max3DVolModelVal || item.fill > xitecloud.max3DVolModelVal
      ).length === 0 &&
      data.filter((item) => item?.ply_file_size > xitecloud.max3DVolModelPlySize).length === 0;

    var cntGeom = new THREE.Object3D();
    cntGeom.name = "vol_BG_ply";

    let totalVol = {
      total_cut: 0,
      total_fill: 0,
      cnt_proc_layer: 0,
      cnt_layer: data.length,
      layer_info: [],
      center: new THREE.Vector3(),
      min_z: null,
      max_z: null,
    };

    // (20240126) 분석 결과에 따른 메시지 구분 출력 (handleCompleteLoad 함수 내부에서 작동)
    const getMessage = () => {
      if (
        data.filter(
          (item) => item.cut > xitecloud.max3DVolModelVal || item.fill > xitecloud.max3DVolModelVal
        ).length > 0 &&
        data.filter((item) => item?.ply_file_size > xitecloud.max3DVolModelPlySize).length > 0
      ) {
        message.warning(i18next.t("message$Cannot_load_3d_model_volume_ply"));
        return;
      } else if (
        data.filter(
          (item) => item.cut > xitecloud.max3DVolModelVal || item.fill > xitecloud.max3DVolModelVal
        ).length > 0
      ) {
        // 절성토량(cut/fill)
        message.warning(i18next.t("message$Cannot_load_3d_model_volume"));
        return;
      } else if (
        data.filter((item) => item?.ply_file_size > xitecloud.max3DVolModelPlySize).length > 0
      ) {
        // 파일(ply) 크기
        message.warning(i18next.t("message$Cannot_load_3d_model_ply"));
        return;
      }
    };

    let handleCompleteLoad = () => {
      if (totalVol.cnt_layer !== 1) totalVol.center.divideScalar(totalVol.cnt_layer - 1);

      if (isProgressLoad) {
        let arrTxt = data
          .map((item) => {
            return `<br/> ${item.f_layer_nm} (
                        Cut Volume : ${addCommas(item.cut.toFixed(2), "V")}
                        Fill Volume : ${addCommas(item.fill.toFixed(2), "V")}
                    )`;
          })
          .join(" ");

        let txtResult = "";

        txtResult += arrTxt;
        let arrCenter = new THREE.Box3().setFromObject(cntGeom).getCenter().toArray();

        // (20211008) Annotation이 블록을 가려서 위치 수정
        arrCenter[0] = arrCenter[0] + 200;
        let _txt_Annotation = new Annotation({
          position: arrCenter,
          title: txtResult,
        });

        _txt_Annotation.name = "txt_vol_BG";
        fnApplyTrans(_txt_Annotation, [0, 0, xitecloud.bore_zmin]);
        fnApplyTrans(cntGeom, [0, 0, xitecloud.bore_zmin]);

        window.viewer.scene.scene.add(cntGeom);
        window.viewer.scene.annotations.add(_txt_Annotation);

        resolve({ _3DObject: cntGeom, annotation: _txt_Annotation });
      } else {
        resolve({ _3DObject: cntGeom, annotation: null });
        getMessage(data);
      }
    };

    if (isProgressLoad) {
      // eslint-disable-next-line array-callback-return
      data.map((item) => {
        let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);

        // eslint-disable-next-line array-callback-return
        if (data.length !== 1 && item.rock_sq === 0) return;

        _option.color = xitecloud.ArrColor[item.rock_sq - 1];
        // _option.color = undefined;
        // _option.vertexColors= true;

        let Globaltrans = xitecloud.Globaltrans;

        var loader = new THREE.PLYLoader(LoaddingManager);

        const onLoaded = (geometry) => {
          geometry.computeBoundingBox();
          geometry.computeVertexNormals();

          if (Globaltrans && Globaltrans.length === 3)
            geometry.applyMatrix(
              new THREE.Matrix4().makeTranslation(Globaltrans[0], Globaltrans[1], Globaltrans[2])
            );

          let plyGeom;
          {
            console.log(item.f_layer_nm);
            let material = new THREE.MeshStandardMaterial(_option);
            plyGeom = new THREE.Mesh(geometry, material);
            plyGeom.name = `${item.f_layer_nm}`;

            //totalVol.min_z = (totalVol.min_z && totalVol.min_z > )

            totalVol.max_z = totalVol.max_z ? totalVol.max_z : geometry.boundingBox.getCenter().z;
            totalVol.min_z = totalVol.min_z ? totalVol.min_z : geometry.boundingBox.getCenter().z;

            totalVol.max_z =
              totalVol.max_z > geometry.boundingBox.getCenter().z
                ? geometry.boundingBox.getCenter().z
                : totalVol.max_z;
            totalVol.min_z =
              totalVol.min_z > geometry.boundingBox.getCenter().z
                ? geometry.boundingBox.getCenter().z
                : totalVol.min_z;

            //totalVol.center.add( _ = geometry.boundingBox.getCenter());
            totalVol.center = geometry.boundingBox.getCenter();
          }

          cntGeom.add(plyGeom);

          // 0 index 제외
          if (totalVol.cnt_layer - 1 === ++totalVol.cnt_proc_layer) {
            handleCompleteLoad();
          } else if (data.length === 1) {
            handleCompleteLoad();
          }
        };

        const onProgress = () => {
          // resolve();
        };
        const onError = (err) => {
          // console.log(arguments, 'err')
          totalVol.cnt_proc_layer++;

          // 0 index 제외
          if (totalVol.cnt_layer - 1 === ++totalVol.cnt_proc_layer) {
            handleCompleteLoad();
          }
        };

        /*
         * PLY 파일명 30자 미만 이상이면 분석 결과 ("저장" 버튼)
         * 30자 이상은 실시간 분석
         */
        try {
          /* if (
            data.filter((item) => item.cut === 0 && item.fill === 0).length > 0 ||
            data.filter((item) => item.ply_file_size === 0).length > 0
          ) {
            // 절성토량 0 또는 PLY 파일크기 0
            message.warning("Cut/Fill: 0");
          } else */ if (item.f_ply_file_name.length < 30) {
            let file = `/${item.project_mng_sq_t_project_mng}/${item.f_input_date}/volumn/${item.id}.ply`;
            loader.load(`/uploads/data_pcd${file}`, onLoaded, onProgress, onError);
          } else {
            loader.load(`/uploads/data_pcd${item.f_ply_file_name}`, onLoaded, onProgress, onError);
          }
        } catch (e) {
          console.error(e);
        }
      });
    } else {
      handleCompleteLoad();
    }

    // resolve
    // return {
    //     '_3DObject' : cntGeom,
    //     'annotation' : _txt_Annotation
    // };
  });
};

export const fnLoadGeomVolumeBGResult = async (_item, data) => {
  let grpRtnGeom = new THREE.Group();
  data.potreeAnnotation = [];
  grpRtnGeom.name = "loadgeom_volume_" + _item.annotation_mng_sq;

  /* bgcalc 전환 데이터셋 변경으로 기존과 맞추기 위해 재 배열함 [전종수 2021.08.03] */

  data.fnbgcalc = data.f_result.fnbgcalc;
  data.f_result = [];

  fnLoadBGCalc(data.fnbgcalc, data).then((rtn) => {
    if (rtn) {
      const { _3DObject, annotation } = rtn;
      data.potreeAnnotation.push(annotation);
      data._3DObject = _3DObject;

      const _resultArr = data.fnbgcalc.map((item) => {
        return {
          idx: item.rock_sq,
          layer_sq: item.id,
          geom_tbl_nm: `pcd_${item.project_mng_sq_t_project_mng}_${item.f_input_date}_${item.rock_sq}`,
          nxt_geom_tbl_nm: item.f_ply_file_name_org,
          r_result: {
            area: 0,
            job_end: item.create_dt,
            line_geom_cut: null,
            line_geom_fill: null,
            src_poly: [],
            target_poly: [],
            vol_cut: item.cut,
            vol_fill: item.fill,
          },
          rock_type: item.rock_layer_nm,
          srcname: item.f_input_date,
        };
      });

      data.f_result = _resultArr;
    }
  });
};

/* Volume calc call */
export const fnVolumeGeomLoad = (viewData, ynLoadGeom) => {
  let SRID = window.xitecloud.viewDataSet.project.f_epsg;

  let srcLayers = [];

  let pcdTopoItem = window.xitecloud.viewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  );

  if (!pcdTopoItem) {
    return window.alert("No PointCloud");
  }

  srcLayers.push({
    gbn: "topo",
    item: pcdTopoItem.dbObj,
  });

  //멀티콤보 선택값 저장 방식 변경 [전종수 2020.03.17]
  //viewData.toolObj.value = 'a2|BOUNDRYALL';

  //let _toolObjValue =  viewData.toolObj.value.split('|');

  let targetLayer = window.xitecloud.viewDataSet.layer.target[0].dbObj;

  let measure = viewData.measure;
  let _targetBoundUse = false;
  let boundryLayer = window.xitecloud.viewDataSet.layer.target[0].dbObj;

  if (window.xitecloud.viewDataSet.layer.target.length === 0) {
    return alert("No target Layers!!");
  }

  if (_targetBoundUse || measure.points.length > 2) {
    var param = fnMakeParamFromMeasure(measure, true);

    let objParamPre = {
      srid: SRID,
      points: param,
      topoLayer: pcdTopoItem.dbObj,
      targetLayer: targetLayer,
      targetBoundUse: _targetBoundUse,
      boundryLayer: boundryLayer,
    };

    const _callback = (_result) => {
      let result = _result.fnprecalc.r_result_array;
      let srcLayers = _result.fnprecalc.r_result_layer_array;

      if (measure == null) {
        measure = new Measure();

        let _points = result[0].target_boundry.split("((")[1].replace("))", "").split(",");

        for (let _pt of _points) {
          measure.addMarker(
            new THREE.Vector3(
              Number(_pt.split(" ")[0]),
              Number(_pt.split(" ")[1]),
              xitecloud.bore_zmin
            )
          );
        }
      }

      let _tmpObj = {
        area: Number(result[0].param_area).toFixed(2),
        "Layer Count :": srcLayers.length,
        sectorCnt: result.length,
        avg_area: Number(result[0].area_avg).toFixed(2),
      };

      let _messageStr = `Selected Area: ${addCommas(_tmpObj.area, "A")} 
Divide Sector Count: ${_tmpObj.sectorCnt} (Average ${addCommas(_tmpObj.avg_area, "A")})
Calculate few Minuates 
Continue?`;

      let _tmp = window.confirm(_messageStr);
      let rtnGeom = {};

      const objParam = {
        srid: SRID,
        srcLayer: srcLayers,
        targetLayer: targetLayer,
        points: param,
        sectors: result,
        measure: measure,
        viewData: viewData,
        targetBoundUse: _targetBoundUse,
        boundryLayer: boundryLayer,
      };

      if (_tmp) {
        fnVolumeGeomLoadProc(objParam);
      } else {
        fnCalcVolumeJob(rtnGeom, objParam);

        viewData.measure.visible = false;
        viewData.measure.dispose();
      }
    };

    let _cancelCallbak = () => {};

    fnPreCalc(objParamPre, _callback, _cancelCallbak);
  }
};

export const fnVolumeGeomLoadProc = (objParam) => {
  var rtnGeom = {};
  let _callback = (data) => {
    window.xitecloud.viewDataSet.annotations.analytics.push(data.viewData);
    window.xitecloud.updateLayerListInComponent();
  };

  fnCalcVolume(rtnGeom, objParam, _callback);
};

/* promise single call */
export const fnCalcVolume = (rtnGeom, data, isCustomAltitude, _callback) => {
  if (xitecloud.isProcessing) return alert("Now Processing...");
  xitecloud.isProcessing = true;

  rtnGeom.result = [];

  const result = {};

  //그리기 효과
  xitecloud.loaddingShow = false;
  $(".model-loading-bar").hide();

  let boundaryLayerName = data.boundryLayer.f_geometry_tbl_nm;
  let targetBoundUse = data.targetBoundUse;

  var arrLayergeom = [];
  var arrLayerAnnotaion = [];
  var arrResult = [];

  let _completeCnt = 0;
  let _errorCnt = 0;

  let totalArea = 0;
  let totalVolume = 0;
  let totalVolumeCut = 0;
  let totalVolumeFill = 0;

  /**
   * grep center of measure
   */
  let _gCenter = new THREE.Geometry();
  _gCenter.vertices.push(...data.measure.points.map((a) => a.position));
  _gCenter.computeBoundingSphere();
  //_gCenter.boundingSphere.center.boundingSphere.center.toArray();

  const srcLength = isCustomAltitude ? 1 : data.srcLayer.length;
  /**
   * first annotation
   */
  let _progressAnnotation = new Annotation({
    position: _gCenter.boundingSphere.center.toArray(),
    title: `Calculate Volume Layers (${srcLength}) Ready`,
  });

  _progressAnnotation.srcLayerCount = srcLength;
  _progressAnnotation.sectorCount = data.sectors.length;
  _progressAnnotation.completeLayerCount = 0;
  _progressAnnotation.completeSectorCount = 0;

  window.viewer.scene.annotations.add(_progressAnnotation);

  /**
   * [ pcd, rocks, target ]
   * add target object
   */
  const srcLayerName = [].concat(isCustomAltitude ? [data.srcLayer[0]] : data.srcLayer);
  srcLayerName.push({
    f_input_date: data.targetLayer.f_input_date,
    f_layer_nm: data.targetLayer.f_layer_nm,
    geom_tbl_nm: data.targetLayer.f_geometry_tbl_nm,
    project_mng_sq_t_project_mng: data.targetLayer.project_mng_sq_t_project_mng,
  });

  const _layerLoadedCallback = function (_inidxlayer, grpRtnGeomSec, annotationTitleArr) {
    let _maxZ = 0;
    let _minZ = 0;
    let layerArea = 0;
    let layerVolume = 0;
    let layerVolumeCut = 0;
    let layerVolumeFill = 0;

    let _secCenter = new THREE.Vector3();

    //각 섹터물량에서 레이어 물량 계산(타겟)
    for (var _idx = 0; _idx < grpRtnGeomSec.children.length; _idx++) {
      layerArea += Number(grpRtnGeomSec.children[_idx].calc.area); //area
      layerVolume += Number(grpRtnGeomSec.children[_idx].calc.vol); //volume
      layerVolumeCut += Number(grpRtnGeomSec.children[_idx].calc.vol_cut); //volume
      layerVolumeFill += Number(grpRtnGeomSec.children[_idx].calc.vol_fill); //volume

      grpRtnGeomSec.children[_idx].geometry.computeBoundingSphere();

      _secCenter.add(grpRtnGeomSec.children[_idx].geometry.boundingSphere.center);
    }
    _secCenter.divideScalar(grpRtnGeomSec.children.length);

    //source layer topo 추가로 암층 명은 +1 하지만 인데스가 하나 증가해 있으므로 그냥 idx

    let _layerName = srcLayerName[_inidxlayer].f_layer_nm;

    let _layerResultObj = {
      layerName: _layerName,
      idx: _inidxlayer,
      layergeom: grpRtnGeomSec.clone(),
      secCenter: _secCenter.clone(),

      target_cut: layerVolumeCut,
      target_fill: layerVolumeFill,
      cut: 0,
      fill: 0,
      net: 0, //순토량
    };

    arrResult[_inidxlayer] = _layerResultObj;
    //현재(20200515)물량 계산은 각 레이어 타겟 물량임으로 전층의 물량은 이전 결과에서 현재 물량을 차감한 값이다
    //이번계산으로 전층 물량 결정 레이어가 하나일경우(타겟 까지 2 개) custom fit plan
    if (_inidxlayer !== 0) {
      let _preLayerResultObj = arrResult[_inidxlayer - 1];

      _preLayerResultObj.cut = _preLayerResultObj.target_cut - layerVolumeCut + layerVolumeFill;
      _preLayerResultObj.fill -= layerVolumeFill;
      _preLayerResultObj.net = _preLayerResultObj.target_cut - _preLayerResultObj.fill;

      //layer voume annotation
      // let aActions = new Annotation({
      //     position: [_preLayerResultObj.secCenter.x, _preLayerResultObj.secCenter.y, _preLayerResultObj.secCenter.z],
      //     title: _layerName + "\n Cut Volume : " + addCommas((_preLayerResultObj.cut).toFixed(2), 'V')
      //         + "\n Fill Volume : " + addCommas((_preLayerResultObj.fill).toFixed(2), 'V')
      // });

      annotationTitleArr.push(`
                <br/> ${_layerName} (
                    Cut Volume : ${addCommas(_preLayerResultObj.cut.toFixed(2), "V")}
                    Fill Volume : ${addCommas(_preLayerResultObj.fill.toFixed(2), "V")}
                )
                <br/>
            `);

      result[_layerName] = {
        cut: addCommas(_preLayerResultObj.cut.toFixed(2), "V"),
        fill: addCommas(_preLayerResultObj.fill.toFixed(2), "V"),
      };

      _maxZ = _maxZ > _secCenter.z ? _maxZ : _secCenter.z;
      _minZ = _minZ > _secCenter.z ? _secCenter.z : _minZ;
      // aActions.name = _inidxlayer + "layerVolumeAnnotation";

      // grpRtnGeomSec.add(aActions);
      // arrLayerAnnotaion.push(aActions);

      // window.viewer.scene.annotations.add(aActions);

      //totalArea += layerArea;
      //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
      totalVolumeCut += _preLayerResultObj.cut;
      totalVolumeFill += _preLayerResultObj.fill;
    } else if (srcLayerName.length === 2) {
      _layerResultObj.cut = _layerResultObj.target_cut;
      _layerResultObj.fill = _layerResultObj.target_fill;
      _layerResultObj.net = _layerResultObj.target_cut - _layerResultObj.target_fill;

      //layer voume annotation
      // let aActions = new Annotation({
      //     position: [_layerResultObj.secCenter.x, _layerResultObj.secCenter.y, _layerResultObj.secCenter.z],
      //     title: _layerName + "\n Cut Volume : " + addCommas((_layerResultObj.cut).toFixed(2), 'V')
      //         + "\n Fill Volume : " + addCommas((_layerResultObj.fill).toFixed(2), 'V')
      // });

      annotationTitleArr.push(`
                <br/> ${_layerName} (
                    Cut Volume : ${addCommas(_layerResultObj.cut.toFixed(2), "V")}
                    Fill Volume : ${addCommas(_layerResultObj.fill.toFixed(2), "V")}
                    )
                <br/>
            `);

      result[_layerName] = {
        cut: addCommas(_layerResultObj.cut.toFixed(2), "V"),
        fill: addCommas(_layerResultObj.fill.toFixed(2), "V"),
      };

      _maxZ = _maxZ > _secCenter.z ? _maxZ : _secCenter.z;
      _minZ = _minZ > _secCenter.z ? _secCenter.z : _minZ;
      // aActions.name = _inidxlayer + "layerVolumeAnnotation";

      // grpRtnGeomSec.add(aActions);
      // arrLayerAnnotaion.push(aActions);

      // window.viewer.scene.annotations.add(aActions);

      //totalArea += layerArea;
      //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
      totalVolumeCut += _layerResultObj.cut;
      totalVolumeFill += _layerResultObj.fill;
    }

    //결과 리턴용
    rtnGeom.result.push(_layerResultObj);
    // arrResult.push(_layerResultObj);

    _completeCnt++;
    _progressAnnotation.completeLayerCount++;
    _progressAnnotation.completeSectorCount = 0;

    _progressAnnotation["title"] = `Calculate Volume Layers (${srcLength})`;

    grpRtnGeomSec.visible = true;
    //layer total voume annotation
    if (_completeCnt === srcLayerName.length - 1) {
      arrLayergeom[0].children[1].geometry.computeBoundingBox();

      let title = `TOTAL ( Cut Volume : ${addCommas(
        totalVolumeCut.toFixed(2),
        "V"
      )} Fill Volume : ${addCommas(totalVolumeFill.toFixed(2), "V")}) <br/>.
            `;

      result["total"] = {
        cut: addCommas(totalVolumeCut.toFixed(2), "V"),
        fill: addCommas(totalVolumeFill.toFixed(2), "V"),
      };

      title += annotationTitleArr.join();
      let bActions = new Annotation({
        position: [
          _secCenter.x,
          _secCenter.y,
          arrLayergeom[0].children[1].geometry.boundingBox.max.z,
        ],
        title,
      });

      bActions.name = "totalVolumeAnnotation";
      grpRtnGeomSec.add(bActions);
      window.viewer.scene.annotations.add(bActions);

      data.viewData._3DObject = arrLayergeom;
      data.calVolResult = arrResult;

      arrLayerAnnotaion.push(bActions);

      data.viewData.potreeAnnotation = arrLayerAnnotaion;

      grpRtnGeomSec.visible = true;
      _progressAnnotation.visible = false;
      _progressAnnotation.dispose();

      xitecloud.isProcessing = false;
      $(".model-loading-bar").show();

      _callback(data, result);
    }
  };

  /**
   *
   * @param {:object} _srcLayer
   *      iterable element
   * @param {:number} _idxLayer
   *      iterable index
   */
  function realTimeDraw(_srcLayer, _idxLayer) {
    let secCompleteCnt = 0;
    //분석 대상이 한개인 경우 루프를 위해 타겟을 넣어 줌 [전종수 20200514]
    let _targetLayerName =
      srcLayerName.length === 1
        ? data.targetLayer.f_geometry_tbl_nm
        : srcLayerName[_idxLayer + 1].geom_tbl_nm;
    const grpRtnGeomSec = new THREE.Group();
    grpRtnGeomSec.name = grpRtnGeomSec.uuid + "_volume_" + _srcLayer.geom_tbl_nm;

    //그리는거 보여줄때 주석
    //grpRtnGeomSec.visible = false;

    //layer geom
    arrLayergeom.push(grpRtnGeomSec);
    window.viewer.scene.scene.add(grpRtnGeomSec);

    /**
     * first request start count
     */
    const sliceLength = 5;
    let progressArr = data.sectors.slice(0, sliceLength);
    let i = sliceLength;

    progressArr.map((x) =>
      getSampleMesh(x)
        .then(getSampleMeshCallback)
        .catch((err) => {
          console.error(err);
          getSampleMesh(x).then(getSampleMeshCallback);
        })
    );

    function getSampleMeshCallback(calcRows) {
      if (calcRows.data.src_poly && calcRows.data.target_poly) {
        let rtnGeom = fnMakeLayerVolumeGeom(calcRows.data, _idxLayer, [
          0,
          0,
          Math.abs(window.xitecloud.bore_zmin),
        ]);

        rtnGeom.name = "sec" + secCompleteCnt;
        rtnGeom.calc = calcRows.data;
        grpRtnGeomSec.add(rtnGeom);
      }

      _progressAnnotation["title"] = `Calculate Volume Layers (${srcLength})
                Progress  ( ${(
                  ((++_progressAnnotation.completeSectorCount / _progressAnnotation.sectorCount) *
                    100) /
                  srcLength
                ).toFixed(2)} % )`;

      /**
       * layer last sector
       */
      if (data.sectors.length === ++secCompleteCnt) {
        // _layerLoadedCallback(_idxLayer);
        temp.push({
          index: _idxLayer,
          object: grpRtnGeomSec,
        });

        if (temp.length === srcLength) {
          const sortedTemp = _.sortBy(temp, ["index"]);
          const annotationTitleArr = [];
          sortedTemp.map((grpRtnGeomSecItem) => {
            const { index, object } = grpRtnGeomSecItem;
            _layerLoadedCallback(index, object, annotationTitleArr);
          });
          // _layerLoadedCallback()
          return (xitecloud.loaddingShow = true);
        }
      } else if (i < data.sectors.length) {
        getSampleMesh(data.sectors[i])
          .then(getSampleMeshCallback)
          .catch((err) => {
            _errorCnt++;
            console.log(err);
            if (data.sectors[i]) {
              getSampleMesh(data.sectors[i]).then(getSampleMeshCallback);
            }
          });
        i++;
      }
    }

    async function getSampleMesh(sector) {
      return await Axios.get("/api/calcVoumeSampleMeshGeom", {
        params: {
          srcLayer: _srcLayer.geom_tbl_nm,
          targetLayer: _targetLayerName,
          boundaryLayer: boundaryLayerName,
          targetBoundUse: targetBoundUse == "true" ? "false" : targetBoundUse,
          srid: data.srid,
          points: sector.sector_geom_t
            .replace("POLYGON", "")
            .replace("Z", "")
            .replace("((", "")
            .replace("))", "")
            .split(",")
            .join(","),
        },
        timeout: 5 * 60 * 1000,
        maxRedirects: 0,
      });
    }
  }

  console.log(rtnGeom, data, _callback);
  const temp = [];
  setTimeout(() => {
    isCustomAltitude ? realTimeDraw(data.srcLayer[0], 0) : data.srcLayer.map(realTimeDraw);
  }, 0);
};

/* promise single call */
// export const fnCalcVolume = function (rtnGeom, data, _callback) {

//     if (xitecloud.isProcessing) {

//         alert('Now Processing...');
//         return;

//     }

//     xitecloud.isProcessing = true;

//     rtnGeom.result = [];

//     //그리기 효과
//     xitecloud.loaddingShow = false;
//     $('.model-loading-bar').hide();

//     let srcLayerName = data.srcLayer;

//     let boundaryLayerName = data.boundryLayer.f_geometry_tbl_nm;
//     let targetBoundUse = data.targetBoundUse;

//     var arrLayergeom = [];
//     var arrLayerAnnotaion = [];
//     var arrResult = [];

//     let _completeCnt = 0;
//     let _errorCnt = 0;

//     let totalArea = 0;
//     let totalVolume = 0;
//     let totalVolumeCut = 0;
//     let totalVolumeFill = 0;

//     let _gCenter = new THREE.Geometry();
//     _gCenter.vertices.push(...data.measure.points.map(a => { return a.position }));

//     _gCenter.computeBoundingSphere();
//     //_gCenter.boundingSphere.center.boundingSphere.center.toArray();

//     let _progressAnnotation = new Annotation({
//         position: _gCenter.boundingSphere.center.toArray(),
//         title: `Calculate Volume Layers ( 0 / ${data.srcLayer.length} )
//                 ( 0 / ${data.sectors.length})`
//     });

//     _progressAnnotation.srcLayerCount = data.srcLayer.length;
//     _progressAnnotation.sectorCount = data.sectors.length;
//     _progressAnnotation.completeLayerCount = 0;
//     _progressAnnotation.completeSectorCount = 0;

//     window.viewer.scene.annotations.add(_progressAnnotation);

//     srcLayerName.push({
//         "f_input_date": data.targetLayer.f_input_date
//         , "f_layer_nm": data.targetLayer.f_layer_nm
//         , "geom_tbl_nm": data.targetLayer.f_geometry_tbl_nm
//         , "project_mng_sq_t_project_mng": data.targetLayer.project_mng_sq_t_project_mng
//     });

//     (async () => {

//         for (var _idxLayer = 0; _idxLayer < srcLayerName.length - 1; _idxLayer++) {
//             let __progressAnnotation = _progressAnnotation;
//             let _cur_idxLayer = _idxLayer;
//             let _srcLayer = srcLayerName[_idxLayer];

//             let secCompleteCnt = 0;

//             //분석 대상이 한개인 경우 루프를 위해 타겟을 넣어 줌 [전종수 20200514]
//             let _targetLayerName = (srcLayerName.length == 1) ? data.targetLayer.f_geometry_tbl_nm : srcLayerName[_idxLayer + 1].geom_tbl_nm;
//             let _boundaryLayerName = boundaryLayerName;
//             let grpRtnGeomSec = new THREE.Group();
//             grpRtnGeomSec.name = grpRtnGeomSec.uuid + "_volume_" + _srcLayer.geom_tbl_nm;

//             //그리는거 보여줄때 주석
//             //grpRtnGeomSec.visible = false;

//             //layer geom
//             arrLayergeom.push(grpRtnGeomSec);
//             window.viewer.scene.scene.add(grpRtnGeomSec);

//             let _maxZ = 0;
//             let _minZ = 0;

//             let _layerLoadedCallback = function (_inidxlayer) {

//                 let layerArea = 0;
//                 let layerVolume = 0;
//                 let layerVolumeCut = 0;
//                 let layerVolumeFill = 0;

//                 let _secCenter = new THREE.Vector3();

//                 //각 섹터물량에서 레이어 물량 계산(타겟)
//                 for (var _idx = 0; _idx < grpRtnGeomSec.children.length; _idx++) {

//                     layerArea += Number(grpRtnGeomSec.children[_idx].calc.area);  //area
//                     layerVolume += Number(grpRtnGeomSec.children[_idx].calc.vol); //volume
//                     layerVolumeCut += Number(grpRtnGeomSec.children[_idx].calc.vol_cut); //volume
//                     layerVolumeFill += Number(grpRtnGeomSec.children[_idx].calc.vol_fill); //volume

//                     grpRtnGeomSec.children[_idx].geometry.computeBoundingSphere();

//                     _secCenter.add(grpRtnGeomSec.children[_idx].geometry.boundingSphere.center);

//                 }
//                 _secCenter.divideScalar(grpRtnGeomSec.children.length);

//                 //source layer topo 추가로 암층 명은 +1 하지만 인데스가 하나 증가해 있으므로 그냥 idx
//                 let _layerName = srcLayerName[_idxLayer].f_layer_nm;

//                 let _layerResultObj = {
//                     layerName: _layerName
//                     , idx: _inidxlayer
//                     , layergeom: grpRtnGeomSec.clone()
//                     , secCenter: _secCenter.clone()

//                     , target_cut: layerVolumeCut
//                     , target_fill: layerVolumeFill
//                     , cut: 0
//                     , fill: 0
//                     , net: 0  //순토량
//                 };

//                 //현재(20200515)물량 계산은 각 레이어 타겟 물량임으로 전층의 물량은 이전 결과에서 현재 물량을 차감한 값이다
//                 //이번계산으로 전층 물량 결정 레이어가 하나일경우(타겟 까지 2 개) custom fit plan
//                 if (_inidxlayer != 0) {

//                     let _preLayerResultObj = arrResult[_inidxlayer - 1];

//                     _preLayerResultObj.cut = _preLayerResultObj.target_cut - layerVolumeCut + layerVolumeFill;
//                     _preLayerResultObj.fill -= layerVolumeFill;
//                     _preLayerResultObj.net = _preLayerResultObj.target_cut - _preLayerResultObj.fill;

//                     //layer voume annotation
//                     let aActions = new Annotation({
//                         position: [_preLayerResultObj.secCenter.x, _preLayerResultObj.secCenter.y, _preLayerResultObj.secCenter.z],
//                         title: _layerName + "\n Cut Volume : " + addCommas((_preLayerResultObj.cut).toFixed(2), 'V')
//                             + "\n Fill Volume : " + addCommas((_preLayerResultObj.fill).toFixed(2), 'V')
//                     });

//                     _maxZ = (_maxZ > _secCenter.z) ? _maxZ : _secCenter.z;
//                     _minZ = (_minZ > _secCenter.z) ? _secCenter.z : _minZ;
//                     aActions.name = _inidxlayer + "layerVolumeAnnotation";

//                     grpRtnGeomSec.add(aActions);
//                     arrLayerAnnotaion.push(aActions);

//                     window.viewer.scene.annotations.add(aActions);

//                     //totalArea += layerArea;
//                     //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
//                     totalVolumeCut += _preLayerResultObj.cut;
//                     totalVolumeFill += _preLayerResultObj.fill;

//                 } else if (srcLayerName.length == 2) {

//                     _layerResultObj.cut = _layerResultObj.target_cut;
//                     _layerResultObj.fill = _layerResultObj.target_fill;
//                     _layerResultObj.net = _layerResultObj.target_cut - _layerResultObj.target_fill;

//                     //layer voume annotation
//                     let aActions = new Annotation({
//                         position: [_layerResultObj.secCenter.x, _layerResultObj.secCenter.y, _layerResultObj.secCenter.z],
//                         title: _layerName + "\n Cut Volume : " + addCommas((_layerResultObj.cut).toFixed(2), 'V')
//                             + "\n Fill Volume : " + addCommas((_layerResultObj.fill).toFixed(2), 'V')
//                     });

//                     _maxZ = (_maxZ > _secCenter.z) ? _maxZ : _secCenter.z;
//                     _minZ = (_minZ > _secCenter.z) ? _secCenter.z : _minZ;
//                     aActions.name = _inidxlayer + "layerVolumeAnnotation";

//                     grpRtnGeomSec.add(aActions);
//                     arrLayerAnnotaion.push(aActions);

//                     window.viewer.scene.annotations.add(aActions);

//                     //totalArea += layerArea;
//                     //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
//                     totalVolumeCut += _layerResultObj.cut;
//                     totalVolumeFill += _layerResultObj.fill;
//                 }

//                 //결과 리턴용
//                 rtnGeom.result.push(_layerResultObj);
//                 arrResult.push(_layerResultObj);

//                 _completeCnt++;
//                 __progressAnnotation.completeLayerCount++;
//                 __progressAnnotation.completeSectorCount = 0;

//                 __progressAnnotation['title'] = `Calculate Volume Layers ( ${(__progressAnnotation.completeLayerCount)} / ${__progressAnnotation.srcLayerCount})`;

//                 grpRtnGeomSec.visible = true;
//                 //layer total voume annotation
//                 if (_completeCnt == srcLayerName.length - 1) {

//                     arrLayergeom[0].children[1].geometry.computeBoundingBox();

//                     let bActions = new Annotation({
//                         position: [_secCenter.x, _secCenter.y, (arrLayergeom[0].children[1].geometry.boundingBox.max.z)],
//                         title: " Cut Volume : " + addCommas((totalVolumeCut).toFixed(2), 'V')
//                             + "<br/>Fill Volume : " + addCommas((totalVolumeFill).toFixed(2), 'V')
//                     });

//                     bActions.name = "totalVolumeAnnotation";
//                     grpRtnGeomSec.add(bActions);
//                     window.viewer.scene.annotations.add(bActions);

//                     data.viewData._3DObject = arrLayergeom;
//                     data.calVolResult = arrResult;

//                     arrLayerAnnotaion.push(bActions);

//                     data.viewData.potreeAnnotation = arrLayerAnnotaion;

//                     grpRtnGeomSec.visible = true;
//                     __progressAnnotation.visible = false;
//                     __progressAnnotation.dispose();

//                     xitecloud.isProcessing = false;

//                     _callback(data);
//                 }
//             }

//             for (var _idxSect in data.sectors) {

//                 const _data = data;

//                 let _grpRtnGeomSec = grpRtnGeomSec;
//                 let _sector = data.sectors[_idxSect];
//                 let _point = _sector.sector_geom_t.replace('POLYGON', '').replace('Z', '').replace('((', '').replace('))', '').split(',');

//                 let _param = {
//                     "srcLayer": _srcLayer.geom_tbl_nm
//                     , "targetLayer": _targetLayerName
//                     , "boundaryLayer": _boundaryLayerName
//                     , "targetBoundUse": ((targetBoundUse == 'true') ? 'false' : targetBoundUse) //custom일 경우는 z 값을 사용하여 타겟 사용
//                     , "srid": data.srid
//                     , "points": _point.join(',') //_sector.sector_geom_t
//                 }

//                 let _cureSec = _idxSect; //현재 idx 저장

//                 try {

//                     //const _axios = Axios.create();
//                     $('.model-loading-bar').hide();
//                     //const { data } = await _axios.get('/api/calcVoumeSampleMeshGeom', { params: _param  ,timeout: 5 * 60 *1000 });
//                     const { data } = await Axios.get('/api/calcVoumeSampleMeshGeom', { params: _param, timeout: 5 * 60 * 1000, maxRedirects: 0 });

//                     if (data.src_poly && data.target_poly) {
//                         let rtnGeom = fnMakeLayerVolumeGeom(data, _cur_idxLayer, [0, 0, Math.abs(window.xitecloud.bore_zmin)]);
//                         rtnGeom.name = 'sec' + _cureSec;
//                         rtnGeom.calc = data;
//                         _grpRtnGeomSec.add(rtnGeom);
//                     }

//                     // ++secCompleteCnt;
//                     __progressAnnotation.completeSectorCount++;

//                     __progressAnnotation['title'] = `Calculate Volume Layers ( ${(__progressAnnotation.completeLayerCount)} / ${__progressAnnotation.srcLayerCount})
//                         Progress  ( ${(__progressAnnotation.completeSectorCount / __progressAnnotation.sectorCount * 100).toFixed(2)} % )`;

//                     // if (_data.sectors.length == secCompleteCnt) {
//                     //     await _layerLoadedCallback(_cur_idxLayer);

//                     //     xitecloud.loaddingShow = true;
//                     // }
//                 } catch (error) {
//                     console.log(error)
//                     _errorCnt++;

//                     // if (_data.sectors.length == ++secCompleteCnt) {
//                     //     await _layerLoadedCallback(_cur_idxLayer);

//                     //     xitecloud.loaddingShow = true;
//                     // }
//                 } finally {
//                     // if (_data.sectors.length == secCompleteCnt) {
//                     //     await _layerLoadedCallback(_cur_idxLayer);

//                     //     xitecloud.loaddingShow = true;
//                     // }
//                     if (_data.sectors.length == ++secCompleteCnt) {
//                         await _layerLoadedCallback(_cur_idxLayer);

//                         xitecloud.loaddingShow = true;
//                     }
//                 }
//             }

//         }
//     })()
// }

/* promise multi call */
export const fnCalcVolumeMulti = function (rtnGeom, data, _callback) {
  if (xitecloud.isProcessing) {
    alert("Now Processing...");
    return;
  }

  xitecloud.isProcessing = true;

  rtnGeom.result = [];

  //그리기 효과
  xitecloud.loaddingShow = false;
  $(".model-loading-bar").hide();

  let srcLayerName = data.srcLayer;

  let boundaryLayerName = data.boundryLayer.f_geometry_tbl_nm;
  let targetBoundUse = data.targetBoundUse;

  var arrLayergeom = [];
  var arrLayerAnnotaion = [];
  var arrResult = [];

  let _completeCnt = 0;
  let _errorCnt = 0;

  let totalArea = 0;
  let totalVolume = 0;
  let totalVolumeCut = 0;
  let totalVolumeFill = 0;

  let _gCenter = new THREE.Geometry();
  _gCenter.vertices.push(
    ...data.measure.points.map((a) => {
      return a.position;
    })
  );

  _gCenter.computeBoundingSphere();
  //_gCenter.boundingSphere.center.boundingSphere.center.toArray();

  let _progressAnnotation = new Annotation({
    position: _gCenter.boundingSphere.center.toArray(),
    title: `Calculate Volume Layers ( 0 / ${data.srcLayer.length} ) 
                ( 0 / ${data.sectors.length})`,
  });

  _progressAnnotation.srcLayerCount = data.srcLayer.length;
  _progressAnnotation.sectorCount = data.sectors.length;
  _progressAnnotation.completeLayerCount = 0;
  _progressAnnotation.completeSectorCount = 0;

  window.viewer.scene.annotations.add(_progressAnnotation);

  srcLayerName.push({
    f_input_date: data.targetLayer.f_input_date,
    f_layer_nm: data.targetLayer.f_layer_nm,
    geom_tbl_nm: data.targetLayer.f_geometry_tbl_nm,
    project_mng_sq_t_project_mng: data.targetLayer.project_mng_sq_t_project_mng,
  });

  for (var _idxLayer = 0; _idxLayer < srcLayerName.length - 1; _idxLayer++) {
    let __progressAnnotation = _progressAnnotation;
    let _cur_idxLayer = _idxLayer;
    let _srcLayer = srcLayerName[_idxLayer];

    let secCompleteCnt = 0;

    //분석 대상이 한개인 경우 루프를 위해 타겟을 넣어 줌 [전종수 20200514]
    let _targetLayerName =
      srcLayerName.length == 1
        ? data.targetLayer.f_geometry_tbl_nm
        : srcLayerName[_idxLayer + 1].geom_tbl_nm;
    let _boundaryLayerName = boundaryLayerName;
    let grpRtnGeomSec = new THREE.Group();
    grpRtnGeomSec.name = grpRtnGeomSec.uuid + "_volume_" + _srcLayer.geom_tbl_nm;

    //그리는거 보여줄때 주석
    //grpRtnGeomSec.visible = false;

    //layer geom
    arrLayergeom.push(grpRtnGeomSec);
    window.viewer.scene.scene.add(grpRtnGeomSec);

    let _maxZ = 0;
    let _minZ = 0;

    let _layerLoadedCallback = function (_inidxlayer) {
      let layerArea = 0;
      let layerVolume = 0;
      let layerVolumeCut = 0;
      let layerVolumeFill = 0;

      let _secCenter = new THREE.Vector3();

      //각 섹터물량에서 레이어 물량 계산(타겟)
      for (var _idx = 0; _idx < grpRtnGeomSec.children.length; _idx++) {
        layerArea += Number(grpRtnGeomSec.children[_idx].calc.area); //area
        layerVolume += Number(grpRtnGeomSec.children[_idx].calc.vol); //volume
        layerVolumeCut += Number(grpRtnGeomSec.children[_idx].calc.vol_cut); //volume
        layerVolumeFill += Number(grpRtnGeomSec.children[_idx].calc.vol_fill); //volume

        grpRtnGeomSec.children[_idx].geometry.computeBoundingSphere();

        _secCenter.add(grpRtnGeomSec.children[_idx].geometry.boundingSphere.center);
      }
      _secCenter.divideScalar(grpRtnGeomSec.children.length);

      //source layer topo 추가로 암층 명은 +1 하지만 인데스가 하나 증가해 있으므로 그냥 idx
      // let _layerName = srcLayerName[_idxLayer].f_layer_nm;
      let _layerName = srcLayerName[_inidxlayer].f_layer_nm;

      let _layerResultObj = {
        layerName: _layerName,
        idx: _inidxlayer,
        layergeom: grpRtnGeomSec.clone(),
        secCenter: _secCenter.clone(),

        target_cut: layerVolumeCut,
        target_fill: layerVolumeFill,
        cut: 0,
        fill: 0,
        net: 0, //순토량
      };

      //현재(20200515)물량 계산은 각 레이어 타겟 물량임으로 전층의 물량은 이전 결과에서 현재 물량을 차감한 값이다
      //이번계산으로 전층 물량 결정 레이어가 하나일경우(타겟 까지 2 개) custom fit plan
      if (_inidxlayer != 0) {
        let _preLayerResultObj = arrResult[_inidxlayer - 1];

        _preLayerResultObj.cut = _preLayerResultObj.target_cut - layerVolumeCut + layerVolumeFill;
        _preLayerResultObj.fill -= layerVolumeFill;
        _preLayerResultObj.net = _preLayerResultObj.target_cut - _preLayerResultObj.fill;

        //layer voume annotation
        let aActions = new Annotation({
          position: [
            _preLayerResultObj.secCenter.x,
            _preLayerResultObj.secCenter.y,
            _preLayerResultObj.secCenter.z,
          ],
          title:
            _layerName +
            "\n Cut Volume : " +
            addCommas(_preLayerResultObj.cut.toFixed(2), "V") +
            "\n Fill Volume : " +
            addCommas(_preLayerResultObj.fill.toFixed(2), "V"),
        });

        _maxZ = _maxZ > _secCenter.z ? _maxZ : _secCenter.z;
        _minZ = _minZ > _secCenter.z ? _secCenter.z : _minZ;
        aActions.name = _inidxlayer + "layerVolumeAnnotation";

        grpRtnGeomSec.add(aActions);
        arrLayerAnnotaion.push(aActions);

        window.viewer.scene.annotations.add(aActions);

        //totalArea += layerArea;
        //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
        totalVolumeCut += _preLayerResultObj.cut;
        totalVolumeFill += _preLayerResultObj.fill;
      } else if (srcLayerName.length == 2) {
        _layerResultObj.cut = _layerResultObj.target_cut;
        _layerResultObj.fill = _layerResultObj.target_fill;
        _layerResultObj.net = _layerResultObj.target_cut - _layerResultObj.target_fill;

        //layer voume annotation
        let aActions = new Annotation({
          position: [
            _layerResultObj.secCenter.x,
            _layerResultObj.secCenter.y,
            _layerResultObj.secCenter.z,
          ],
          title:
            _layerName +
            "\n Cut Volume : " +
            addCommas(_layerResultObj.cut.toFixed(2), "V") +
            "\n Fill Volume : " +
            addCommas(_layerResultObj.fill.toFixed(2), "V"),
        });

        _maxZ = _maxZ > _secCenter.z ? _maxZ : _secCenter.z;
        _minZ = _minZ > _secCenter.z ? _secCenter.z : _minZ;
        aActions.name = _inidxlayer + "layerVolumeAnnotation";

        grpRtnGeomSec.add(aActions);
        arrLayerAnnotaion.push(aActions);

        window.viewer.scene.annotations.add(aActions);

        //totalArea += layerArea;
        //totalVolume +=  _preLayerResultObj.cut - layerVolumeFill;
        totalVolumeCut += _layerResultObj.cut;
        totalVolumeFill += _layerResultObj.fill;
      }

      //결과 리턴용
      rtnGeom.result.push(_layerResultObj);
      arrResult.push(_layerResultObj);

      _completeCnt++;
      __progressAnnotation.completeLayerCount++;
      __progressAnnotation.completeSectorCount = 0;

      __progressAnnotation["title"] =
        `Calculate Volume Layers ( ${__progressAnnotation.completeLayerCount} / ${__progressAnnotation.srcLayerCount})`;

      grpRtnGeomSec.visible = true;
      //layer total voume annotation
      if (_completeCnt == srcLayerName.length - 1) {
        arrLayergeom[0].children[1].geometry.computeBoundingBox();

        let bActions = new Annotation({
          position: [
            _secCenter.x,
            _secCenter.y,
            arrLayergeom[0].children[1].geometry.boundingBox.max.z,
          ],
          title:
            " Cut Volume : " +
            addCommas(totalVolumeCut.toFixed(2), "V") +
            "<br/>Fill Volume : " +
            addCommas(totalVolumeFill.toFixed(2), "V"),
        });

        bActions.name = "totalVolumeAnnotation";
        grpRtnGeomSec.add(bActions);
        window.viewer.scene.annotations.add(bActions);

        data.viewData._3DObject = arrLayergeom;
        data.calVolResult = arrResult;

        arrLayerAnnotaion.push(bActions);

        data.viewData.potreeAnnotation = arrLayerAnnotaion;

        grpRtnGeomSec.visible = true;
        __progressAnnotation.visible = false;
        __progressAnnotation.dispose();

        xitecloud.isProcessing = false;

        _callback(data);
      }
    };

    function sleep(delay) {
      var start = new Date().getTime();
      while (new Date().getTime() < start + delay);
    }

    //for (var _idxSect in data.sectors) {
    for (let _idxSect = 0; _idxSect < data.sectors.length; _idxSect++) {
      // if (_idxSect != 0 && Number(_idxSect) % 10 == 0 ) {
      //     debugger;
      //     console.log( _idxSect + ' sleep 3 minute')
      //     sleep(3 * 60 * 1000)
      // }

      const _data = data;

      let _grpRtnGeomSec = grpRtnGeomSec;
      let _sector = data.sectors[_idxSect];
      let _point = _sector.sector_geom_t
        .replace("POLYGON", "")
        .replace("Z", "")
        .replace("((", "")
        .replace("))", "")
        .split(",");

      let _param = {
        srcLayer: _srcLayer.geom_tbl_nm,
        targetLayer: _targetLayerName,
        boundaryLayer: _boundaryLayerName,
        targetBoundUse: targetBoundUse == "true" ? "false" : targetBoundUse, //custom일 경우는 z 값을 사용하여 타겟 사용
        srid: data.srid,
        points: _point.join(","), //_sector.sector_geom_t
      };

      let _cureSec = _idxSect; //현재 idx 저장

      //const _axios = Axios.create();
      $(".model-loading-bar").hide();
      //const { data } = await _axios.get('/api/calcVoumeSampleMeshGeom', { params: _param  ,timeout: 5 * 60 *1000 });
      Axios.get("/api/calcVoumeSampleMeshGeom", {
        params: _param,
        timeout: 5 * 60 * 1000,
        maxRedirects: 0,
      })
        .then(({ data }) => {
          if (data.src_poly && data.target_poly) {
            let rtnGeom = fnMakeLayerVolumeGeom(data, _cur_idxLayer, [
              0,
              0,
              Math.abs(window.xitecloud.bore_zmin),
            ]);
            rtnGeom.name = "sec" + _cureSec;
            rtnGeom.calc = data;
            _grpRtnGeomSec.add(rtnGeom);
          }

          ++secCompleteCnt;
          __progressAnnotation.completeSectorCount++;

          __progressAnnotation["title"] = `Calculate Volume Layers ( ${
            __progressAnnotation.completeLayerCount
          } / ${__progressAnnotation.srcLayerCount})
                    Progress  ( ${(
                      (__progressAnnotation.completeSectorCount /
                        __progressAnnotation.sectorCount) *
                      100
                    ).toFixed(2)} % )`;

          if (_data.sectors.length == secCompleteCnt) {
            _layerLoadedCallback(_cur_idxLayer);
            xitecloud.loaddingShow = true;
          }
        })
        .catch((error) => {
          console.log(error);
          _errorCnt++;

          if (_data.sectors.length == ++secCompleteCnt) {
            _layerLoadedCallback(_cur_idxLayer);
            xitecloud.loaddingShow = true;
          }
        });
    }
  }
};

/* Cut & fill */
export const fnCutFillGeomLoad = (viewData, ynLoadGeom) => {
  let SRID = window.xitecloud.viewDataSet.project.f_epsg;
  let DIST = 20;

  let srcLayers = [];

  let pcdTopoItem = window.xitecloud.viewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  );

  srcLayers.push({
    gbn: "topo",
    item: pcdTopoItem.dbObj,
  });

  //멀티콤보 선택값 저장 방식 변경 [전종수 2020.03.17]
  let _toolObjValue = viewData.toolObj.value.split("|");

  if (window.xitecloud.viewDataSet.layer.target.length == 0) {
    viewData.measure.visible = false;
    viewData.measure.remove();
    return alert("No target");
  }

  let targetLayer = window.xitecloud.viewDataSet.layer.target[0].dbObj;
  let boundryLayer = window.xitecloud.viewDataSet.layer.target[0].dbObj;
  let measure = viewData.measure;
  let _targetBoundUse = false;

  //all rock layer
  if (_toolObjValue[0] === "a3" && _toolObjValue[1] === "SUBLAYER") {
    for (let _item of window.xitecloud.viewDataSet.layer.subsurface) {
      if (_item.visible == true) {
        srcLayers.push({
          gbn: "sublayer",
          item: _item.dbObj,
        });
      }
    }
    //all - target boundry
  } else if (_toolObjValue[0] === "a3" && _toolObjValue[1] === "BOUNDRYALL") {
    for (let _item of window.xitecloud.viewDataSet.layer.subsurface) {
      if (_item.visible == true) {
        srcLayers.push({
          gbn: "sublayer",
          item: _item.dbObj,
        });
      }
    }
    _targetBoundUse = true;
    //topo - target
  } else if (_toolObjValue[0] === "a3" && _toolObjValue[1] === "TOPO") {
    /* 이후 타겟을 파라미터로 변경 검토 */
    targetLayer = window.xitecloud.viewDataSet.layer.target[0].dbObj;
    _targetBoundUse = true;
  }

  if (window.xitecloud.viewDataSet.layer.target.length === 0) {
    return alert("No target Layers!!");
  }

  if (_targetBoundUse || measure.points.length > 2) {
    var param = fnMakeParamFromMeasure(measure, true);

    let objParamPre = {
      srid: SRID,
      points: param,
      topoLayer: pcdTopoItem.dbObj,
      targetLayer: targetLayer,
      boundryLayer: boundryLayer,
      targetBoundUse: _targetBoundUse,
    };

    const _callback = (result) => {
      if (measure == null) {
        measure = new Measure();

        let _points = result[0].target_boundry.split("((")[1].replace("))", "").split(",");

        for (let _pt of _points) {
          measure.addMarker(
            new THREE.Vector3(
              Number(_pt.split(" ")[0]),
              Number(_pt.split(" ")[1]),
              xitecloud.bore_zmin
            )
          );
        }
      }

      //   $('#lds-roller-container').hide();   //그려지는거 보여 줄때
      let _tmpObj = {
        area: Number(result[0].param_area).toFixed(2),
        "Layer Count :": srcLayers.length,
        sectorCnt: result.length,
        avg_area: Number(result[0].area_avg).toFixed(2),
      };

      let _messageStr = `Selected Area: ${addCommas(_tmpObj.area, "A")} 
Divide Sector Count: ${_tmpObj.sectorCnt} (Average ${addCommas(_tmpObj.avg_area, "A")})
Calculate few Minuates
Continue? Cancel for background job`;

      let _tmp = window.confirm(_messageStr);

      const objParam = {
        srid: SRID,
        srcLayer: srcLayers,
        targetLayer: targetLayer,
        points: param,
        sectors: result,
        measure: measure,
        viewData: viewData,
        targetBoundUse: _targetBoundUse,
        boundryLayer: boundryLayer,
      };

      if (_tmp) {
        var rtnGeom = {};
        let _callback = (data) => {
          window.xitecloud.viewDataSet.annotations.analytics.push(data.viewData);
          window.xitecloud.updateLayerListInComponent();
        };

        fnCalcCutFill(rtnGeom, objParam, _callback);
      } else {
        if (viewData.measure) viewData.measure.visible = false;

        fnCalcCutFillJob(rtnGeom, objParam);
      }
    };

    let _cancelCallbak = () => {};

    fnPreCalc(objParamPre, _callback, _cancelCallbak);
  }
};

export const fnCalcCutFill = function (rtnGeom, data, _callback) {
  //그리기 효과
  xitecloud.loaddingShow = false;

  let Globaltrans = xitecloud.Globaltrans;

  //sublayer 레이어 암층 생성 순으로 정렬 (pk_id)
  data.srcLayer.sort(function (a, b) {
    if (a.gbn == "topo") return -1;
    if (b.gbn == "topo") return 1;
    return a.item.subsurface_data_sq < b.item.subsurface_data_sq
      ? -1
      : a.item.subsurface_data_sq > b.item.subsurface_data_sq
        ? 1
        : 0;
  });

  let srcLayerName = data.srcLayer.map(function (a) {
    if (a.gbn == "topo") {
      return {
        gbn: "topo",
        geomTableName:
          a.item.f_calculation_tbl_nm == null || a.item.f_calculation_tbl_nm == ""
            ? a.item.f_ply_geom_tbl_nm
            : a.item.f_calculation_tbl_nm,
        item: a.item,
        calc:
          a.item.f_calculation_tbl_nm == null || a.item.f_calculation_tbl_nm == "" ? false : true,
      };
    } else
      return {
        gbn: "sublayer",
        geomTableName: a.item.f_geometry_tbl_nm,
        item: a.item,
        calc: false,
      };
  });

  //sublayer 없는경우 타겟레이어를 대상에 넣어 줌
  if (srcLayerName.length == 1) {
    srcLayerName.push({
      gbn: "sublayer",
      geomTableName: data.targetLayer.f_geometry_tbl_nm,
      item: data.targetLayer,
    });
  }

  let boundryLayerName = data.targetLayer.f_geometry_tbl_nm;

  var arrLayergeom = [];
  var arrLayerAnnotaion = [];

  let _completeCnt = 0;
  let _errorCnt = 0;

  let totalArea = 0;
  let totalVolume = 0;
  let totalVolumeCut = 0;
  let totalVolumeFill = 0;

  let _gCenter = new THREE.Geometry();
  _gCenter.vertices.push(
    ...data.measure.points.map((a) => {
      return a.position;
    })
  );

  _gCenter.computeBoundingSphere();
  //_gCenter.boundingSphere.center.boundingSphere.center.toArray();

  let _progressAnnotation = new Annotation({
    position: _gCenter.boundingSphere.center.toArray(),
    title: `Calculate Volume Layers ( 0 / ${data.srcLayer.length}
                ( 0 / ${data.sectors.length})`,
  });

  _progressAnnotation.srcLayerCount = data.srcLayer.length;
  _progressAnnotation.sectorCount = data.sectors.length;
  _progressAnnotation.completeLayerCount = 0;
  _progressAnnotation.completeSectorCount = 0;

  window.viewer.scene.annotations.add(_progressAnnotation);

  for (var _idxLayer = 0; _idxLayer < srcLayerName.length - 1; _idxLayer++) {
    let __progressAnnotation = _progressAnnotation;
    let _cur_idxLayer = _idxLayer;
    var _srcLayer = srcLayerName[_idxLayer];

    let secCompleteCnt = 0;

    let _targetLayerName = srcLayerName[_idxLayer + 1].geomTableName;

    let grpRtnGeomSec = new THREE.Group();
    grpRtnGeomSec.name = grpRtnGeomSec.uuid + "_cutfill_" + _srcLayer.geomTableName;

    //그리는거 보여줄때 주석
    //grpRtnGeomSec.visible = false;

    //layer geom
    arrLayergeom.push(grpRtnGeomSec);
    window.viewer.scene.scene.add(grpRtnGeomSec);

    let _maxZ = 0;
    let _minZ = 0;

    let _layerLoadedCallback = function (_inidxlayer) {
      let layerArea = 0;
      let layerVolume = 0;
      let layerVolumeCut = 0;
      let layerVolumeFill = 0;

      let _secCenter = new THREE.Vector3();

      for (var _idx = 0; _idx < grpRtnGeomSec.children.length; _idx++) {
        //layerArea += Number(grpRtnGeomSec.children[_idx].calc.src_poly);  //area
        layerVolume += Number(grpRtnGeomSec.children[_idx].calc.vol); //volume
        layerVolumeCut += Number(grpRtnGeomSec.children[_idx].calc.cut); //volume
        layerVolumeFill += Number(grpRtnGeomSec.children[_idx].calc.fill); //volume

        //geom 없는 경우
        if (grpRtnGeomSec.children[_idx].geometry == undefined) continue;

        grpRtnGeomSec.children[_idx].geometry.computeBoundingSphere();

        _secCenter.add(grpRtnGeomSec.children[_idx].geometry.boundingSphere.center);
      }
      _secCenter.divideScalar(grpRtnGeomSec.children.length);

      //source layer topo 추가로 암층 명은 +1
      let _layerName = srcLayerName[_inidxlayer + 1].item.f_layer_nm;

      //layer voume annotation
      let aActions = new Annotation({
        position: [_secCenter.x, _secCenter.y, _secCenter.z],
        title:
          _layerName +
          " Layer Volume : " +
          addCommas(layerVolume.toFixed(2), "V") +
          " ( " +
          layerVolumeCut.toFixed(2) +
          " / " +
          layerVolumeFill.toFixed(2) +
          " )",
      });

      _maxZ = _maxZ > _secCenter.z ? _maxZ : _secCenter.z;
      _minZ = _minZ > _secCenter.z ? _secCenter.z : _minZ;
      aActions.name = _inidxlayer + "layerVolumeAnnotation";

      arrLayerAnnotaion.push(aActions);
      window.viewer.scene.annotations.add(aActions);

      totalArea += layerArea;
      totalVolume += layerVolume;
      totalVolumeCut += layerVolumeCut;
      totalVolumeFill += layerVolumeFill;

      _completeCnt++;

      __progressAnnotation.completeLayerCount++;
      __progressAnnotation.completeSectorCount = 0;

      __progressAnnotation["title"] = `Calculate Volume Layers ( ${
        __progressAnnotation.completeLayerCount
      } / ${__progressAnnotation.srcLayerCount})
                                                               Progress ( ${(
                                                                 (__progressAnnotation.completeSectorCount /
                                                                   __progressAnnotation.sectorCount) *
                                                                 100
                                                               ).toFixed(2)} %)`;

      grpRtnGeomSec.visible = true;

      //layer total voume annotation
      if (_completeCnt == srcLayerName.length - 1) {
        let _boundingBox;
        //cut, fill 없을 경우
        if (arrLayergeom[0].children[1].geometry) {
          arrLayergeom[0].children[1].geometry.computeBoundingBox();
          _boundingBox = arrLayergeom[0].children[1].geometry.boundingBox;
        } else {
          arrLayergeom[0].children[2].geometry.computeBoundingBox();
          _boundingBox = arrLayergeom[0].children[2].geometry.boundingBox;
        }

        let bActions = new Annotation({
          position: [_secCenter.x, _secCenter.y, _boundingBox.max.z + 10],
          title:
            "Total Volume : " +
            addCommas(totalVolume.toFixed(2), "V") +
            "<br/>Cut Volume : " +
            addCommas(totalVolumeCut.toFixed(2), "V") +
            "<br/>Fill Volume : " +
            addCommas(totalVolumeFill.toFixed(2), "V"),
        });

        bActions.name = "totalVolumeAnnotation";
        //grpRtnGeomSec.add(bActions);
        window.viewer.scene.annotations.add(bActions);

        data.viewData._3DObject = arrLayergeom;

        arrLayerAnnotaion.push(bActions);

        data.viewData.potreeAnnotation = arrLayerAnnotaion;

        grpRtnGeomSec.visible = true;
        __progressAnnotation.visible = false;
        __progressAnnotation.dispose();

        _callback(data);
      }
    };

    for (var _idxSect in data.sectors) {
      const _data = data;

      let _grpRtnGeomSec = grpRtnGeomSec;
      let _sector = data.sectors[_idxSect];
      let _point = _sector.sector_geom_t
        .replace("POLYGON", "")
        .replace("((", "")
        .replace("))", "")
        .split(",");

      let _param = {
        srcLayer: _srcLayer.geomTableName,
        targetLayer: _targetLayerName,
        boudryLayer: boundryLayerName,
        srid: data.srid,
        points: _point.join(","), //_sector.sector_geom_t
        sector_idx: _idxSect,
      };

      let _cureSec = _idxSect; //현재 idx 저장
      let _geom = _sector.sector_geom_t;
      Axios.get(
        //( (_srcLayer.calc) ? '/api/calcCutFillGeomByCalc' :  '/api/calcCutFillGeom')
        "/api/calcCutFillGeom",
        {
          params: _param,
        }
      )
        .then((result) => {
          let item = result.data;

          let calc = { cut: 0, fill: 0, area: 0, vol: 0 };

          if (item.vol_cut != 0 && item.line_geom_cut != null) {
            try {
              let _rtnLineGeomCut = fnMakeCutFillLineGeom(item.line_geom_cut, _cur_idxLayer, 0);
              _grpRtnGeomSec.add(_rtnLineGeomCut);
              _rtnLineGeomCut.name = "sec" + _cureSec;
              _rtnLineGeomCut.calc = calc;
              calc.cut = Math.abs(item.vol_cut);
            } catch (e) {}
          }

          if (item.vol_fill != 0 && item.line_geom_fill != null) {
            try {
              let _rtnLineGeomFill = fnMakeCutFillLineGeom(item.line_geom_fill, _cur_idxLayer, 1);
              _grpRtnGeomSec.add(_rtnLineGeomFill);
              _rtnLineGeomFill.name = "sec" + _cureSec;
              _rtnLineGeomFill.calc = calc;
              calc.fill = Math.abs(item.vol_fill);
            } catch (e) {}
          }

          calc.vol = calc.cut + calc.fill;
          calc.area += item.area;

          __progressAnnotation.completeSectorCount++;

          __progressAnnotation["title"] = `Calculate Volume Layers ( ${
            __progressAnnotation.completeLayerCount
          } / ${__progressAnnotation.srcLayerCount})
                    Progress ( ${(
                      (__progressAnnotation.completeSectorCount /
                        __progressAnnotation.sectorCount) *
                      100
                    ).toFixed(2)} % )`;

          if (_data.sectors.length == ++secCompleteCnt) {
            _layerLoadedCallback(_cur_idxLayer);
            xitecloud.loaddingShow = true;
          }
        })
        .catch((error) => {
          console.log(error);
          _errorCnt++;

          if (_data.sectors.length == ++secCompleteCnt) {
            _layerLoadedCallback(_cur_idxLayer);

            xitecloud.loaddingShow = true;
          }
        });
    }
  }
};

export const fnCalcAreaJob = function (rtnGeom, data, _callback) {
  let boundryLayerName = "";
  let _targetLayerName = "";

  let _param = {
    //"type" : data.viewData.toolObj.value
    type: "AREA",
    project_mng_sq: data.srcTable.project_mng_sq_t_project_mng,
    input_date: data.srcTable.f_input_date,
    //, "top": data.srcTable.f_ply_geom_tbl_nm
    top: data.srcTable,
    bottom: _targetLayerName,
    boundry: boundryLayerName,
    srid: data.srid,
    points: data.points,
    targetBoundUse: data.targetBoundUse,
  };

  // const dbParam =
  return {
    project_mng_sq_t_project_mng: data.srcTable.project_mng_sq_t_project_mng,
    f_create_date: data.srcTable.f_input_date,
    f_fence_nm: data.viewData.title,
    //f_fence_annotation_flag: objParam.toolObj.value,
    f_fence_annotation_flag: data.viewData.toolObj.value,
    c_fence_type: data.viewData.toolObj.annotationGroup,
    c_annotation_type: data.viewData.toolObj.measureType,
    f_line_color: `#${data.measure.lineColor.getHexString()}`,
    f_line_dash: 0,
    f_line_width: 0,
    f_fill_color: `#${data.measure.faceColor.getHexString()}`,
    f_fill_transparency: 100,
    f_location: fnMakeParamFromMeasure(data.viewData.measure, true),
    f_description: "",
    f_param: JSON.stringify(_param),
  };

  // Axios.post(`/createAnnotationAndJob`, {
  //     params: dbParam
  // })
  // .then(_callback)
  // .catch((error) => console.log(error));
};

/** 어노테이션 물량(Volume) 계산 */
export const fnCalcVolumeJob = (rtnGeom, data, _callback) => {
  let boundryLayerName = data.targetLayer.f_geometry_tbl_nm;
  let _targetLayerName = data.targetLayer.f_geometry_tbl_nm;

  // 기존 Input Date 및 topo 입력값 (fnPreCalc(/api/preCalc 호출)의 결과값)
  // let srcLayerName = data.srcLayer;
  // let _srcLayer = srcLayerName[0].geom_tbl_nm;

  let _srcLayer = `pcd_${window.xitecloud.viewDataSet.project.project_mng_sq}_${data.selectedDate}_original`;

  let _param = {
    // "type" : data.viewData.toolObj.value
    type: "VOLUME_BG",
    project_mng_sq: data.srcLayer[0].project_mng_sq_t_project_mng,
    input_date: data.selectedDate, // data.srcLayer[0].f_input_date,
    top: _srcLayer,
    bottom: _targetLayerName,
    boundry: boundryLayerName,
    srid: data.srid,
    points: data.points,
    targetBoundUse: data.targetBoundUse,
    uiOptions: data.uiOptions,
  };

  // const currentProject = window.xitecloud.viewDataSet.project;
  // const topo_0 = window.xitecloud.viewDataSet.layer.topo.find((_item) => (_item.dataType === 'pointcloud')).dbObj
  // console.log(rtnGeom, data)
  // const dbParam =
  return {
    project_mng_sq_t_project_mng: data.srcLayer[0].project_mng_sq_t_project_mng,
    f_create_date: store.getState().currentProjectReducer.selectedDate,
    f_fence_nm: data.viewData.title,
    //f_fence_annotation_flag: objParam.toolObj.value,
    f_fence_annotation_flag: data.viewData.toolObj.value,
    c_fence_type: data.viewData.toolObj.annotationGroup,
    c_annotation_type: data.viewData.toolObj.measureType,
    f_line_color: "",
    f_line_dash: 0,
    f_line_width: 0,
    f_fill_color: "",
    f_fill_transparency: 100,
    f_location: fnMakeParamFromMeasure(data.viewData.measure, true),
    f_description: "",
    f_param: JSON.stringify(_param),
  };

  //   Axios.post(`/createAnnotationAndJob`, {
  //     params: dbParam
  //   })
  //     .then(_callback)
  //     .catch((error) => console.log(error));
};

export const fnCalcCutFillJob = (rtnGeom, data, _callback) => {
  // 그리기 효과
  let srcLayerName = data.srcLayer.map((a) => {
    if (a.gbn === "topo") {
      return {
        gbn: "topo",
        geomTableName:
          a.item.f_calculation_tbl_nm == null || a.item.f_calculation_tbl_nm == ""
            ? a.item.f_ply_geom_tbl_nm
            : a.item.f_calculation_tbl_nm,
        item: a.item,
        calc:
          a.item.f_calculation_tbl_nm == null || a.item.f_calculation_tbl_nm == "" ? false : true,
      };
    } else {
      return {
        gbn: "sublayer",
        geomTableName: a.item.f_geometry_tbl_nm,
        item: a.item,
        calc: false,
      };
    }
  });

  // Sublayer 없는경우 타겟 레이어를 대상에 할당
  if (srcLayerName.length === 1) {
    srcLayerName.push({
      gbn: "sublayer",
      geomTableName: data.targetLayer.f_geometry_tbl_nm,
      item: data.targetLayer,
    });
  }

  let boundryLayerName = data.targetLayer.f_geometry_tbl_nm;
  let _targetLayerName = data.targetLayer.f_geometry_tbl_nm;
  let _srcLayer = srcLayerName[0].geomTableName;

  let _param = {
    // "type" : data.viewData.toolObj.value
    type: "CUTFILL",
    project_mng_sq: data.srcLayer[0].item.project_mng_sq_t_project_mng,
    input_date: data.srcLayer[0].item.f_input_date,
    top: _srcLayer,
    bottom: _targetLayerName,
    boundry: boundryLayerName,
    srid: data.srid,
    points: data.points,
    targetBoundUse: data.targetBoundUse,
  };

  const topo_0 = window.xitecloud.viewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  ).dbObj;

  const dbParam = {
    project_mng_sq_t_project_mng: topo_0.project_mng_sq_t_project_mng,
    f_create_date: topo_0.f_input_date,
    f_fence_nm: data.viewData.title,
    //f_fence_annotation_flag: objParam.toolObj.value,
    f_fence_annotation_flag: data.viewData.toolObj.value,
    c_fence_type: data.viewData.toolObj.annotationGroup,
    c_annotation_type: data.viewData.toolObj.measureType,
    f_line_color: "",
    f_line_dash: 0,
    f_line_width: 0,
    f_fill_color: "",
    f_fill_transparency: 100,
    f_location: fnMakeParamFromMeasure(data.viewData.measure, true),
    f_description: "",
    f_param: JSON.stringify(_param),
  };

  Axios.post(`/createAnnotationAndJob`, {
    params: dbParam,
  })
    .then(_callback)
    .catch((error) => console.log(error));
};

/* src mesh target mexh 삼각기둥 만들기 buffergeometry */
export const fnMakeLayerVolumeGeom = function (_dataArr, pColor, _trans) {
  let _color = pColor ? xitecloud.ArrColor[pColor] : xitecloud.ArrColor[0];

  let data = _dataArr;
  let cutFill = _dataArr;

  _trans = _trans ? _trans : [0, 0, 0];

  _color = new THREE.Color(_color);

  var vertex = [];
  var faces = [];
  var normals = [];
  var colors = [];

  var idx = 0;

  for (var _tmp = 0; _tmp < data.src_poly.length; _tmp++) {
    if (data.src_poly[_tmp].coordinates[0].length == 4) {
      //with close point (polygon)

      //top
      vertex.push(...data.src_poly[_tmp].coordinates[0][0]);
      vertex.push(...data.src_poly[_tmp].coordinates[0][1]);
      vertex.push(...data.src_poly[_tmp].coordinates[0][2]);

      //bottom
      vertex.push(...data.target_poly[_tmp].coordinates[0][0]);
      vertex.push(...data.target_poly[_tmp].coordinates[0][1]);
      vertex.push(...data.target_poly[_tmp].coordinates[0][2]);

      faces.push(...[idx, idx + 1, idx + 2]);
      faces.push(...[idx, idx + 3, idx + 4]);

      faces.push(...[idx, idx + 4, idx + 1]);
      faces.push(...[idx + 1, idx + 4, idx + 5]);

      faces.push(...[idx + 1, idx + 5, idx + 2]);
      faces.push(...[idx + 2, idx + 5, idx + 3]);

      faces.push(...[idx + 2, idx + 3, idx + 0]);
      faces.push(...[idx + 2, idx + 4, idx + 5]);

      //bottom reverse

      normals.push(0, 0, 1);
      normals.push(0, 0, 1);
      normals.push(0, 0, 1);

      normals.push(0, 0, 1);
      normals.push(0, 0, 1);
      normals.push(0, 0, 1);

      normals.push(0, 0, 1);
      normals.push(0, 0, 1);
      normals.push(0, 0, 1);

      if (Math.abs(cutFill.vol_fill[0]) > Math.abs(cutFill.vol_cut[0])) {
        colors.push(..._color.toArray());
        colors.push(..._color.toArray());
        colors.push(..._color.toArray());

        colors.push(..._color.toArray());
        colors.push(..._color.toArray());
        colors.push(..._color.toArray());

        colors.push(..._color.toArray());
        colors.push(..._color.toArray());
        colors.push(..._color.toArray());
      } else {
        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));

        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));

        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));
        colors.push(..._color.toArray().map((a) => a - 0.5));
      }
      //vertix 6
      idx += 6;
    }
  }

  var geometry = new THREE.BufferGeometry();
  geometry.setIndex(faces);
  geometry.setAttribute("position", new THREE.Float32BufferAttribute(vertex, 3)); //(x,y,z)
  geometry.setAttribute("normal", new THREE.Float32BufferAttribute(normals, 3));
  geometry.setAttribute("color", new THREE.Float32BufferAttribute(colors, 3)); //(r,g,b)

  geometry.computeFaceNormals();

  let Globaltrans = xitecloud.Globaltrans;

  if (Globaltrans && Globaltrans.length == 3)
    geometry.applyMatrix(
      new THREE.Matrix4().makeTranslation(
        Globaltrans[0] + _trans[0],
        Globaltrans[1] + _trans[1],
        Globaltrans[2] + _trans[2]
      )
    );

  let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
  _option.vertexColors = true;

  // var MaterialTopo = new THREE.MeshPhongMaterial( {
  //     side: THREE.DoubleSide,
  //     vertexColors: true
  //flatShading: true
  // } );

  var MaterialTopo = new THREE.MeshStandardMaterial(_option);

  return new THREE.Mesh(geometry, MaterialTopo);
};

/* st_collect -> multi polygon geojson */
export const fnMakeLayerAreaGeom = function (_data, _color, _trans) {
  if (_data === null) return new THREE.Object3D();
  var data = _data.coordinates;

  _color = _color ? _color : xitecloud.ArrColor[0];
  _trans = _trans ? _trans : [0, 0, 0];

  var vertex = [];
  var faces = [];
  let geometry = new THREE.BufferGeometry();

  var idx = 0;

  for (var _tmp = 0; _tmp < data.length; _tmp++) {
    //폴리곤 4점
    if (data[_tmp][0].length == 4) {
      //with close point (polygon)
      //top
      vertex.push(new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2]));

      faces.push(new THREE.Face3(idx, idx + 1, idx + 2));

      idx += 3;
    }
    //폴리곤 5점
    else if (data[_tmp][0].length == 5) {
      //with close point (polygon)

      //top
      vertex.push(new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][3][0], data[_tmp][0][3][1], data[_tmp][0][3][2]));

      faces.push(new THREE.Face3(idx, idx + 1, idx + 2));
      faces.push(new THREE.Face3(idx, idx + 2, idx + 3));

      idx += 4;
    }
    //폴리곤 6점
    else if (data[_tmp][0].length == 6) {
      //with close point (polygon)

      //top
      vertex.push(new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][3][0], data[_tmp][0][3][1], data[_tmp][0][3][2]));

      vertex.push(new THREE.Vector3(data[_tmp][0][4][0], data[_tmp][0][4][1], data[_tmp][0][4][2]));

      faces.push(new THREE.Face3(idx, idx + 1, idx + 2));
      faces.push(new THREE.Face3(idx, idx + 2, idx + 3));
      faces.push(new THREE.Face3(idx, idx + 3, idx + 4));

      idx += 5;
    } else {
      console.log("make calcArea geom over point !! " + data[_tmp][0].length);
    }
  }

  geometry = new THREE.Geometry();
  geometry.vertices = vertex;
  geometry.faces = faces;

  let Globaltrans = xitecloud.Globaltrans;
  if (Globaltrans && Globaltrans.length == 3)
    geometry.applyMatrix(
      new THREE.Matrix4().makeTranslation(
        Globaltrans[0] + _trans[0],
        Globaltrans[1] + _trans[1],
        Globaltrans[2] + _trans[2]
      )
    );

  let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
  _option.color = _color;

  var MaterialTopo = new THREE.MeshStandardMaterial(_option);
  let rtnGeom = new THREE.Mesh(geometry, MaterialTopo);

  window.viewer.scene.scene.add(rtnGeom);

  return rtnGeom;
};
//0 : cut  1 : fill
export const fnMakeCutFillLineGeom = function (_data, _color, _cutfill, _trans) {
  let _line = new THREE.Object3D();

  try {
    var data = _data.coordinates;

    _color = _color ? xitecloud.ArrColor[_color] : xitecloud.ArrColor[0];
    _trans = _trans ? _trans : [0, 0, 0];

    _color = new THREE.Color(_color);

    //fill
    if (_cutfill == 1) {
      _color.r = 1;
      _color.g = _color.g - 0.3;
      _color.b = _color.b - 0.3;
    }
    //cut
    else if (_cutfill == 0) {
      _color.r = _color.r - 0.3;
      _color.g = _color.g - 0.3;
      _color.b = 1;
    }

    var vertex = [];
    var faces = [];
    var colors = [];

    for (var _tmp = 0; _tmp < data.length; _tmp++) {
      //top
      vertex.push(...data[_tmp][0]);
      vertex.push(...data[_tmp][1]);

      colors.push(..._color.toArray());
      colors.push(..._color.toArray());
    }

    var geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.Float32BufferAttribute(vertex, 3)); //(x,y,z)
    geometry.setAttribute("color", new THREE.Float32BufferAttribute(colors, 3)); //(r,g,b)

    var material = new THREE.LineBasicMaterial({ vertexColors: THREE.VertexColors, opacity: 0.8 });

    let Globaltrans = xitecloud.Globaltrans;
    if (Globaltrans && Globaltrans.length == 3)
      geometry.applyMatrix(
        new THREE.Matrix4().makeTranslation(
          Globaltrans[0] + _trans[0],
          Globaltrans[1] + _trans[1],
          Globaltrans[2] + _trans[2]
        )
      );

    _line = new THREE.LineSegments(geometry, material);

    let _option = Object.assign({}, xitecloud.MeshStandardMaterial_options);
    _option.color = _color;

    window.viewer.scene.scene.add(_line);
  } catch (e) {}

  return _line;
};

// "UNIT" : {
//     "M" : [1 ,"M" ] ,         //미터(M)
//     "INCH" : [39.37, "inch"],   //인치(Inch)
//     "FT" : [3.2808, "ft"], //피트(Feet)
//     "YD" : 	[1.0936, "yard"],  //야드(Yard)
//     "MILE" :	[0.0006, "mile"]  //마일(Mile)
// },

//단위 변환 ( L, A ^2 , V ^3 )
export const addCommas = function (nStr, gbn = "L", unitTo = "M", unitFr = "M") {
  let _unitFr = xitecloud.UNIT[unitFr][0];
  let _unitTo = xitecloud.UNIT[unitTo][0];
  let _unitStr = xitecloud.UNIT[unitTo][1];

  switch (gbn) {
    case "V":
      _unitStr += `³`;
      _unitFr = Math.pow(_unitFr, 3);
      _unitTo = Math.pow(_unitTo, 3);
      break;
    case "A":
      _unitStr += `²`;
      _unitFr = Math.pow(_unitFr, 2);
      _unitTo = Math.pow(_unitTo, 2);
      break;
    case "L":
      break;
    default:
      break;
  }

  try {
    let _n = Number(nStr);

    if (_unitFr != 1) _n /= _unitFr;

    _n /= _unitTo;

    nStr = _n + "";

    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2 + " " + _unitStr;
  } catch (e) {
    return nStr + " " + _unitStr;
  }
};

export const removeCommas = function (str) {
  return str.replace(/,/g, "");
};

export const loadBoreholeGeom = async function (project, selectedDate, dataset, _callback) {
  // return new Promise((resolve, reject) => {
  var boreScence = new THREE.Object3D();
  boreScence.name = project.project_mng_sq + "_boreholeGroup";
  var Globaltrans = xitecloud.Globaltrans;

  var optionsBore = {
    color: 0x5391af,
    //	linewidth: 10,
    //	wireframe: false,
    // transparent: true,
    // opacity: 0.9,
    //side:  THREE.DoubleSide
  };

  /* load Bore  - 시추 정보*/
  const { data } = await Axios.get("/api/loadBoreGeom", {
    params: { project_mng_sq: project.project_mng_sq, inputDate: selectedDate },
  });

  /**
   * 20200716 김신후
   * 에러 처리해야할 부분이지만,
   * 유저가 데이터 업로드 이후 전처리, 3D모델, 쿼리연산 등의 이유들로 인해
   * 오류가 발생한 것이기 때문에 데이터 자체는 화면으로 넘김
   */
  // if (!data.length) return reject(new Error())
  if (!data || !data.length) {
    dataset.title = "데이터 준비중";
    dataset.visible = false;
    dataset.dbObj = data;
    dataset._3DObject = {};

    return dataset;
  }

  var items = [];
  xitecloud.ArrColor = [];
  let sum_height = 0;
  let z_min = 0;
  let _bAddColor = true;

  for (let key = 0; key < data.length; key++) {
    let _tmp = data[key];

    let temp_x = Number(_tmp.f_x);
    let temp_y = Number(_tmp.f_y);
    let temp_z = Number(_tmp.f_z);

    if (_tmp.f_rock_num === 1) {
      //최저 z 값 찾기
      if (!z_min || z_min > temp_z - sum_height) {
        z_min = temp_z - sum_height;
      }

      sum_height = 0;

      if (key !== 0) {
        _bAddColor = false;
      }
    }

    optionsBore.color = _tmp.f_rock_type_color;

    if (_bAddColor) {
      //시추 색상으로 사이트 기본색상 설정
      //xitecloud.ArrColor[key] = _tmp.f_rock_type_color;
      xitecloud.ArrColor.push(_tmp.f_rock_type_color);
    }

    let _boreCylinderGeom = new THREE.CylinderBufferGeometry(1, 1, Number(_tmp.f_height), 32);
    // var _boreCylindermaterial = new THREE.MeshBasicMaterial(optionsBore);
    let _boreCylindermaterial = new THREE.MeshStandardMaterial(optionsBore);

    _boreCylinderGeom
      .applyMatrix(new THREE.Matrix4().makeTranslation(0, Number(_tmp.f_height) / 2, 0))
      .applyMatrix(new THREE.Matrix4().makeTranslation(0, sum_height, 0))
      .rotateX(THREE.Math.degToRad(-90))
      .applyMatrix(new THREE.Matrix4().makeTranslation(temp_x, temp_y, temp_z));

    let textGeoRock = new THREE.TextGeometry(_tmp.f_rock_type_nm, xitecloud.textGeoOption);
    textGeoRock.rotateX(THREE.Math.degToRad(90));

    let textMeshRock = new THREE.Mesh(textGeoRock, xitecloud.fontmaterials);

    textMeshRock.name = _tmp.f_bh_nm;

    textMeshRock.position.x = temp_x + Number(3 + 3 * (key % 2)); //축 좌측위치
    textMeshRock.position.y = temp_y;
    textMeshRock.position.z = temp_z - (sum_height + Number(_tmp.f_height) / 2);

    //textMeshRock.update = () => console.log('call update');
    textMeshRock.update = () => {};

    boreScence.add(textMeshRock);

    //시추공 텍스트  (루프에서 다음 값이 0:시추 첫번째일경우 시추공명 출력, 마지막 데이터일 경우)
    if (key === data.length - 1 || data[key + 1].f_rock_num === 1) {
      let textGeo = new THREE.TextGeometry(_tmp.f_bh_nm, xitecloud.textGeoOption);
      textGeo.rotateX(THREE.Math.degToRad(90));
      let textMesh1 = new THREE.Mesh(textGeo, xitecloud.fontmaterials);

      textMesh1.name = _tmp.f_bh_nm;
      textMesh1.position.x = temp_x;
      textMesh1.position.y = temp_y;
      textMesh1.position.z = temp_z + 5;

      boreScence.add(textMesh1);
    }

    if (Globaltrans && Globaltrans.length === 3)
      _boreCylinderGeom.applyMatrix(
        new THREE.Matrix4().makeTranslation(Globaltrans[0], Globaltrans[1], Globaltrans[2])
      );

    var _boreCylinder = new THREE.Mesh(_boreCylinderGeom, _boreCylindermaterial);

    sum_height += Number(_tmp.f_height);
    if (_tmp.f_height != 0) boreScence.add(_boreCylinder);
  }

  xitecloud.bore_zmin = z_min;

  window.viewer.scene.scene.add(boreScence);

  dataset.dbObj = data;
  dataset._3DObject = boreScence;

  return dataset;
};

export const makeMeasure = function (_dbAnnotationData, pickCrosspointMeasure = null, cb) {
  // let toolObj = Object.create( window.xitecloud.toolAttribute[(_dbAnnotationData.f_fence_annotation_flag).split('|')[0]] );

  const measure = new Measure();

  if (_dbAnnotationData.type === "geofence") {
    measure.type = "geofence";
  }

  measure.pickCrosspointMeasure = pickCrosspointMeasure;
  if (_dbAnnotationData.f_line_color) {
    const color = new THREE.Color(_dbAnnotationData.f_line_color);
    if (
      _dbAnnotationData.c_annotation_type === "point" ||
      _dbAnnotationData.c_annotation_type === "annotation"
    ) {
      measure.pointColor.r = color.r;
      measure.pointColor.g = color.g;
      measure.pointColor.b = color.b;
    } else {
      //line
      measure.lineColor.r = color.r;
      measure.lineColor.g = color.g;
      measure.lineColor.b = color.b;
    }
    measure.color.r = color.r;
    measure.color.g = color.g;
    measure.color.b = color.b;
  }

  if (_dbAnnotationData.f_fill_color) {
    const color = new THREE.Color(_dbAnnotationData.f_fill_color);
    //fill
    measure.faceColor.r = color.r;
    measure.faceColor.g = color.g;
    measure.faceColor.b = color.b;

    measure.color.r = color.r;
    measure.color.g = color.g;
    measure.color.b = color.b;
  }

  measure.name = _dbAnnotationData.f_fence_nm;

  //point default color -> only line or fill
  if (
    _dbAnnotationData.c_annotation_type !== "point" &&
    _dbAnnotationData.c_annotation_type !== "annotation"
  ) {
    const white = new window.THREE.Color("#ffffff");
    measure.pointColor.r = white.r;
    measure.pointColor.g = white.g;
    measure.pointColor.b = white.b;
  }

  if (_dbAnnotationData.c_annotation_type === "area") {
    measure.showDistances = false;
    measure.showArea = true;
    measure.closed = true;
  } else if (_dbAnnotationData.c_annotation_type === "line") {
    measure.showDistances = true;
    measure.showArea = false;
    measure.closed = false;
    measure.lineThickness = _dbAnnotationData.f_line_width;
  } else {
    measure.showDistances = false;
    measure.showArea = false;
    measure.closed = false;
    measure.maxMarkers = 1;
  }

  setTimeout(() => {
    for (let _geom of _dbAnnotationData.f_location.split("|")) {
      if (_geom === "") continue;

      let _points = _geom.split(",");
      measure.addMarker(
        new THREE.Vector3(Number(_points[0]), Number(_points[1]), Number(_points[2]))
      );
    }
    if (cb) cb();
  }, 0);

  // measure.update();
  window.viewer.scene.addMeasurement(measure);

  return measure;
};

export const makePotreeAnnotation = function (_dbAnnotationData) {
  let toolObj = Object.create(
    window.xitecloud.toolAttribute[_dbAnnotationData.f_fence_annotation_flag.spit("|")[0]]
  );

  let _geom = _dbAnnotationData.f_location.split("|");
  let _points = _geom[0].split(",");

  if (_points.length === 0) return;

  let _annotation = new Annotation({
    position: [Number(_points[0]), Number(_points[1]), Number(_points[2])],
    title: _dbAnnotationData.f_fence_nm,
    // ,description: `<ul><li>Click on the annotation label to move a predefined view.</li>
    // <li>Click on the icon to execute the specified action.</li>
    // In this case, the action will bring you to another scene and point cloud.</ul>`
  });

  //window.viewer.scene.addMeasurement(measure);
  window.viewer.scene.annotations.add(_annotation);

  return _annotation;
};

//ajax 옮기기
export const fnCrossectionLoad_org = async function (
  viewData,
  xitecloudViewDataSet,
  currentProject,
  _ynOpenwindow
) {
  _ynOpenwindow = _ynOpenwindow === undefined ? true : _ynOpenwindow;

  let SRID = currentProject.f_epsg;
  let DIST = 20;
  let pcdTopoItem = xitecloudViewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  );
  let targetItem = xitecloudViewDataSet.layer.target[0]; //target

  let srcTable = pcdTopoItem.dbObj.f_ply_geom_tbl_nm;
  let targetTable = targetItem.dbObj.f_geometry_tbl_nm;

  let measure = viewData.measure;

  if (viewData.measure.points.length > 1) {
    var param = "";
    var paramPop = "";

    for (var tmpi = 0; tmpi < measure.points.length; tmpi++) {
      if (tmpi !== 0) param += ",";
      if (tmpi !== 0) paramPop += ",";

      paramPop +=
        measure.points[tmpi].position.x +
        "|" +
        measure.points[tmpi].position.y +
        "|" +
        measure.points[tmpi].position.z +
        "|";

      param +=
        measure.points[tmpi].position.x +
        " " +
        measure.points[tmpi].position.y +
        " " +
        measure.points[tmpi].position.z +
        " ";
    }

    let objParam = {
      srid: SRID,
      srcTable: srcTable,
      targetTable: targetTable,
      points: param,
      dist: DIST,
      baseLength: xitecloud._BASELENGTH,
    };

    let objPopParam = {
      srid: SRID,
      srcTable: srcTable,
      targetTable: targetTable,
      points: encodeURI(paramPop),
      dist: DIST,
      baseLength: xitecloud._BASELENGTH,
    };

    if (_ynOpenwindow) {
      openCrossectionPopup(viewData, xitecloudViewDataSet, currentProject);
    }

    let _callback = function (_data, _rtnGeom) {
      viewData._3DObject = _rtnGeom;
    };

    Axios.get("/api/crosscectionLon", {
      params: objParam,
    })
      .then(({ data }) => {
        var rtnGeom = {};
        drawThreeGeoJSON(data, rtnGeom, _callback);
      })
      .catch((error) => console.log(error));
  }
};

/*  */
export const fnMakeSectionGeom = function (_data, _color, _trans) {
  if (_data === null) return new THREE.Object3D();

  let _raLineGeom = {};

  _raLineGeom.type = "Feature";
  _raLineGeom.geometry = _data;

  let _option = {
    //wireframe:false,
    //transparent: true,
    //opacity: 0.9,
    //vertexColors: 2,
    color: _color,
    side: THREE.DoubleSide,
    //blending: THREE.AdditiveBlending,
    flatShading: false,
  };

  const MaterialTopo = new THREE.MeshStandardMaterial(_option);
  MaterialTopo.flatShading = THREE.SmoothShading;

  let rtnGeom = new THREE.Object3D();

  if (Math.max(..._data.coordinates.map((item) => item[0].length)) > 6) {
    let data = _data.coordinates;
    var vertex = [];

    for (var _tmp = 0; _tmp < data.length; _tmp++) {
      let geometryLine = new THREE.Geometry();
      geometryLine.vertices = data[_tmp][0].map(
        (item) => new THREE.Vector3(item[0], item[1], item[2])
      );
      const line = new THREE.Line(geometryLine, MaterialTopo);
      rtnGeom.add(line);

      if (data[_tmp][0].length > 3) {
        let vertex = data[_tmp][0].map((item) => new THREE.Vector3(item[0], item[1], item[2]));

        let faces = [];

        for (let _i = 3; _i <= vertex.length; _i++) {
          faces.push(new THREE.Face3(0, _i - 2, _i - 1));
        }

        let geometry = new THREE.Geometry();
        geometry.vertices = vertex;
        geometry.faces = faces;

        const mesh = new THREE.Mesh(geometry, MaterialTopo);

        rtnGeom.add(mesh);
      }
    }

    // window.drawThreeGeo(
    //   _raLineGeom,
    //   10,
    //   "line",
    //   {
    //     color: _color,
    //     //0xFF0000,
    //     //linewidth: 30,
    //     //trans: xitecloud.Globaltrans,
    //     side: THREE.DoubleSide,
    //   },
    //   rtnGeom
    // );

    // rtnGeom.applyMatrix(
    //   new THREE.Matrix4().makeTranslation(
    //     xitecloud.Globaltrans[0],
    //     xitecloud.Globaltrans[1],
    //     xitecloud.Globaltrans[2]
    //   )
    // );
  } else {
    var data = _data.coordinates;

    _color = _color ? _color : xitecloud.ArrColor[0];
    _trans = _trans ? _trans : [0, 0, 0];

    var vertex = [];
    var faces = [];
    let geometry = new THREE.BufferGeometry();

    var idx = 0;

    for (var _tmp = 0; _tmp < data.length; _tmp++) {
      //폴리곤 4점
      if (data[_tmp][0].length == 4) {
        //with close point (polygon)
        //top
        vertex.push(
          new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2])
        );

        faces.push(new THREE.Face3(idx, idx + 1, idx + 2));

        idx += 3;
      }
      //폴리곤 5점
      else if (data[_tmp][0].length == 5) {
        //with close point (polygon)

        //top
        vertex.push(
          new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][3][0], data[_tmp][0][3][1], data[_tmp][0][3][2])
        );

        faces.push(new THREE.Face3(idx, idx + 1, idx + 2));
        faces.push(new THREE.Face3(idx, idx + 2, idx + 3));

        idx += 4;
      }
      //폴리곤 5점
      else if (data[_tmp][0].length == 6) {
        //with close point (polygon)

        //top
        vertex.push(
          new THREE.Vector3(data[_tmp][0][0][0], data[_tmp][0][0][1], data[_tmp][0][0][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][1][0], data[_tmp][0][1][1], data[_tmp][0][1][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][2][0], data[_tmp][0][2][1], data[_tmp][0][2][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][3][0], data[_tmp][0][3][1], data[_tmp][0][3][2])
        );

        vertex.push(
          new THREE.Vector3(data[_tmp][0][4][0], data[_tmp][0][4][1], data[_tmp][0][4][2])
        );

        faces.push(new THREE.Face3(idx, idx + 1, idx + 2));
        faces.push(new THREE.Face3(idx, idx + 2, idx + 3));
        faces.push(new THREE.Face3(idx, idx + 3, idx + 4));

        idx += 5;
      }
    }

    geometry = new THREE.Geometry();
    geometry.vertices = vertex;
    geometry.faces = faces;

    let Globaltrans = xitecloud.Globaltrans;
    if (Globaltrans && Globaltrans.length == 3)
      geometry.applyMatrix(
        new THREE.Matrix4().makeTranslation(
          Globaltrans[0] + _trans[0],
          Globaltrans[1] + _trans[1],
          Globaltrans[2] + _trans[2]
        )
      );

    geometry.computeFaceNormals();
    geometry.computeVertexNormals();
    rtnGeom = new THREE.Mesh(geometry, MaterialTopo);
  }

  return rtnGeom;
};

export const fnCrossectionLoad = function (data) {
  const _callback = () => {};
  let sec_geom = new THREE.Object3D();
  sec_geom.name = "section_geom";

  let sec_geom_lon = new THREE.Object3D();
  sec_geom_lon.name = "section_geom_lon";

  let sec_geom_lat = new THREE.Object3D();
  sec_geom_lat.name = "section_geom_lat";

  let sec_geom_baseline = new THREE.Object3D();
  sec_geom_baseline.name = "section_geom_baseline";

  sec_geom.add(sec_geom_lon);
  sec_geom.add(sec_geom_lat);
  sec_geom.add(sec_geom_baseline);

  let _txt_Annotation = new Annotation({
    position: new THREE.Vector3(0, 0, 0),
    title: "",
  });

  let _txt_Annotation_lon = new Annotation({
    position: new THREE.Vector3(0, 0, 0),
    title: "",
  });

  let _txt_Annotation_lat = new Annotation({
    position: new THREE.Vector3(0, 0, 0),
    title: "",
  });

  let maxz = null;
  let minz = null;

  let _r_sec_geom = new THREE.Object3D();
  let _r_sec_geom_str = "";

  maxz = data.t_summary.zmax;
  minz = data.t_summary.zmin;

  const annotationArr = [];
  /* 스테이션 절토 3D 폴리곤 */
  if (data.c_info) {
    data.c_info.map((item, i) => {
      let _txt = ``;
      let position;

      item.c_tin_geom.map((cGeomItem, j) => {
        let _rock = data.rock_info.filter((v) => v.gbn === cGeomItem.nxt_gbn)[0];

        let rtnGeom = fnMakeSectionGeom(cGeomItem.pl_geom_3d, _rock.f_rock_type_color);

        if (rtnGeom.geometry) {
          rtnGeom.geometry.computeBoundingSphere();
          rtnGeom.geometry.computeBoundingBox();

          maxz =
            maxz === null
              ? rtnGeom.geometry.boundingBox.max.z
              : maxz > rtnGeom.geometry.boundingBox.max.z
                ? rtnGeom.geometry.boundingBox.max.z
                : maxz;

          minz =
            minz === null
              ? rtnGeom.geometry.boundingBox.min.z
              : minz > rtnGeom.geometry.boundingBox.min.z
                ? rtnGeom.geometry.boundingBox.min.z
                : minz;

          _txt += `<br/> ${_rock.f_rock_type_nm} - ${cGeomItem.area.toFixed(
            ROUND_OFF_THE_NUMBERS_AREA
          )}m<sup>2</sup>`;

          //long
          if (item.st_no === -1) {
            position = rtnGeom.geometry.boundingSphere.center.toArray();
            sec_geom_lon.add(rtnGeom);
          } else {
            sec_geom_lat.add(rtnGeom);
          }
          //annotation 폰트 크기 및 디잔인 수정 필요

          // sec_geom.add(rtnGeom);
        } else {
          var bbox = new THREE.Box3().setFromObject(rtnGeom);

          maxz = maxz === null ? bbox.max.z : maxz > bbox.max.z ? bbox.max.z : maxz;

          minz = minz === null ? bbox.min.z : minz > bbox.min.z ? bbox.min.z : minz;

          _txt += `<br/> ${_rock.f_rock_type_nm} - ${cGeomItem.area.toFixed(
            ROUND_OFF_THE_NUMBERS_AREA
          )}m<sup>2</sup>`;

          //long
          if (item.st_no === -1) {
            position = bbox.getCenter().toArray();
            sec_geom_lon.add(rtnGeom);
          } else {
            sec_geom_lat.add(rtnGeom);
          }
        }
      });

      annotationArr.push({
        st_no: item.st_no,
        position,
        title: _txt,
      });
    });
  }

  /* 스테이션 성토 3D 폴리곤 배열 한개만 존재 */
  if (data.f_info) {
    data.f_info.map((fGeomItem) => {
      let rtnGeom = fnMakeSectionGeom(fGeomItem.f_tin_geom[0].pl_geom_3d, "#0000FF");
      let _position;

      if (rtnGeom.geometry) {
        rtnGeom.geometry.computeBoundingSphere();
        rtnGeom.geometry.computeBoundingBox();
        _position = rtnGeom.geometry.boundingSphere.center.toArray();
      } else {
        let bbox = new THREE.Box3().setFromObject(rtnGeom);
        _position = bbox.getCenter().toArray();
      }

      // let _txt = `ST+${ (item.data.ex_dist).toFixed(2)} ${item.data.f_rock_type_nm} - ${(item.data.area).toFixed(2)}`
      let _txt = `Fill ${fGeomItem.f_tin_geom[0].area.toFixed(
        ROUND_OFF_THE_NUMBERS_AREA
      )}m<sup>2</sup>`;

      //annotation 폰트 크기 및 디잔인 수정 필요
      let _progressAnnotation = new Annotation({
        position: _position,
        title: _txt,
      });

      if (fGeomItem.st_no === -1) {
        _txt_Annotation_lon.add(_progressAnnotation);
        sec_geom_lon.add(rtnGeom);
      } else {
        _txt_Annotation_lat.add(_progressAnnotation);
        sec_geom_lat.add(rtnGeom);
      }

      // _txt_Annotation.add(_progressAnnotation);
      // sec_geom_baseline.add(rtnGeom);
    });
  }

  /* 
            분석 가이드 라인 (스테이션) 
            2D 좌표로 maxz 값을 z값으로 사용한다
    */

  data.t_base.map((raLineItem) => {
    //let _raLineGeoJson = JSON.parse( _r_sec_geom_str )
    let _raLineGeom = {};

    _raLineGeom.type = "Feature";
    _raLineGeom.geometry = JSON.parse(raLineItem.ra_line_geom_t);

    window.drawThreeGeo(
      _raLineGeom,
      10,
      "line",
      {
        color: "#FF0000", //xitecloud.defaultColor.lineColor,
        trans: [0, 0, maxz],
        side: THREE.DoubleSide,
      },
      _r_sec_geom
    );

    /**
     * -1 종단, 나머지 횡단.
     */
    const stationInfomation = annotationArr.find((x) => x.st_no === raLineItem.st_no);

    const _raLineCoordinates = _raLineGeom.geometry;
    const textAnnotationOptions =
      raLineItem.st_no === -1
        ? {
            position: new THREE.Vector3(
              _raLineCoordinates.coordinates[0][0],
              _raLineCoordinates.coordinates[0][1],
              maxz
            ),
            //title: `Section Analysis Main Line`,
            title: `Longitude Analysis ${stationInfomation ? stationInfomation.title : ""}`,
          }
        : {
            position:
              stationInfomation && stationInfomation.position
                ? stationInfomation.position
                : new THREE.Vector3(
                    _raLineCoordinates.coordinates[0][0],
                    _raLineCoordinates.coordinates[0][1] + 50,
                    maxz
                  ),
            title: `ST+${
              raLineItem.c_station_name ? raLineItem.c_station_name : raLineItem.ex_dist.toFixed(2)
            } ${stationInfomation ? stationInfomation.title : ""}`,
          };

    if (raLineItem.st_no === -1) {
      _txt_Annotation_lon.add(new Annotation(textAnnotationOptions));
    } else {
      _txt_Annotation_lat.add(new Annotation(textAnnotationOptions));
    }

    //_txt_Annotation.add(new Annotation(textAnnotationOptions));

    sec_geom_baseline.add(_r_sec_geom);
  });

  let _transZ = (Math.abs(maxz - minz) > maxz ? Math.abs(maxz - minz) : maxz) / 2;
  _transZ = xitecloud.bore_zmin;

  /* 분석결과 annotation */
  fnApplyTrans(_txt_Annotation, [0, 0, _transZ]);
  fnApplyTrans(_txt_Annotation_lon, [0, 0, _transZ]);
  fnApplyTrans(_txt_Annotation_lat, [0, 0, _transZ]);

  fnApplyTrans(sec_geom, [0, 0, _transZ]);
  fnApplyTrans(sec_geom_lon, [0, 0, _transZ]);
  fnApplyTrans(sec_geom_lat, [0, 0, _transZ]);
  fnApplyTrans(sec_geom_baseline, [0, 0, _transZ]);

  // window.viewer.scene.scene.add(sec_geom);
  // window.viewer.scene.annotations.add(_txt_Annotation);

  window.viewer.scene.scene.add(sec_geom_lon);
  window.viewer.scene.scene.add(sec_geom_lat);
  window.viewer.scene.scene.add(sec_geom_baseline);

  window.viewer.scene.annotations.add(_txt_Annotation_lon);
  window.viewer.scene.annotations.add(_txt_Annotation_lat);

  return {
    _3DObject: sec_geom,
    _3DObject_lon: sec_geom_lon,
    _3DObject_lat: sec_geom_lat,
    _3DObject_baseline: sec_geom_baseline,
    annotation: _txt_Annotation,
    annotation_lon: _txt_Annotation_lon,
    annotation_lat: _txt_Annotation_lat,
  };
};

export const openCrossectionPopup = (viewData, xitecloudViewDataSet, currentProject) => {
  let SRID = currentProject.f_epsg;
  let DIST = 20;

  let pcdTopoItem = xitecloudViewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  );
  let targetItem = xitecloudViewDataSet.layer.target[0]; //target

  let srcTable = pcdTopoItem.dbObj.f_ply_geom_tbl_nm;
  let targetTable = targetItem.dbObj.f_geometry_tbl_nm;

  let measure = viewData.measure;

  if (viewData.measure.points.length > 1) {
    var param = "";
    var paramPop = "";

    for (var tmpi = 0; tmpi < measure.points.length; tmpi++) {
      if (tmpi !== 0) param += ",";
      if (tmpi !== 0) paramPop += ",";

      paramPop +=
        measure.points[tmpi].position.x +
        "|" +
        measure.points[tmpi].position.y +
        "|" +
        measure.points[tmpi].position.z +
        "|";

      param +=
        measure.points[tmpi].position.x +
        " " +
        measure.points[tmpi].position.y +
        " " +
        measure.points[tmpi].position.z +
        " ";
    }

    let objParam = {
      srid: SRID,
      srcTable: srcTable,
      targetTable: targetTable,
      points: param,
      dist: DIST,
    };

    let objPopParam = {
      srid: SRID,
      srcTable: srcTable,
      targetTable: targetTable,
      points: encodeURI(paramPop),
      dist: DIST,
    };

    window.open(
      "/crossWebgl.html?" +
        Object.entries(objPopParam)
          .map((e) => e.join("="))
          .join("&"),
      "Xitecloud-Crossection",
      "width=1300, height=900, menubar=no, status=no, toolbar=no"
    );
    //$('#profile_window').show();
  }
};

export const fnAreaGeomLoad = (viewData, _resultData) => {
  let SRID = window.xitecloud.viewDataSet.project.f_epsg;
  let DIST = 20; //station term dist

  let pcdTopoItem = window.xitecloud.viewDataSet.layer.topo.find(
    (_item) => _item.dataType === "pointcloud"
  );
  let srcTable = pcdTopoItem.dbObj;
  let boundryLayer = ""; //window.xitecloud.viewDataSet.layer.target[0].dbObj;
  let _targetBoundUse = false;
  let measure = viewData.measure;

  if (viewData.measure.points.length > 2) {
    var param = fnMakeParamFromMeasure(viewData.measure, true);

    let objParamPre = {
      srid: SRID,
      points: param,
      targetLayer: "",
      topoLayer: srcTable,
      boundryLayer: boundryLayer,
      targetBoundUse: _targetBoundUse,
    };

    const _callback = (_result) => {
      let result = _result.fnprecalc.r_result_array;

      if (measure == null) {
        measure = new Measure();

        let _points = result[0].target_boundry.split("((")[1].replace("))", "").split(",");

        for (let _pt of _points) {
          measure.addMarker(
            new THREE.Vector3(
              Number(_pt.split(" ")[0]),
              Number(_pt.split(" ")[1]),
              xitecloud.bore_zmin
            )
          );
        }
      }

      //   $('#lds-roller-container').hide();   //그려지는거 보여 줄때
      let _tmpObj = {
        area: Number(result[0].param_area).toFixed(2),
        sectorCnt: result.length,
        avg_area: Number(result[0].area_avg).toFixed(2),
      };

      let _messageStr = `Selected Area(2D): ${addCommas(_tmpObj.area, "A")} 
Divide Sector Count: ${_tmpObj.sectorCnt} (Average ${addCommas(_tmpObj.avg_area, "A")})
Calculate few Minuates
Continue?`;

      let _tmp = window.confirm(_messageStr);
      var rtnGeom = {};

      const objParam = {
        srid: SRID,
        points: param,
        sectors: result,
        srcTable: srcTable,
        measure: measure,
        viewData: viewData,
        targetBoundUse: _targetBoundUse,
        boundryLayer: boundryLayer,
      };

      if (_tmp) {
        let _callback = (data) => {
          window.xitecloud.viewDataSet.annotations[viewData.annotationGroup].push(data.viewData);
          // window.xitecloud.viewDataSet.annotations.analytics.push(data.viewData);/
          window.xitecloud.updateLayerListInComponent();
        };

        fnCalcArea(rtnGeom, objParam, _callback);
      } else {
        fnCalcAreaJob(rtnGeom, objParam, () => {});

        //viewData.measure.visible = false;
      }
    };

    fnPreCalc(objParamPre, _callback);
  }
};

export const fnCalcArea = function (rtnGeom, data, _callback) {
  //그리기 효과
  xitecloud.loaddingShow = false;

  let Globaltrans = xitecloud.Globaltrans;

  //let srcLayerName = data.srcTable.f_ply_geom_tbl_nm;
  let srcLayerName = data.srcTable;

  var arrLayergeom = [];
  var arrLayerAnnotaion = [];

  let _completeCnt = 0;
  let _errorCnt = 0;

  let totalArea = 0;

  let secCompleteCnt = 0;

  let _gCenter = new THREE.Geometry();
  _gCenter.vertices.push(
    ...data.measure.points.map((a) => {
      return a.position;
    })
  );

  _gCenter.computeBoundingSphere();
  //_gCenter.boundingSphere.center.boundingSphere.center.toArray();

  let _progressAnnotation = new Annotation({
    position: _gCenter.boundingSphere.center.toArray(),
    title: `Calculate ( 0 / ${data.sectors.length})`,
  });

  _progressAnnotation.sectorCount = data.sectors.length;
  _progressAnnotation.completeSectorCount = 0;

  window.viewer.scene.annotations.add(_progressAnnotation);

  let grpRtnGeomSec = new THREE.Group();
  grpRtnGeomSec.name = grpRtnGeomSec.uuid + "_area_" + srcLayerName;

  //그리는거 보여줄때 주석
  //grpRtnGeomSec.visible = false;

  //layer geom
  arrLayergeom.push(grpRtnGeomSec);
  window.viewer.scene.scene.add(grpRtnGeomSec);

  let _maxZ = 0;
  let _minZ = 0;

  let _layerLoadedCallback = function () {
    let layerArea = 0;

    let _secCenter = new THREE.Vector3();

    for (var _idx = 0; _idx < grpRtnGeomSec.children.length; _idx++) {
      layerArea += Number(grpRtnGeomSec.children[_idx].calc.area); //area
      grpRtnGeomSec.children[_idx].geometry.computeBoundingSphere();

      _secCenter.add(grpRtnGeomSec.children[_idx].geometry.boundingSphere.center);
    }

    _secCenter.divideScalar(grpRtnGeomSec.children.length);

    //source layer topo 추가로 암층 명은 +1
    totalArea += layerArea;

    grpRtnGeomSec.visible = true;

    //layer total voume annotation
    arrLayergeom[0].children[1].geometry.computeBoundingBox();

    let bActions = new Annotation({
      position: [
        _secCenter.x,
        _secCenter.y,
        arrLayergeom[0].children[1].geometry.boundingBox.max.z,
      ],
      title: "Total Area(3D) : " + addCommas(totalArea.toFixed(ROUND_OFF_THE_NUMBERS_AREA), "A"),
    });

    bActions.name = "totalAreaAnnotation";
    //grpRtnGeomSec.add(bActions);
    window.viewer.scene.annotations.add(bActions);

    //measure
    //김신후 수정 arr -> object
    data.viewData._3DObject = grpRtnGeomSec;
    // data.viewData._3DObject = arrLayergeom;

    arrLayerAnnotaion.push(bActions);

    data.viewData.potreeAnnotation = arrLayerAnnotaion;

    grpRtnGeomSec.visible = true;
    _progressAnnotation.visible = false;
    _progressAnnotation.dispose();

    if (_callback) _callback(data);
  };

  for (var _idxSect in data.sectors) {
    const _data = data;

    let _grpRtnGeomSec = grpRtnGeomSec;
    let _sector = data.sectors[_idxSect];
    let _point = _sector.sector_geom_t
      .replace("POLYGON", "")
      .replace("((", "")
      .replace("))", "")
      .split(",");

    let _param = {
      srcLayer: srcLayerName,
      srid: data.srid,
      points: _point.join(","), //_sector.sector_geom_t
    };

    let _cureSec = _idxSect; //현재 idx 저장

    Axios.get("/topoArea", {
      params: _param,
    })
      .then((result) => {
        data._3DObject = [];

        let calc = { area: 0 };
        let _rtnLineGeom = fnMakeLayerAreaGeom(result.data.calc_area.geom, xitecloud.ArrColor[0], [
          0,
          0,
          Math.abs(window.xitecloud.bore_zmin),
        ]);
        //let _Title = 'Total Area :' + addCommas( Number(data[1].features.sum_area).toFixed(2), 'A' );

        calc.area += result.data.calc_area.area;

        //data._3DObject.push(_rtnGeom);
        data._3DObject.push(_rtnLineGeom);

        _rtnLineGeom.name = "sec" + _cureSec;
        _rtnLineGeom.calc = calc;
        _grpRtnGeomSec.add(_rtnLineGeom);

        _progressAnnotation.completeSectorCount++;

        _progressAnnotation["title"] = `Calculate Area Progress ( ${(
          (_progressAnnotation.completeSectorCount / _progressAnnotation.sectorCount) *
          100
        ).toFixed(2)} % )`;

        if (_data.sectors.length == ++secCompleteCnt) {
          _layerLoadedCallback();
          xitecloud.loaddingShow = true;
        }
      })
      .catch((error) => {
        console.log(error);
        _errorCnt++;

        if (_data.sectors.length == ++secCompleteCnt) {
          _layerLoadedCallback();
          xitecloud.loaddingShow = true;
        }
      });
  }
};

export const fnChangeImageMap = async (idx) => {
  let layers = window.cesiumViewer.imageryLayers;

  if (layers.length > 0) {
    layers.remove(layers.get(0));
  }

  let baseLayer = layers.addImageryProvider(xitecloud.imageryProvider[idx]);
  layers.lowerToBottom(baseLayer);
};

export const fnChangeTerrainMode = (bool) => {
  xitecloud.GTerrainMode = bool;

  if (xitecloud.GTerrainMode) {
    window.cesiumViewer.terrainProvider = Cesium.createWorldTerrain();
    fnApplyTransAll(xitecloud.Globaltrans);
  } else {
    window.cesiumViewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
    fnApplyTransAll([
      -xitecloud.Globaltrans[0],
      -xitecloud.Globaltrans[1],
      -xitecloud.Globaltrans[2],
    ]);
  }
};

export const fnFlyRockLayer = (_bool, xitecloudViewDataSet, isInit) => {
  //let pcdTopoItem = window.xitecloud.viewDataSet.layer.topo.find((_item) => (_item.dataType === 'pointcloud'));
  //let _boundbox =  pcdTopoItem._3DObject.getBoundingBoxWorld()

  //trans 한 시점 부터 값이 변경됨 [전종수 2020.03.09] 초기 pointcloud 로드시 셋팅 된 값 사용
  //let _boundbox = window.viewer.getBoundingBox();

  if (!xitecloud.initTopoBound) return;
  if (xitecloud.isProcessing) {
    alert("Sorry, now Processing...");
    return;
  }

  let _transZmin = undefined;
  let _transZmax = undefined;

  _transZmax = xitecloud.initTopoBound.max.z;
  _transZmin = xitecloud.initTopoBound.min.z;

  if (xitecloud.bore_zmin) {
    _transZmin = _transZmin > xitecloud.bore_zmin ? xitecloud.bore_zmin : _transZmin;
  }

  let init = 0;
  if (!isInit) {
    init = _bool ? _transZmax - _transZmin : -(_transZmax - _transZmin);
    xitecloud.GFlyrocklayer = _bool;
    // console.log('false', xitecloud.initTopoBound)
  } else {
    // console.log('true', xitecloud.initTopoBound)
    xitecloud.GFlyrocklayer = false;
  }

  fnApplyTransAll([0, 0, init], xitecloudViewDataSet);
  //threejs scence 전체 적용 annotation 적용 필요
  //window.viewer.scene.scene.position = new THREE.Vector3([0,0, (_bool) ? _transZmax - _transZmin : -(_transZmax - _transZmin) ] );
  //window.viewer.scene.scene.position.z = (_bool) ? _transZmax - _transZmin : -(_transZmax - _transZmin);
};

// potree set view override
export const fnChangeView = (view) => {
  if (!view) return;

  switch (view) {
    case "F":
      window.viewer.setFrontView();
      break;
    case "B":
      window.viewer.setBackView();
      break;
    case "L":
      window.viewer.setLeftView();
      break;
    case "R":
      window.viewer.setRightView();
      break;
    case "T":
      window.viewer.setTopView();
      break;
    case "D":
      window.viewer.setBottomView();
      break;
  }
};

let fnApplyTrans = function (_item, _arrTrans) {
  let _position;

  if (_item instanceof THREE.Object3D) {
    _position = _item.position;
    _item.position.set(
      _position.x + _arrTrans[0],
      _position.y + _arrTrans[1],
      _position.z + _arrTrans[2]
    );
  } else if (_item instanceof Annotation) {
    try {
      _position = _item.position;
      _item.position.set(
        _position.x + _arrTrans[0],
        _position.y + _arrTrans[1],
        _position.z + _arrTrans[2]
      );
    } catch (e) {}

    _item.children.map((c_item) => {
      fnApplyTrans(c_item, _arrTrans);
    });
  }
};

// db analisys result load
export const fnLoadGeomAreaResult = (item, data) => {
  let grpRtnGeom = new THREE.Group();
  grpRtnGeom.name = "loadgeom_area_" + item.annotation_mng_sq;
  //grpRtnGeom.visible = false;

  // let  rtnGeom = fnMakeLayerVolumeGeom(data, _cur_idxLayer, [0, 0, 0]);

  let _rtnLineGeomCut = fnMakeLayerAreaGeom(item.f_result.geom, xitecloud.ArrColor[0], [
    0,
    0,
    Math.abs(window.xitecloud.bore_zmin),
  ]);

  let calc = {};

  calc.area = item.f_result.area;

  _rtnLineGeomCut.name = "area_" + item.annotation_mng_sq;
  _rtnLineGeomCut.calc = calc;

  let _secCenter;
  if (_rtnLineGeomCut.geometry) {
    _rtnLineGeomCut.geometry.computeBoundingSphere();
    _secCenter = _rtnLineGeomCut.geometry.boundingSphere.center;
  } else {
    return alert("no Result");
  }

  //layer voume annotation
  let aActions = new Annotation({
    position: [_secCenter.x, _secCenter.y, _secCenter.z],
    title: " Area : " + addCommas(Number(calc.area).toFixed(2), "V"),
  });

  grpRtnGeom.add(_rtnLineGeomCut);

  //김신후 수정 arr -> object
  // data._3DObject = [grpRtnGeom];
  data._3DObject = grpRtnGeom;
  // aActions.visible = false;
  data.potreeAnnotation = [aActions];

  window.viewer.scene.scene.add(grpRtnGeom);
  window.viewer.scene.annotations.add(aActions);

  // window.xitecloud.viewDataSet.annotations.analytics.push(data);
  // window.xitecloud.updateLayerListInComponent();
};

/**
 * 김신후 수정 버전.
 * @바뀐점
 *  Annotation이 각 레이어별에서 통합
 */
// db analisys result load
export const fnLoadGeomVolumeResult = (_item, data) => {
  let grpRtnGeom = new THREE.Group();
  data.potreeAnnotation = [];
  grpRtnGeom.name = "loadgeom_volume_" + _item.annotation_mng_sq;
  // grpRtnGeom.visible = false;

  // let  rtnGeom = fnMakeLayerVolumeGeom(data, _cur_idxLayer, [0, 0, 0]);
  let annotationTitle = "";
  let firstCenter;

  for (let i = 0; i < _item.f_result.result_cnt; i++) {
    let item = _item.f_result.data[i];

    let _rtnLineGeomCut = fnMakeLayerVolumeGeom(item.r_result, i, [
      0,
      0,
      Math.abs(window.xitecloud.bore_zmin),
    ]);

    let calc = {};

    calc.area = item.r_result.area;
    calc.vol = item.r_result.vol;
    calc.cut = item.r_result.vol_cut;
    calc.fill = item.r_result.vol_fill;

    _rtnLineGeomCut.name = "volume_" + item.srcname;
    _rtnLineGeomCut.calc = calc;

    let layerVolume = 0;
    let layerVolumeCut = 0;
    let layerVolumeFill = 0;

    layerVolume = Number(calc.vol); //volume
    layerVolumeCut = Number(calc.cut); //volume
    layerVolumeFill = Number(calc.fill); //volume

    let _secCenter;
    if (_rtnLineGeomCut.geometry) {
      _rtnLineGeomCut.geometry.computeBoundingSphere();
      _secCenter = _rtnLineGeomCut.geometry.boundingSphere.center;
    } else {
      return alert("no Result");
    }

    if (i === 0) firstCenter = _secCenter;

    //layer voume annotation
    // let aActions = new Annotation({
    //     position: [_secCenter.x, _secCenter.y, _secCenter.z],
    //     title: item.srcname + " Cut : " + addCommas((Number(calc.cut)).toFixed(2), "V")
    //         + "/ Fill : " + addCommas((Number(calc.fill)).toFixed(2), "V")
    // });
    annotationTitle += `
            <br/> ${item.srcname} (
               Cut : ${addCommas(Number(calc.cut).toFixed(2), "V")}
               Fill : ${addCommas(Number(calc.fill).toFixed(2), "V")}
            ) <br/>
        `;

    grpRtnGeom.add(_rtnLineGeomCut);
    // aActions.visible = false;
    // data.potreeAnnotation.push(aActions);
    // window.viewer.scene.annotations.add(aActions);
  }

  // annotation이 블럭을 가려서 위치 수정 21.10.08
  firstCenter.x = firstCenter.x + 200;

  let aActions = new Annotation({
    position: [firstCenter.x, firstCenter.y, firstCenter.z],
    title: annotationTitle,
  });

  data.potreeAnnotation.push(aActions);
  window.viewer.scene.annotations.add(aActions);
  data._3DObject = grpRtnGeom;
  window.viewer.scene.scene.add(grpRtnGeom);

  // window.xitecloud.viewDataSet.annotations.analytics.push(data);
  // window.xitecloud.updateLayerListInComponent();
};

// db analisys result load

export const fnLoadGeomCutFillResult = (_item, data) => {
  let grpRtnGeom = new THREE.Group();
  grpRtnGeom.name = "loadgeom_cutfill_" + _item.annotation_mng_sq;
  //grpRtnGeom.visible = false;

  data.potreeAnnotation = [];

  for (let i = 0; i < _item.f_result.result_cnt; i++) {
    let item = _item.f_result.data[i];

    let _rtnLineGeomCut = fnMakeCutFillLineGeom(item.r_result.line_geom_cut, i, 0);
    let _rtnLineGeomFill = fnMakeCutFillLineGeom(item.r_result.line_geom_fill, i, 1);

    let calc = {};

    calc.cut = Math.abs(item.r_result.vol_cut);
    calc.fill = Math.abs(item.r_result.vol_fill);

    calc.vol = calc.cut + calc.fill;

    calc.area += item.r_result.area;

    _rtnLineGeomCut.name = _item.annotation_mng_sq + "_cut_" + item.idx;
    _rtnLineGeomCut.calc = calc;

    _rtnLineGeomFill.name = _item.annotation_mng_sq + "_fill_" + item.idx;
    _rtnLineGeomFill.calc = calc;

    let layerVolume = 0;
    let layerVolumeCut = 0;
    let layerVolumeFill = 0;

    layerVolume = Number(calc.vol); //volume
    layerVolumeCut = Number(calc.cut); //volume
    layerVolumeFill = Number(calc.fill); //volume

    let _secCenter;
    if (_rtnLineGeomCut.geometry) {
      _rtnLineGeomCut.geometry.computeBoundingSphere();
      _secCenter = _rtnLineGeomCut.geometry.boundingSphere.center;
    } else if (_rtnLineGeomFill.geometry) {
      _rtnLineGeomFill.geometry.computeBoundingSphere();
      _secCenter = _rtnLineGeomFill.geometry.boundingSphere.center;
    } else {
      return alert("no Result");
    }

    //layer voume annotation
    let aActions = new Annotation({
      position: [_secCenter.x, _secCenter.y, _secCenter.z],
      title:
        " Volume : " +
        addCommas(Number(calc.cut).toFixed(2), "V") +
        " / " +
        addCommas(Number(calc.fill).toFixed(2), "V"),
    });

    //aActions.visible = false;
    grpRtnGeom.add(_rtnLineGeomCut);
    grpRtnGeom.add(_rtnLineGeomFill);
    data.potreeAnnotation.push(aActions);

    window.viewer.scene.annotations.add(aActions);
  }

  data._3DObject = grpRtnGeom;
  window.viewer.scene.scene.add(grpRtnGeom);

  window.xitecloud.viewDataSet.annotations.analytics.push(data);
  window.xitecloud.updateLayerListInComponent();
};

// Apply Global Trans
export const fnApplyTransAll = (_arrTrans, xitecloudViewDataSet) => {
  xitecloud.Globaltrans = _arrTrans;
  if (xitecloudViewDataSet) {
    let iterableCallback = (_item) =>
      (() => {
        if (_item.potreeAnnotation) {
          for (let __item of _item.potreeAnnotation) {
            fnApplyTrans(__item, _arrTrans);
          }
        }

        if (_item._3DObject instanceof Array) {
          for (let __item of _item._3DObject) {
            fnApplyTrans(__item, _arrTrans);
          }
        }

        fnApplyTrans(_item._3DObject, _arrTrans);
      })();

    _.flattenDeep(
      _.toArray(xitecloudViewDataSet).map((layOrAnnotation) => _.toArray(layOrAnnotation))
    ).map(iterableCallback);

    for (var _item of xitecloudViewDataSet.annotations.onsite) {
      fnApplyTrans(_item.measure, _arrTrans);
    }

    for (var _item of xitecloudViewDataSet.annotations.offsite) {
      fnApplyTrans(_item.measure, _arrTrans);
    }

    for (var _item of xitecloudViewDataSet.annotations.analytics) {
      fnApplyTrans(_item.measure, _arrTrans);

      if (_item._3DObject instanceof Array) {
        for (let __item of _item._3DObject) {
          fnApplyTrans(__item, _arrTrans);
        }
      } else {
        fnApplyTrans(_item._3DObject, _arrTrans);
      }

      //volume Calc result Annotaion(potree)
      if (_item.potreeAnnotation) {
        for (let __item of _item.potreeAnnotation) {
          fnApplyTrans(__item, _arrTrans);
        }
      }
    }
  }
};

function generateTexture() {
  var canvas = document.createElement("canvas");
  canvas.width = 256;
  canvas.height = 256;

  var context = canvas.getContext("2d");
  var image = context.getImageData(0, 0, 256, 256);

  var x = 0,
    y = 0;

  for (var i = 0, j = 0, l = image.data.length; i < l; i += 4, j++) {
    x = j % 256;
    y = x == 0 ? y + 1 : y;

    image.data[i] = 255;
    image.data[i + 1] = 255;
    image.data[i + 2] = 255;
    image.data[i + 3] = Math.floor(x ^ y);
  }

  context.putImageData(image, 0, 0);

  return canvas;
}

export const fnSaveScene = () => {
  // open in new window like this

  var w = window.open(
    "/report.html?project_mng_sq_t_project_mng=0&report_sq=0",
    "AnalyticsReport",
    "width=1000, height=700, menubar=no, status=no, toolbar=no"
  );
  //var w = window.open('', '');
  w.document.title = "AnalyticsReport";
  //w.document.body.style.backgroundColor = "red";

  var img = new Image();
  xitecloud.imgScreen = new Image();
  xitecloud.imgScreen.src = window.viewer.renderer.domElement.toDataURL();
  // img.src = window.viewer.renderer.domElement.toDataURL();
  //var imgCesium = new Image();
  //imgCesium.src = window.cesiumViewer._element.getElementsByTagName('canvas')[0].toDataURL()
  // w.document.body.appendChild(imgCesium);
};

function downloadBlob(blob, name = "xitecloud.dxf") {
  if (window.navigator && window.navigator.msSaveOrOpenBlob)
    return window.navigator.msSaveOrOpenBlob(blob);

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = data;
  link.download = name;

  // this is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
}

/**
 * DXF 출력 (20240725 DXF Writer 패키지 생성 로직 변경)
 * @param {*} dataItem 단면 분석 데이터
 */
export const fnDownloadSectionDXF = async (dataItem) => {
  /* DXF 형식 문자열 생성 (DXF Writer) */
  const dxfString = await makeSectionDxf(dataItem);
  const fileName = `xitecloud_${moment().format("YYYYMMDDHHmmss")}.dxf`;
  downloadBlob(new Blob([dxfString], { type: "data:application/octet-stream" }), fileName);
};

const angle = function (cx, cy, ex, ey) {
  let dy = ey - cy;
  let dx = ex - cx;
  let theta = Math.atan2(dy, dx); // range (-PI, PI]
  theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  //if (theta < 0) theta = 360 + theta; // range [0, 360)
  return theta;
};

// let dire = angle(_asset.position[0], _asset.position[1]
//     , streamData.f_longitude, streamData.f_latitude)

const toDegrees = function (cartesian3Pos) {
  let pos = Cesium.Cartographic.fromCartesian(cartesian3Pos);
  return [(pos.longitude / Math.PI) * 180, (pos.latitude / Math.PI) * 180];
};

// Cesuim 군집(Clustering) 아이콘 설정
const makeClusterPin = function (tagName, pinColor, pinSize) {
  let pinBuilder = new Cesium.PinBuilder();
  return pinBuilder.fromText(tagName, pinColor, pinSize);
};

// Cesuim 군집화(Clustering) 함수
export const fnClusteringEntities = function () {
  const dataSource = window.cesiumViewer.entities.owner;
  const clusterSet = dataSource.clustering;
  clusterSet.show = true;
  clusterSet.enabled = true;
  clusterSet.pixelRange = 80; // Clustering 시작 최소픽셀 범위
  clusterSet.minimumClusterSize = 3;

  clusterSet.clusterEvent.addEventListener(function (clusteredEntities, cluster) {
    cluster.label.show = false;
    cluster.billboard.show = true;
    cluster.billboard.id = cluster.label.id;
    cluster.billboard.verticalOrigin = Cesium.VerticalOrigin.BOTTOM;

    let clusterImage = null;
    const entitiesCount = clusteredEntities.length;

    if (entitiesCount >= 250) {
      clusterImage = makeClusterPin("250+", Cesium.Color.DARKBLUE, 50);
    } else if (entitiesCount >= 200) {
      clusterImage = makeClusterPin("200+", Cesium.Color.BROWN, 50);
    } else if (entitiesCount >= 150) {
      clusterImage = makeClusterPin("150+", Cesium.Color.DODGERBLUE, 50);
    } else if (entitiesCount >= 100) {
      clusterImage = makeClusterPin("100+", Cesium.Color.CORAL, 50);
    } else if (entitiesCount >= 50) {
      clusterImage = makeClusterPin("50+", Cesium.Color.CORNFLOWERBLUE, 50);
    } else if (entitiesCount >= 10) {
      clusterImage = makeClusterPin("10+", Cesium.Color.GOLDENROD, 50);
    } else if (entitiesCount >= 5) {
      clusterImage = makeClusterPin(`${entitiesCount}`, Cesium.Color.GOLD, 50);
    }

    if (clusterImage !== null) {
      cluster.billboard.image = clusterImage;
    } else {
      cluster.billboard.show = false;
    }
  });
};

export const getAssetModel = (asset_id) => {
  let _asset = null;
  try {
    _asset = xitecloud.AssetModels[asset_id];
  } catch (e) {
    _asset = null;
  }
  return _asset;
};

/**
 * @param  { "AST001" | "AST002" | "AST003" | "AST004" | "AST005" | "AST006" | "AST037" | "AST040" | "AST042" | "ETC" } type
 * @return {{ uri: string; initDegree: number; color: any; }}
 */
export const getModelOptionByAssetType = (type) => {
  const modelOption = {
    // 굴착기
    AST001: {
      uri: "/model/Excavator.gltf",
      initDegree: 0,
      color: Cesium.Color.RED,
      colorRgb: "#FF0000",
    },
    // 덤프트럭
    AST002: {
      uri: "/model/Dump_Truck.gltf",
      initDegree: 0,
      color: Cesium.Color.BLUE,
      colorRgb: "#0000FF",
    },
    // 도저
    AST003: {
      uri: "/model/Bulldozer.gltf",
      initDegree: 0,
      color: Cesium.Color.ORANGE,
      colorRgb: "#FFA500",
    },
    // 로더
    AST004: {
      uri: "/model/Loader.gltf",
      initDegree: 0,
      color: Cesium.Color.RED,
      colorRgb: "#FF0000",
    },
    // 롤러
    AST005: {
      uri: "/model/Roller.gltf",
      initDegree: 0,
      color: Cesium.Color.GREEN,
      colorRgb: "#008000",
    },
    // 그레이더
    AST006: {
      uri: "/model/Grader.gltf",
      initDegree: 0,
      color: Cesium.Color.ORANGE,
      colorRgb: "#FFA500",
    },
    // 전회전식 천공기
    AST037: {
      uri: "/model/Asset_ETC.gltf",
      initDegree: 0,
      color: Cesium.Color.LIME,
      colorRgb: "#00FF00",
    },
    // 진공흡입 준설차
    AST040: {
      uri: "/model/Asset_ETC.gltf",
      initDegree: 0,
      color: Cesium.Color.LIME,
      colorRgb: "#00FF00",
    },
    // 살수차
    AST042: {
      uri: "/model/Asset_ETC.gltf",
      initDegree: 0,
      color: Cesium.Color.LIME,
      colorRgb: "#00FF00",
    },
    ETC: {
      uri: "/model/Asset_ETC.gltf",
      initDegree: 0,
      color: Cesium.Color.LIME,
      colorRgb: "#00FF00",
    },
  };

  return modelOption[type] ?? modelOption["ETC"];
};

export const removeTimeOutEntity = () => {
  if (!xitecloud.AssetModels) return;

  const keys = Object.keys(xitecloud.AssetModels);
  const timeout = 60 * 20;

  let removeKeys = [];
  const unixTime = moment().unix() - timeout;
  keys.map((key) => {
    let _asset = getAssetModel(key);
    if (_asset) {
      const show = Number(_asset.name) >= unixTime;
      if (!show) {
        _asset.show = show;
        removeKeys.push(key);
      }
    }
  });
  return removeKeys;
};

export const changeAssetState = (entity, isShowOnlyPoint, isShowAssetName) => {
  entity.model.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(
    0,
    isShowOnlyPoint ? 0 : 3000
  );
  entity.label.distanceDisplayCondition = new Cesium.DistanceDisplayCondition(
    0,
    isShowAssetName ? 3000 : 0
  );
  entity.billboard.distanceDisplayCondition = isShowOnlyPoint
    ? new Cesium.DistanceDisplayCondition(0, Number.MAX_VALUE)
    : new Cesium.DistanceDisplayCondition(3000, Number.MAX_VALUE);
};

export const changeRealTimeAssetState = (showAsset) => {
  const checkString = `rt_asset_`;
  window.cesiumViewer.entities.values.forEach((entity) => {
    if (entity.id.indexOf(checkString) > -1) {
      changeAssetState(entity, showAsset.isShowOnlyPoint, showAsset.isShowAssetName);
    }
  });
};

export const changeSelectedAsset = (keys, isShow = true) => {
  xitecloud.SelectedKeys = keys;

  const tempKeys = keys.filter((x) => x).map((x) => x.toString());

  const checkString = `rt_asset_`;
  window.cesiumViewer.entities.values.forEach((entity) => {
    if (entity.id.indexOf(checkString) > -1) {
      const id = entity.id.replace(checkString, "");
      const isInclude = tempKeys.includes(id);
      entity.show = isInclude ? isShow : !isShow;
    }
  });
};

export const getSvg = (type, color) => {
  const colorEncode = encodeURIComponent(color);
  const strokeColor = encodeURIComponent("#000000");
  const strokeWidth = 1;
  let svgText = ``;

  const width = 28;
  const height = 28;

  /**
   * URL-encoder for SVG
   * @link https://yoksel.github.io/url-encoder/
   */
  switch (type) {
    case "AST001":
      // 굴착기
      svgText = `data:image/svg+xml,%3Csvg width='30' height='25' viewBox='0 0 30 25' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128307)'%3E%3Cmask id='path-1-outside-1_2374_128307' maskUnits='userSpaceOnUse' x='-1' y='0' width='31' height='25' fill='black'%3E%3Crect fill='white' x='-1' width='31' height='25'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M29 20.1667C29 19.5789 28.5654 19.0927 28 19.0118V14L26 12H24V10L22 8H17L11 1H7.5L1.0026 17.0729L5 22L10 19V17H7L6 15L10 7L13 11V19H12.1667C11.5223 19 11 19.5223 11 20.1667V22.8333C11 23.4777 11.5223 24 12.1667 24H27.8333C28.4777 24 29 23.4777 29 22.8333V20.1667Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M29 20.1667C29 19.5789 28.5654 19.0927 28 19.0118V14L26 12H24V10L22 8H17L11 1H7.5L1.0026 17.0729L5 22L10 19V17H7L6 15L10 7L13 11V19H12.1667C11.5223 19 11 19.5223 11 20.1667V22.8333C11 23.4777 11.5223 24 12.1667 24H27.8333C28.4777 24 29 23.4777 29 22.8333V20.1667Z' fill='black'/%3E%3Cpath d='M28 19.0118L27.8584 20.0017L27 19.879V19.0118H28ZM28 14L28.7071 13.2929L29 13.5858V14H28ZM26 12V11H26.4142L26.7071 11.2929L26 12ZM24 12V13H23V12H24ZM24 10L24.7071 9.29289L25 9.58579V10H24ZM22 8V7H22.4142L22.7071 7.29289L22 8ZM17 8V9H16.5401L16.2407 8.65079L17 8ZM11 1V0H11.4599L11.7593 0.349209L11 1ZM7.5 1L6.57289 0.625219L6.82563 0H7.5V1ZM1.0026 17.0729L0.226036 17.703L-0.145555 17.2449L0.0754883 16.6981L1.0026 17.0729ZM5 22L5.5145 22.8575L4.77026 23.304L4.22343 22.63L5 22ZM10 19H11V19.5662L10.5145 19.8575L10 19ZM10 17V16H11V17H10ZM7 17V18H6.38197L6.10557 17.4472L7 17ZM6 15L5.10557 15.4472L4.88197 15L5.10557 14.5528L6 15ZM10 7L9.10557 6.55279L9.82918 5.10557L10.8 6.4L10 7ZM13 11L13.8 10.4L14 10.6667V11H13ZM13 19H14V20H13V19ZM28.1416 18.0219C29.1925 18.1722 30 19.0743 30 20.1667H28C28 20.0836 27.9382 20.0132 27.8584 20.0017L28.1416 18.0219ZM29 14V19.0118H27V14H29ZM26.7071 11.2929L28.7071 13.2929L27.2929 14.7071L25.2929 12.7071L26.7071 11.2929ZM24 11H26V13H24V11ZM25 10V12H23V10H25ZM22.7071 7.29289L24.7071 9.29289L23.2929 10.7071L21.2929 8.70711L22.7071 7.29289ZM17 7H22V9H17V7ZM11.7593 0.349209L17.7593 7.34921L16.2407 8.65079L10.2407 1.65079L11.7593 0.349209ZM7.5 0H11V2H7.5V0ZM0.0754883 16.6981L6.57289 0.625219L8.42711 1.37478L1.92971 17.4477L0.0754883 16.6981ZM4.22343 22.63L0.226036 17.703L1.77917 16.4429L5.77657 21.37L4.22343 22.63ZM10.5145 19.8575L5.5145 22.8575L4.4855 21.1425L9.4855 18.1425L10.5145 
      19.8575ZM11 17V19H9V17H11ZM7 16H10V18H7V16ZM6.89443 14.5528L7.89443 16.5528L6.10557 17.4472L5.10557 15.4472L6.89443 14.5528ZM10.8944 7.44721L6.89443 15.4472L5.10557 14.5528L9.10557 6.55279L10.8944 7.44721ZM12.2 11.6L9.2 7.6L10.8 6.4L13.8 10.4L12.2 11.6ZM12 19V11H14V19H12ZM12.1667 18H13V20H12.1667V18ZM10 20.1667C10 18.9701 10.9701 18 12.1667 18V20C12.0746 20 12 20.0746 12 20.1667H10ZM10 22.8333V20.1667H12V22.8333H10ZM12.1667 25C10.9701 25 10 24.0299 10 22.8333H12C12 22.9254 12.0746 23 12.1667 23V25ZM27.8333 25H12.1667V23H27.8333V25ZM30 22.8333C30 24.0299 29.03 25 27.8333 25V23C27.9254 23 28 22.9254 28 22.8333H30ZM30 20.1667V22.8333H28V20.1667H30Z' fill='white' mask='url(%23path-1-outside-1_2374_128307)'/%3E%3Cpath d='M13.4 10.7L13.5 10.8333V11V19.8221L27.5 19.511V14.2071L25.7929 12.5H24H23.5V12V10.2071L21.7929 8.5H17H16.77L16.6204 8.3254L10.77 1.5H7.83718L1.57668 16.9869L5.11487 21.348L9.5 18.7169V17.5H7H6.69098L6.55279 17.2236L5.55279 15.2236L5.44098 15L5.55279 14.7764L9.55279 6.77639L9.91459 6.05279L10.4 6.7L13.4 10.7Z' fill='inherit' stroke='black'/%3E%3Cpath d='M11.5 20.1667V22.8333C11.5 23.2015 11.7985 23.5 12.1667 23.5H27.8333C28.2015 23.5 28.5 23.2015 28.5 22.8333V20.1667C28.5 19.7985 28.2015 19.5 27.8333 19.5H24.2H12.1667C11.7985 19.5 11.5 19.7985 11.5 20.1667Z' fill='inherit' stroke='black'/%3E%3Cpath d='M18 14H22V11L21 10H18V14Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128307'%3E%3Crect width='30' height='25' fill='white' transform='matrix(-1 0 0 1 30 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST002":
      // 덤프
      svgText = `data:image/svg+xml,%3Csvg width='26' height='22' viewBox='0 0 26 22' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128375)'%3E%3Cmask id='path-1-outside-1_2374_128375' maskUnits='userSpaceOnUse' x='0' y='0' width='26' height='22' fill='black'%3E%3Crect fill='white' width='26' height='22'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M25 14V13V3H12L10 1H6V4H3L1 6V18H4C4.00005 19.6568 5.34318 20.9998 7 20.9998C8.65682 20.9998 9.99995 19.6568 10 18H15C15 19.6568 16.3432 20.9998 18 20.9998C19.6568 20.9998 21 19.6568 21 18H25V14Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M25 14V13V3H12L10 1H6V4H3L1 6V18H4C4.00005 19.6568 5.34318 20.9998 7 20.9998C8.65682 20.9998 9.99995 19.6568 10 18H15C15 19.6568 16.3432 20.9998 18 20.9998C19.6568 20.9998 21 19.6568 21 18H25V14Z' fill='black'/%3E%3Cpath d='M25 3H26V2H25V3ZM12 3L11.2929 3.70711L11.5858 4H12V3ZM10 1L10.7071 0.292893L10.4142 0H10V1ZM6 1V0H5V1H6ZM6 4V5H7V4H6ZM3 4V3H2.58579L2.29289 3.29289L3 4ZM1 6L0.292893 5.29289L0 5.58579V6H1ZM1 18H0V19H1V18ZM4 18L5 18L4.99997 17H4V18ZM10 18V17H9.00003L9 18L10 18ZM15 18L16 18L16 17H15V18ZM21 18V17H20L20 18L21 18ZM25 18V19H26V18H25ZM24 13V14H26V13H24ZM24 3V13H26V3H24ZM12 4H25V2H12V4ZM9.29289 1.70711L11.2929 3.70711L12.7071 2.29289L10.7071 0.292893L9.29289 1.70711ZM6 2H10V0H6V2ZM7 4V1H5V4H7ZM3 5H6V3H3V5ZM1.70711 6.70711L3.70711 4.70711L2.29289 3.29289L0.292893 5.29289L1.70711 6.70711ZM2 18V6H0V18H2ZM4 17H1V19H4V17ZM7 19.9998C5.89542 19.9998 5.00003 19.1044 5 18L3 18C3.00007 20.2091 4.79093 21.9998 7 21.9998V19.9998ZM9 18C8.99997 19.1044 8.10458 19.9998 7 19.9998V21.9998C9.20907 21.9998 10.9999 20.2091 11 18L9 18ZM15 17H10V19H15V17ZM18 19.9998C16.8954 19.9998 16 19.1044 16 18L14 18C14.0001 20.2091 15.7909 21.9998 18 21.9998V19.9998ZM20 18C20 19.1044 19.1046 19.9998 18 19.9998V21.9998C20.2091 21.9998 21.9999 20.2091 22 18L20 18ZM25 17H21V19H25V17ZM24 14V18H26V14H24Z' fill='white' mask='url(%23path-1-outside-1_2374_128375)'/%3E%3Cmask id='path-3-inside-2_2374_128375' fill='white'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 4H3L1 6V18H7H9H25V13H9V4Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 4H3L1 6V18H7H9H25V13H9V4Z' fill='inherit'/%3E%3Cpath d='M3 4V3H2.58579L2.29289 3.29289L3 4ZM9 4H10V3H9V4ZM1 6L0.292893 5.29289L0 5.58579V6H1ZM1 18H0V19H1V18ZM25 18V19H26V18H25ZM25 13H26V12H25V13ZM9 13H8V14H9V13ZM3 
      5H9V3H3V5ZM1.70711 6.70711L3.70711 4.70711L2.29289 3.29289L0.292893 5.29289L1.70711 6.70711ZM2 18V6H0V18H2ZM7 17H1V19H7V17ZM9 17H7V19H9V17ZM25 17H9V19H25V17ZM24 13V18H26V13H24ZM9 14H25V12H9V14ZM8 4V13H10V4H8Z' fill='black' mask='url(%23path-3-inside-2_2374_128375)'/%3E%3Cpath d='M6 10H3V7.06448L4.06452 6H6V10Z' fill='black'/%3E%3Cpath d='M9.5 17.9999C9.5 19.3806 8.38073 20.4998 7 20.4998C5.61927 20.4998 4.5 19.3806 4.5 17.9999C4.5 16.6193 5.61927 15.5 7 15.5C8.38073 15.5 9.5 16.6193 9.5 17.9999Z' fill='inherit' stroke='black'/%3E%3Cpath d='M20.5 17.9999C20.5 19.3806 19.3807 20.4998 18 20.4998C16.6193 20.4998 15.5 19.3806 15.5 17.9999C15.5 16.6193 16.6193 15.5 18 15.5C19.3807 15.5 20.5 16.6193 20.5 17.9999Z' fill='inherit' stroke='black'/%3E%3Cpath d='M7.88889 4.5H8.38889V5V13.5H24.5V3.5H12H11.7929L11.6464 3.35355L9.79289 1.5H6.5V4.5H7.88889Z' fill='inherit' stroke='black'/%3E%3Crect x='12' y='6' width='1' height='5' fill='black'/%3E%3Crect x='16' y='6' width='1' height='5' fill='black'/%3E%3Crect x='20' y='6' width='1' height='5' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128375'%3E%3Crect width='26' height='22' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST003":
      // 도저
      svgText = `data:image/svg+xml,%3Csvg width='34' height='20' viewBox='0 0 34 20' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128421)'%3E%3Cmask id='path-1-outside-1_2374_128421' maskUnits='userSpaceOnUse' x='-1' y='0' width='35' height='20' fill='black'%3E%3Crect fill='white' x='-1' width='35' height='20'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M27 1V5H29L31 7V14H31.75C32.4404 14 33 14.5596 33 15.25V17.75C33 18.4404 32.4404 19 31.75 19H14.25C13.5596 19 13 18.4404 13 17.75V15.25C13 14.5596 13.5596 14 14.25 14H15V13H11V17L9 19H3L1 16.5L4 15L6 6L4 3H9L11 5V10H15V9L17 7H19V3L21 1H27Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M27 1V5H29L31 7V14H31.75C32.4404 14 33 14.5596 33 15.25V17.75C33 18.4404 32.4404 19 31.75 19H14.25C13.5596 19 13 18.4404 13 17.75V15.25C13 14.5596 13.5596 14 14.25 14H15V13H11V17L9 19H3L1 16.5L4 15L6 6L4 3H9L11 5V10H15V9L17 7H19V3L21 1H27Z' fill='black'/%3E%3Cpath d='M27 5V6H26V5H27ZM27 1V0H28V1H27ZM29 5V4H29.4142L29.7071 4.29289L29 5ZM31 7L31.7071 6.29289L32 6.58579V7H31ZM31 14V15H30V14H31ZM15 14H16V15H15V14ZM15 13V12H16V13H15ZM11 13H10V12H11V13ZM11 17H12V17.4142L11.7071 17.7071L11 17ZM9 19L9.70711 19.7071L9.41421 20H9V19ZM3 19V20H2.51938L2.21913 19.6247L3 19ZM1 16.5L0.219131 17.1247L-0.553609 16.1588L0.552786 15.6056L1 16.5ZM4 15L4.97619 15.2169L4.87293 15.6816L4.44721 15.8944L4 15ZM6 6L6.83205 5.4453L7.06876 5.80036L6.97619 6.21693L6 6ZM4 3L3.16795 3.5547L2.13148 2H4V3ZM9 3V2H9.41421L9.70711 2.29289L9 3ZM11 5L11.7071 4.29289L12 4.58579V5H11ZM11 10V11H10V10H11ZM15 10H16V11H15V10ZM15 9H14V8.58579L14.2929 8.29289L15 9ZM17 7L16.2929 6.29289L16.5858 6H17V7ZM19 7H20V8H19V7ZM19 3H18V2.58579L18.2929 2.29289L19 3ZM21 1L20.2929 0.292893L20.5858 0H21V1ZM26 5V1H28V5H26ZM29 6H27V4H29V6ZM30.2929 7.70711L28.2929 5.70711L29.7071 4.29289L31.7071 6.29289L30.2929 7.70711ZM30 14V7H32V14H30ZM31.75 15H31V13H31.75V15ZM32 15.25C32 15.1119 31.8881 15 31.75 15V13C32.9926 13 34 14.0074 34 15.25H32ZM32 17.75V15.25H34V17.75H32ZM31.75 18C31.8881 18 32 17.8881 32 17.75H34C34 18.9926 32.9926 20 31.75 20V18ZM14.25 18H31.75V20H14.25V18ZM14 17.75C14 17.8881 14.1119 18 14.25 18V20C13.0074 20 12 18.9926 12 17.75H14ZM14 15.25V17.75H12V15.25H14ZM14.25 15C14.1119 15 14 15.1119 14 15.25H12C12 14.0074 13.0074 13 14.25 13V15ZM15 15H14.25V13H15V15ZM16 13V14H14V13H16ZM11 12H15V14H11V12ZM10 17V13H12V17H10ZM8.29289 18.2929L10.2929 
      16.2929L11.7071 17.7071L9.70711 19.7071L8.29289 18.2929ZM3 18H9V20H3V18ZM1.78087 15.8753L3.78087 18.3753L2.21913 19.6247L0.219131 17.1247L1.78087 15.8753ZM4.44721 15.8944L1.44721 17.3944L0.552786 15.6056L3.55279 14.1056L4.44721 15.8944ZM6.97619 6.21693L4.97619 15.2169L3.02381 14.7831L5.02381 5.78307L6.97619 6.21693ZM4.83205 2.4453L6.83205 5.4453L5.16795 6.5547L3.16795 3.5547L4.83205 2.4453ZM9 4H4V2H9V4ZM10.2929 5.70711L8.29289 3.70711L9.70711 2.29289L11.7071 4.29289L10.2929 5.70711ZM10 10V5H12V10H10ZM15 11H11V9H15V11ZM16 9V10H14V9H16ZM17.7071 7.70711L15.7071 9.70711L14.2929 8.29289L16.2929 6.29289L17.7071 7.70711ZM19 8H17V6H19V8ZM20 3V7H18V3H20ZM21.7071 1.70711L19.7071 3.70711L18.2929 2.29289L20.2929 0.292893L21.7071 1.70711ZM27 2H21V0H27V2Z' fill='white' mask='url(%23path-1-outside-1_2374_128421)'/%3E%3Cpath d='M26.5 5V5.5H27H28.7929L30.5 7.20711V14.5H15.5V9.20711L17.2071 7.5H19H19.5V7V3.20711L21.2071 1.5H26.5V5Z' fill='inherit' stroke='black'/%3E%3Cpath d='M4.93426 3.5H8.79289L10.5 5.20711V16.7929L8.79289 18.5H3.24031L1.7768 16.6706L4.22361 15.4472L4.43647 15.3408L4.48809 15.1085L6.48809 6.10847L6.53438 5.90018L6.41603 5.72265L4.93426 3.5Z' fill='inherit' stroke='black'/%3E%3Cpath d='M32.5 15.25V17.75C32.5 18.1642 32.1642 18.5 31.75 18.5H14.25C13.8358 18.5 13.5 18.1642 13.5 17.75V15.25C13.5 14.8358 13.8358 14.5 14.25 14.5H27.6667H31.75C32.1642 14.5 32.5 14.8358 32.5 15.25Z' fill='inherit' stroke='black'/%3E%3Crect x='10.5' y='10.5' width='5' height='2' fill='inherit' stroke='black'/%3E%3Cpath d='M24 7H21V4L22 3H24V7Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128421'%3E%3Crect width='34' height='20' fill='white' transform='matrix(-1 0 0 1 34 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST004":
      // 로더
      svgText = `data:image/svg+xml,%3Csvg width='32' height='23' viewBox='0 0 32 23' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5 9H12L14 12V15.3368C12.8175 15.8984 12 17.1034 12 18.4994C12 20.432 13.567 21.9987 15.5 21.9987C17.263 21.9987 18.7215 20.6955 18.9644 19H21.0356C21.2785 20.6955 22.737 21.9987 24.5 21.9987C26.263 21.9987 27.7215 20.6955 27.9645 19H29L31 17V11L29 9H26V4.00282H20L18 6.27555V9.00282H17L14 5H11V3L10 1H7.5V3L4.5 7L2.5 6L1.5 7V9L3.5 11H9.5L10.5 9Z' fill='black'/%3E%3Cpath d='M12 9V8.5H12.2676L12.416 8.72265L12 9ZM10.5 9L10.0528 8.77639L10.191 8.5H10.5V9ZM14 12L14.416 11.7226L14.5 11.8486V12H14ZM14 15.3368H14.5V15.6528L14.2145 15.7884L14 15.3368ZM18.9644 19L18.4695 18.9291L18.531 18.5H18.9644V19ZM21.0356 19V18.5H21.469L21.5305 18.9291L21.0356 19ZM27.9645 19L27.4695 18.9291L27.531 18.5H27.9645V19ZM29 19L29.3536 19.3536L29.2071 19.5H29V19ZM31 17H31.5V17.2071L31.3536 17.3536L31 17ZM31 11L31.3536 10.6464L31.5 10.7929V11H31ZM29 9V8.5H29.2071L29.3536 8.64645L29 9ZM26 9V9.5H25.5V9H26ZM26 4.00282V3.50282H26.5V4.00282H26ZM20 4.00282L19.6246 3.67251L19.774 3.50282H20V4.00282ZM18 6.27555H17.5V6.08687L17.6246 5.94523L18 6.27555ZM18 9.00282H18.5V9.50282H18V9.00282ZM17 9.00282V9.50282H16.7499L16.5999 9.30268L17 9.00282ZM14 5V4.5H14.2501L14.4001 4.70014L14 5ZM11 5V5.5H10.5V5H11ZM11 3L11.4472 2.77639L11.5 2.88197V3H11ZM10 1V0.5H10.309L10.4472 0.776393L10 1ZM7.5 1H7V0.5H7.5V1ZM7.5 3H8V3.16667L7.9 3.3L7.5 3ZM4.5 7L4.9 7.3L4.64963 7.63383L4.27639 7.44721L4.5 7ZM2.5 6L2.14645 5.64645L2.40127 5.39162L2.72361 5.55279L2.5 6ZM1.5 7H1V6.79289L1.14645 6.64645L1.5 7ZM1.5 9L1.14645 9.35355L1 9.20711V9H1.5ZM3.5 11V11.5H3.29289L3.14645 11.3536L3.5 11ZM9.5 11L9.94721 11.2236L9.80902 11.5H9.5V11ZM12 9.5H10.5V8.5H12V9.5ZM13.584 12.2774L11.584 9.27735L12.416 8.72265L14.416 11.7226L13.584 12.2774ZM13.5 15.3368V12H14.5V15.3368H13.5ZM11.5 18.4994C11.5 16.9032 12.4353 15.5264 13.7855 14.8851L14.2145 15.7884C13.1998 16.2704 12.5 17.3037 12.5 18.4994H11.5ZM15.5 22.4987C13.2909 22.4987 11.5 20.7082 11.5 18.4994H12.5C12.5 20.1558 13.8431 21.4987 15.5 21.4987V22.4987ZM19.4594 19.0709C19.1817 21.0092 17.5152 22.4987 15.5 22.4987V21.4987C17.0108 21.4987 18.2614 20.3818 18.4695 18.9291L19.4594 19.0709ZM21.0356 19.5H18.9644V18.5H21.0356V19.5ZM24.5 22.4987C22.4848 22.4987 20.8183 21.0092 20.5406 19.0709L21.5305 18.9291C21.7386 20.3818 22.9892 21.4987 24.5 
      21.4987V22.4987ZM28.4594 19.0709C28.1817 21.0092 26.5152 22.4987 24.5 22.4987V21.4987C26.0108 21.4987 27.2614 20.3818 27.4695 18.9291L28.4594 19.0709ZM29 19.5H27.9645V18.5H29V19.5ZM31.3536 17.3536L29.3536 19.3536L28.6464 18.6464L30.6464 16.6464L31.3536 17.3536ZM31.5 11V17H30.5V11H31.5ZM29.3536 8.64645L31.3536 10.6464L30.6464 11.3536L28.6464 9.35355L29.3536 8.64645ZM26 8.5H29V9.5H26V8.5ZM26.5 4.00282V9H25.5V4.00282H26.5ZM20 3.50282H26V4.50282H20V3.50282ZM17.6246 5.94523L19.6246 3.67251L20.3754 4.33313L18.3754 6.60586L17.6246 5.94523ZM17.5 9.00282V6.27555H18.5V9.00282H17.5ZM17 8.50282H18V9.50282H17V8.50282ZM14.4001 4.70014L17.4001 8.70295L16.5999 9.30268L13.5999 5.29986L14.4001 4.70014ZM11 4.5H14V5.5H11V4.5ZM11.5 3V5H10.5V3H11.5ZM10.4472 0.776393L11.4472 2.77639L10.5528 3.22361L9.55279 1.22361L10.4472 0.776393ZM7.5 0.5H10V1.5H7.5V0.5ZM7 3V1H8V3H7ZM4.1 6.7L7.1 2.7L7.9 3.3L4.9 7.3L4.1 6.7ZM2.72361 5.55279L4.72361 6.55279L4.27639 7.44721L2.27639 6.44721L2.72361 5.55279ZM1.14645 6.64645L2.14645 5.64645L2.85355 6.35355L1.85355 7.35355L1.14645 6.64645ZM1 9V7H2V9H1ZM3.14645 11.3536L1.14645 9.35355L1.85355 8.64645L3.85355 10.6464L3.14645 11.3536ZM9.5 11.5H3.5V10.5H9.5V11.5ZM10.9472 9.22361L9.94721 11.2236L9.05279 10.7764L10.0528 8.77639L10.9472 9.22361Z' fill='white'/%3E%3Cpath d='M10.5 8.5H10.191L10.0528 8.77639L9.19098 10.5H3.70711L2 8.79289V7.20711L2.59873 6.60838L4.27639 7.44721L4.64963 7.63383L4.9 7.3L7.9 3.3L8 3.16667V3V1.5H9.69098L10.5 3.11803V5V5.5H11H13.7499L16.5999 9.30268L16.7499 9.50282H17H18H18.5V9.00282V6.46422L20.226 4.50282H25.5V9V9.5H26H28.7929L30.5 11.2071V16.7929L28.7929 18.5H14.5V12V11.8486L14.416 11.7226L12.416 8.72265L12.2676 8.5H12H10.5Z' fill='inherit' stroke='black'/%3E%3Cpath d='M18.5 18.4994C18.5 20.1558 17.1569 21.4987 15.5 21.4987C13.8431 21.4987 12.5 20.1558 12.5 18.4994C12.5 16.8429 13.8431 15.5 15.5 15.5C17.1569 15.5 18.5 16.8429 18.5 18.4994Z' fill='inherit' stroke='black'/%3E%3Cpath d='M27.5 18.4994C27.5 20.1558 26.1569 21.4987 24.5 21.4987C22.8431 21.4987 21.5 20.1558 21.5 18.4994C21.5 16.8429 22.8431 15.5 24.5 15.5C26.1569 15.5 27.5 16.8429 27.5 18.4994Z' fill='inherit' stroke='black'/%3E%3Cpath d='M23 10H20V6.91875L20.9189 6H23V10Z' fill='black'/%3E%3C/svg%3E%0A`;
      break;
    case "AST005":
      // 롤러
      svgText = `data:image/svg+xml,%3Csvg width='31' height='23' viewBox='0 0 31 23' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128293)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M26 1H20L18 3V12H16.748C15.8599 8.54955 12.7277 6 9 6C5.27232 6 2.14012 8.54955 1.25204 12H1V14V16H1.25204C2.14012 19.4505 5.27232 22 9 22C12.7277 22 15.8599 19.4505 16.748 16H18L20 18C20 20.2091 21.7909 22 24 22C26.2091 22 28 20.2091 28 18L30 15.5312V8H26V1Z' fill='black'/%3E%3Cpath d='M20 1L19.6464 0.646447L19.7929 0.5H20V1ZM26 1V0.5H26.5V1H26ZM18 3H17.5V2.79289L17.6464 2.64645L18 3ZM18 12H18.5V12.5H18V12ZM16.748 12V12.5H16.3604L16.2637 12.1246L16.748 12ZM1.25204 12L1.73625 12.1246L1.63964 12.5H1.25204V12ZM1 12H0.5V11.5H1V12ZM1 16V16.5H0.5V16H1ZM1.25204 16V15.5H1.63964L1.73625 15.8754L1.25204 16ZM16.748 16L16.2637 15.8754L16.3604 15.5H16.748V16ZM18 16V15.5H18.2071L18.3536 15.6464L18 16ZM20 18L20.3536 17.6464L20.5 17.7929V18H20ZM28 18H27.5V17.8229L27.6115 17.6853L28 18ZM30 15.5312H30.5V15.7084L30.3885 15.846L30 15.5312ZM30 8V7.5H30.5V8H30ZM26 8V8.5H25.5V8H26ZM20 0.5H26V1.5H20V0.5ZM17.6464 2.64645L19.6464 0.646447L20.3536 1.35355L18.3536 3.35355L17.6464 2.64645ZM17.5 12V3H18.5V12H17.5ZM16.748 11.5H18V12.5H16.748V11.5ZM9 5.5C12.9613 5.5 16.2886 8.20937 17.2322 11.8754L16.2637 12.1246C15.4311 8.88972 12.494 6.5 9 6.5V5.5ZM0.767817 11.8754C1.71138 8.20937 5.03866 5.5 9 5.5V6.5C5.50599 6.5 2.56886 8.88972 1.73625 12.1246L0.767817 11.8754ZM1 11.5H1.25204V12.5H1V11.5ZM0.5 14V12H1.5V14H0.5ZM0.5 16V14H1.5V16H0.5ZM1.25204 16.5H1V15.5H1.25204V16.5ZM9 22.5C5.03866 22.5 1.71138 19.7906 0.767817 16.1246L1.73625 15.8754C2.56886 19.1103 5.50599 21.5 9 21.5V22.5ZM17.2322 16.1246C16.2886 19.7906 12.9613 22.5 9 22.5V21.5C12.494 21.5 15.4311 19.1103 16.2637 15.8754L17.2322 16.1246ZM18 16.5H16.748V15.5H18V16.5ZM19.6464 18.3536L17.6464 16.3536L18.3536 15.6464L20.3536 17.6464L19.6464 18.3536ZM24 22.5C21.5147 22.5 19.5 20.4853 19.5 18H20.5C20.5 19.933 22.067 21.5 24 21.5V22.5ZM28.5 18C28.5 20.4853 26.4853 22.5 24 22.5V21.5C25.933 21.5 27.5 19.933 27.5 18H28.5ZM30.3885 15.846L28.3885 18.3147L27.6115 17.6853L29.6115 15.2165L30.3885 15.846ZM30.5 8V15.5312H29.5V8H30.5ZM26 7.5H30V8.5H26V7.5ZM26.5 1V8H25.5V1H26.5Z' fill='white'/%3E%3Ccircle cx='9' cy='14' r='7.5' fill='inherit' stroke='black'/%3E%3Ccircle cx='9' cy='14' r='2.5' fill='black' stroke='black'/%3E%3Cpath d='M20.2071 
      1.5H25.5V8V8.5H26H29.5V15.3541L27.7616 17.5H20.2071L18.3536 15.6464L18.2071 15.5H18H1.5V12.5H18H18.5V12V3.20711L20.2071 1.5Z' fill='inherit' stroke='black'/%3E%3Ccircle cx='24' cy='18' r='3.5' fill='inherit' stroke='black'/%3E%3Cpath d='M23 7H20V4L21 3H23V7Z' fill='black'/%3E%3Crect x='25' y='9' width='1' height='6' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128293'%3E%3Crect width='31' height='23' fill='white' transform='matrix(-1 0 0 1 31 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST006":
      // 그레이더
      svgText = `data:image/svg+xml,%3Csvg width='29' height='23' viewBox='0 0 29 23' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128273)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23 8V1H17L15 3C15.0006 4.82632 15.0011 7.50335 15 8H2V16.7639C1.38625 17.3132 1 18.1115 1 19C1 20.6569 2.34315 22 4 22C5.65685 22 7 20.6569 7 19C7 18.1115 6.61375 17.3132 6 16.7639V12H11V15.4688H9L8 22H14V15.4688H12.0417V12H15V16.4688L16.3848 17.529C16.1398 17.9636 16 18.4655 16 19C16 20.6569 17.3431 22 19 22C20.0435 22 20.9625 21.4672 21.5 20.6589C22.0375 21.4672 22.9565 22 24 22C25.6569 22 27 20.6569 27 19C27 18.4278 26.8398 17.8931 26.5619 17.4381L28 16V10L26 8H25.0417V6.04167H26.0417V5H25.0417H25H24V8H23Z' fill='black'/%3E%3Cpath d='M23 1V0.5H23.5V1H23ZM23 8V8.5H22.5V8H23ZM17 1L16.6464 0.646447L16.7929 0.5H17V1ZM15 3L14.5 3.00016L14.4999 2.79296L14.6464 2.64645L15 3ZM15 8L15.5 8.0011L15.4989 8.5H15V8ZM2 8H1.5V7.5H2V8ZM2 16.7639H2.5V16.9874L2.33346 17.1365L2 16.7639ZM6 16.7639L5.66654 17.1365L5.5 16.9874V16.7639H6ZM6 12H5.5V11.5H6V12ZM11 12V11.5H11.5V12H11ZM11 15.4688H11.5V15.9688H11V15.4688ZM9 15.4688L8.50576 15.3931L8.57073 14.9688H9V15.4688ZM8 22V22.5H7.41762L7.50576 21.9243L8 22ZM14 22H14.5V22.5H14V22ZM14 15.4688V14.9688H14.5V15.4688H14ZM12.0417 15.4688V15.9688H11.5417V15.4688H12.0417ZM12.0417 12H11.5417V11.5H12.0417V12ZM15 12V11.5H15.5V12H15ZM15 16.4688L14.696 16.8658L14.5 16.7157V16.4688H15ZM16.3848 17.529L16.6888 17.132L17.0337 17.3961L16.8204 17.7745L16.3848 17.529ZM21.5 20.6589L21.0836 20.3821L21.5 19.7558L21.9164 20.3821L21.5 20.6589ZM26.5619 17.4381L26.1352 17.6988L25.93 17.3629L26.2083 17.0846L26.5619 17.4381ZM28 16H28.5V16.2071L28.3536 16.3536L28 16ZM28 10L28.3536 9.64645L28.5 9.79289V10H28ZM26 8V7.5H26.2071L26.3536 7.64645L26 8ZM25.0417 8V8.5H24.5417V8H25.0417ZM25.0417 6.04167H24.5417V5.54167H25.0417V6.04167ZM26.0417 6.04167H26.5417V6.54167H26.0417V6.04167ZM26.0417 5V4.5H26.5417V5H26.0417ZM24 5H23.5V4.5H24V5ZM24 8H24.5V8.5H24V8ZM23.5 1V8H22.5V1H23.5ZM17 0.5H23V1.5H17V0.5ZM14.6464 2.64645L16.6464 0.646447L17.3536 1.35355L15.3536 3.35355L14.6464 2.64645ZM14.5 7.9989C14.5011 7.50307 14.5006 4.827 14.5 3.00016L15.5 2.99984C15.5006 4.82564 15.5011 7.50362 15.5 8.0011L14.5 7.9989ZM2 7.5H15V8.5H2V7.5ZM1.5 16.7639V8H2.5V16.7639H1.5ZM0.5 19C0.5 17.9634 0.951302 17.0315 1.66654 16.3913L2.33346 17.1365C1.8212 17.5949 1.5 18.2596 1.5 19H0.5ZM4 
      22.5C2.067 22.5 0.5 20.933 0.5 19H1.5C1.5 20.3807 2.61929 21.5 4 21.5V22.5ZM7.5 19C7.5 20.933 5.933 22.5 4 22.5V21.5C5.38071 21.5 6.5 20.3807 6.5 19H7.5ZM6.33346 16.3913C7.0487 17.0315 7.5 17.9634 7.5 19H6.5C6.5 18.2596 6.1788 17.5949 5.66654 17.1365L6.33346 16.3913ZM6.5 12V16.7639H5.5V12H6.5ZM11 12.5H6V11.5H11V12.5ZM10.5 15.4688V12H11.5V15.4688H10.5ZM9 14.9688H11V15.9688H9V14.9688ZM7.50576 21.9243L8.50576 15.3931L9.49424 15.5444L8.49424 22.0757L7.50576 21.9243ZM14 22.5H8V21.5H14V22.5ZM14.5 15.4688V22H13.5V15.4688H14.5ZM12.0417 14.9688H14V15.9688H12.0417V14.9688ZM12.5417 12V15.4688H11.5417V12H12.5417ZM15 12.5H12.0417V11.5H15V12.5ZM14.5 16.4688V12H15.5V16.4688H14.5ZM16.0808 17.926L14.696 16.8658L15.304 16.0717L16.6888 17.132L16.0808 17.926ZM15.5 19C15.5 18.3773 15.6631 17.7911 15.9492 17.2835L16.8204 17.7745C16.6165 18.1362 16.5 18.5537 16.5 19H15.5ZM19 22.5C17.067 22.5 15.5 20.933 15.5 19H16.5C16.5 20.3807 17.6193 21.5 19 21.5V22.5ZM21.9164 20.9357C21.2902 21.8775 20.2179 22.5 19 22.5V21.5C19.8691 21.5 20.6349 21.0569 21.0836 20.3821L21.9164 20.9357ZM24 22.5C22.7821 22.5 21.7098 21.8775 21.0836 20.9357L21.9164 20.3821C22.3651 21.0569 23.1309 21.5 24 21.5V22.5ZM27.5 19C27.5 20.933 25.933 22.5 24 22.5V21.5C25.3807 21.5 26.5 20.3807 26.5 19H27.5ZM26.9885 17.1775C27.3131 17.7087 27.5 18.3333 27.5 19H26.5C26.5 18.5224 26.3666 18.0775 26.1352 17.6988L26.9885 17.1775ZM28.3536 16.3536L26.9154 17.7917L26.2083 17.0846L27.6464 15.6464L28.3536 16.3536ZM28.5 10V16H27.5V10H28.5ZM26.3536 7.64645L28.3536 9.64645L27.6464 10.3536L25.6464 8.35355L26.3536 7.64645ZM25.0417 7.5H26V8.5H25.0417V7.5ZM25.5417 6.04167V8H24.5417V6.04167H25.5417ZM26.0417 6.54167H25.0417V5.54167H26.0417V6.54167ZM26.5417 5V6.04167H25.5417V5H26.5417ZM25.0417 4.5H26.0417V5.5H25.0417V4.5ZM25 4.5H25.0417V5.5H25V4.5ZM24 4.5H25V5.5H24V4.5ZM23.5 8V5H24.5V8H23.5ZM23 7.5H24V8.5H23V7.5Z' fill='white'/%3E%3Cpath d='M5.5 12V16.9688H2.5V8.5H15H15.4989L15.5 8.0011C15.5011 7.52214 15.5006 5.02192 15.5001 3.20704L17.2071 1.5H22.5V8V8.5H23H25.7929L27.5 10.2071V15.7929L25.7929 17.5H17.1694L15.5 16.2218V12V11.5H15H6H5.5V12Z' fill='inherit' stroke='black'/%3E%3Ccircle cx='4' cy='19' r='2.5' fill='inherit' stroke='black'/%3E%3Ccircle cx='19' cy='19' r='2.5' fill='inherit' stroke='black'/%3E%3Ccircle cx='24' cy='19' r='2.5' fill='inherit' stroke='black'/%3E%3Crect x='11' y='12' width='1.04167' height='4.16667' fill='black'/%3E%3Crect x='24' y='5' 
      width='1.04167' height='3.125' fill='black'/%3E%3Crect x='25' y='5' width='1.04167' height='1.04167' fill='black'/%3E%3Cpath d='M8.58238 21.5L9.42927 15.9688H13.5V21.5H8.58238Z' fill='inherit' stroke='black'/%3E%3Cpath d='M20 7H17V4L18 3H20V7Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128273'%3E%3Crect width='29' height='23' fill='white' transform='matrix(-1 0 0 1 29 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST037":
      // 전회전식 천공기
      svgText = `data:image/svg+xml,%3Csvg width='34' height='38' viewBox='0 0 34 38' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128398)'%3E%3Cmask id='path-1-outside-1_2374_128398' maskUnits='userSpaceOnUse' x='0' y='0' width='34' height='38' fill='black'%3E%3Crect fill='white' width='34' height='38'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 4.99955V2.99978L3 1H9V3.99955V4.99955V19.2154L16 24.0961V22.9996L18 20.9996H26V24.9996H31L33 26.9996V30.9996L31 32.9996H30V35.9996C30 36.5519 29.5523 36.9996 29.0001 36.9996H14.9999C14.4477 36.9996 14 36.5519 14 35.9996V32.9995C14 32.4472 14.4477 31.9996 14.9999 31.9996H16V28.972L9 24.0913V27H11V30.9996H9V33H11V36.9996H3L3 33H5V30.9996H3L3 27H5V4.99955H1Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1 4.99955V2.99978L3 1H9V3.99955V4.99955V19.2154L16 24.0961V22.9996L18 20.9996H26V24.9996H31L33 26.9996V30.9996L31 32.9996H30V35.9996C30 36.5519 29.5523 36.9996 29.0001 36.9996H14.9999C14.4477 36.9996 14 36.5519 14 35.9996V32.9995C14 32.4472 14.4477 31.9996 14.9999 31.9996H16V28.972L9 24.0913V27H11V30.9996H9V33H11V36.9996H3L3 33H5V30.9996H3L3 27H5V4.99955H1Z' fill='black'/%3E%3Cpath d='M1 2.99978L0.292933 2.29263L0 2.58553V2.99978H1ZM1 4.99955H0V5.99955H1V4.99955ZM3 1V0H2.58582L2.29293 0.292854L3 1ZM9 1H10V0H9V1ZM9 19.2154H8V19.7372L8.42806 20.0357L9 19.2154ZM16 24.0961L15.4281 24.9164L17 26.0124V24.0961H16ZM16 22.9996L15.2929 22.2924L15 22.5853V22.9996H16ZM18 20.9996V19.9996H17.5858L17.2929 20.2924L18 20.9996ZM26 20.9996H27V19.9996H26V20.9996ZM26 24.9996H25V25.9996H26V24.9996ZM31 24.9996L31.7071 24.2924L31.4142 23.9996H31V24.9996ZM33 26.9996H34V26.5853L33.7071 26.2924L33 26.9996ZM33 30.9996L33.7071 31.7067L34 31.4138V30.9996H33ZM31 32.9996V33.9996H31.4142L31.7071 33.7067L31 32.9996ZM30 32.9996V31.9996H29V32.9996H30ZM16 31.9996V32.9996H17V31.9996H16ZM16 28.972H17V28.4501L16.5719 28.1517L16 28.972ZM9 24.0913L9.57194 23.271L8 22.175V24.0913H9ZM9 27H8V28H9V27ZM11 27H12V26H11V27ZM11 30.9996V31.9996H12V30.9996H11ZM9 30.9996V29.9996H8V30.9996H9ZM9 33H8V34H9V33ZM11 33H12V32H11V33ZM11 36.9996V37.9996H12V36.9996H11ZM3 36.9996L2 36.9996L2 37.9996H3V36.9996ZM3 33V32H2L2 33L3 33ZM5 33V34H6V33H5ZM5 30.9996H6V29.9996H5V30.9996ZM3 30.9996L2 30.9996L2 31.9996H3V30.9996ZM3 27V26H2L2 27L3 27ZM5 27V28H6V27H5ZM5 4.99955H6V3.99955H5V4.99955ZM0 2.99978V4.99955H2V2.99978H0ZM2.29293 0.292854L0.292933 2.29263L1.70707 
      3.70692L3.70707 1.70715L2.29293 0.292854ZM9 0H3V2H9V0ZM10 3.99955V1H8V3.99955H10ZM10 4.99955V3.99955H8V4.99955H10ZM10 19.2154V4.99955H8V19.2154H10ZM16.5719 23.2758L9.57194 18.3951L8.42806 20.0357L15.4281 24.9164L16.5719 23.2758ZM15 22.9996V24.0961H17V22.9996H15ZM17.2929 20.2924L15.2929 22.2924L16.7071 23.7067L18.7071 21.7067L17.2929 20.2924ZM26 19.9996H18V21.9996H26V19.9996ZM27 24.9996V20.9996H25V24.9996H27ZM31 23.9996H26V25.9996H31V23.9996ZM33.7071 26.2924L31.7071 24.2924L30.2929 25.7067L32.2929 27.7067L33.7071 26.2924ZM34 30.9996V26.9996H32V30.9996H34ZM31.7071 33.7067L33.7071 31.7067L32.2929 30.2924L30.2929 32.2924L31.7071 33.7067ZM30 33.9996H31V31.9996H30V33.9996ZM31 35.9996V32.9996H29V35.9996H31ZM29.0001 37.9996C30.1046 37.9996 31 37.1042 31 35.9996H29L29.0001 35.9996V37.9996ZM14.9999 37.9996H29.0001V35.9996H14.9999V37.9996ZM13 35.9996C13 37.1042 13.8954 37.9996 14.9999 37.9996V35.9996L15 35.9996H13ZM13 32.9995V35.9996H15V32.9995H13ZM14.9999 30.9996C13.8954 30.9996 13 31.895 13 32.9995H15L14.9999 32.9996V30.9996ZM16 30.9996H14.9999V32.9996H16V30.9996ZM15 28.972V31.9996H17V28.972H15ZM8.42806 24.9116L15.4281 29.7923L16.5719 28.1517L9.57194 23.271L8.42806 24.9116ZM10 27V24.0913H8V27H10ZM11 26H9V28H11V26ZM12 30.9996V27H10V30.9996H12ZM9 31.9996H11V29.9996H9V31.9996ZM10 33V30.9996H8V33H10ZM11 32H9V34H11V32ZM12 36.9996V33H10V36.9996H12ZM3 37.9996H11V35.9996H3V37.9996ZM2 33L2 36.9996L4 36.9996L4 33L2 33ZM5 32H3V34H5V32ZM4 30.9996V33H6V30.9996H4ZM3 31.9996H5V29.9996H3V31.9996ZM2 27L2 30.9996L4 30.9996L4 27L2 27ZM5 26H3V28H5V26ZM4 4.99955V27H6V4.99955H4ZM1 5.99955H5V3.99955H1V5.99955Z' fill='white' mask='url(%23path-1-outside-1_2374_128398)'/%3E%3Crect x='0.696156' y='-0.124148' width='2.99965' height='13' transform='matrix(0.57202 -0.82024 0.820293 0.571943 6.39978 22.5179)' fill='inherit' stroke='black'/%3E%3Cpath d='M30.7929 25.5L32.5 27.2071V30.7929L30.7929 32.5H25.5V25.5H30.7929Z' fill='inherit' stroke='black'/%3E%3Cpath d='M25.5 21.5V32.5H16.5V23.2071L18.2071 21.5H25.5Z' fill='inherit' stroke='black'/%3E%3Cmask id='path-6-inside-2_2374_128398' fill='white'%3E%3Crect x='14' y='32' width='16' height='5' rx='0.999944'/%3E%3C/mask%3E%3Crect x='14' y='32' width='16' height='5' rx='0.999944' fill='inherit' stroke='black' stroke-width='2' mask='url(%23path-6-inside-2_2374_128398)'/%3E%3Cpath d='M5.5 4.5H8.5V36.4963H5.5V4.5Z' fill='inherit' stroke='black'/%3E%3Crect x='3.5' y='36.5' width='2.99955' 
      height='7' transform='rotate(-90 3.5 36.5)' fill='inherit' stroke='black'/%3E%3Crect x='3.5' y='30.5' width='2.99955' height='7' transform='rotate(-90 3.5 30.5)' fill='inherit' stroke='black'/%3E%3Cpath d='M1.5 3.20735L3.20709 1.50045L8.5 1.50045L8.5 4.5L1.5 4.5L1.5 3.20735Z' fill='inherit' stroke='black'/%3E%3Cpath d='M18 24L19 23H21V27H18V24Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128398'%3E%3Crect width='34' height='38' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST040":
      // 진공흡입 준설차
      svgText = `data:image/svg+xml,%3Csvg width='36' height='21' viewBox='0 0 36 21' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128344)'%3E%3Cmask id='path-1-outside-1_2374_128344' maskUnits='userSpaceOnUse' x='0' y='0' width='36' height='21' fill='black'%3E%3Crect fill='white' width='36' height='21'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M33 1H22V9H20V3H14L12 5V10H8H3V12L1 14V20H10V14L8 12H12V17H15C15 18.6568 16.3432 19.9998 18 19.9998C19.6568 19.9998 21 18.6568 21 17H26C26 18.6568 27.3432 19.9998 29 19.9998C30.6568 19.9998 32 18.6568 32 17H35V15V12V3L33 1Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M33 1H22V9H20V3H14L12 5V10H8H3V12L1 14V20H10V14L8 12H12V17H15C15 18.6568 16.3432 19.9998 18 19.9998C19.6568 19.9998 21 18.6568 21 17H26C26 18.6568 27.3432 19.9998 29 19.9998C30.6568 19.9998 32 18.6568 32 17H35V15V12V3L33 1Z' fill='inherit'/%3E%3Cpath d='M22 1V0H21V1H22ZM33 1L33.7071 0.292893L33.4142 0H33V1ZM22 9V10H23V9H22ZM20 9H19V10H20V9ZM20 3H21V2H20V3ZM14 3V2H13.5858L13.2929 2.29289L14 3ZM12 5L11.2929 4.29289L11 4.58579V5H12ZM12 10V11H13V10H12ZM3 10V9H2V10H3ZM3 12L3.70711 12.7071L4 12.4142V12H3ZM1 14L0.292893 13.2929L0 13.5858V14H1ZM1 20H0V21H1V20ZM10 20V21H11V20H10ZM10 14H11V13.5858L10.7071 13.2929L10 14ZM8 12V11H5.58579L7.29289 12.7071L8 12ZM12 12H13V11H12V12ZM12 17H11V18H12V17ZM15 17L16 17L16 16H15V17ZM21 17V16H20L20 17L21 17ZM26 17L27 17L27 16H26V17ZM32 17V16H31L31 17L32 17ZM35 17V18H36V17H35ZM35 3H36V2.58579L35.7071 2.29289L35 3ZM22 2H33V0H22V2ZM23 9V1H21V9H23ZM20 10H22V8H20V10ZM19 3V9H21V3H19ZM14 4H20V2H14V4ZM12.7071 5.70711L14.7071 3.70711L13.2929 2.29289L11.2929 4.29289L12.7071 5.70711ZM13 10V5H11V10H13ZM8 11H12V9H8V11ZM3 11H8V9H3V11ZM4 12V10H2V12H4ZM1.70711 14.7071L3.70711 12.7071L2.29289 11.2929L0.292893 13.2929L1.70711 14.7071ZM2 20V14H0V20H2ZM10 19H1V21H10V19ZM9 14V20H11V14H9ZM7.29289 12.7071L9.29289 14.7071L10.7071 13.2929L8.70711 11.2929L7.29289 12.7071ZM12 11H8V13H12V11ZM13 17V12H11V17H13ZM15 16H12V18H15V16ZM18 18.9998C16.8954 18.9998 16 18.1044 16 17L14 17C14.0001 19.2091 15.7909 20.9998 18 20.9998V18.9998ZM20 17C20 18.1044 19.1046 18.9998 18 18.9998V20.9998C20.2091 20.9998 21.9999 19.2091 22 17L20 17ZM26 16H21V18H26V16ZM29 18.9998C27.8954 18.9998 27 18.1044 27 17L25 17C25.0001 19.2091 26.7909 20.9998 29 20.9998V18.9998ZM31 17C31 18.1044 30.1046 18.9998 29 18.9998V20.9998C31.2091 20.9998 32.9999 19.2091 33 17L31 
      17ZM35 16H32V18H35V16ZM34 15V17H36V15H34ZM34 12V15H36V12H34ZM34 3V12H36V3H34ZM32.2929 1.70711L34.2929 3.70711L35.7071 2.29289L33.7071 0.292893L32.2929 1.70711Z' fill='white' mask='url(%23path-1-outside-1_2374_128344)'/%3E%3Cpath d='M22.5 1.5H32.7929L34.5 3.20711V14.5H22.5V1.5Z' fill='inherit' stroke='black'/%3E%3Crect x='19.5' y='9.5' width='3' height='3' fill='inherit' stroke='black'/%3E%3Crect x='8' y='10' width='4' height='2' fill='black'/%3E%3Cpath d='M1.5 14.2071L3.20711 12.5H7.79289L9.5 14.2071V19.5H1.5V14.2071Z' fill='inherit' stroke='black'/%3E%3Cmask id='path-7-inside-2_2374_128344' fill='white'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 3H14L12 5V17H18H20H35V12H20V3Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 3H14L12 5V17H18H20H35V12H20V3Z' fill='inherit'/%3E%3Cpath d='M14 3V2H13.5858L13.2929 2.29289L14 3ZM20 3H21V2H20V3ZM12 5L11.2929 4.29289L11 4.58579V5H12ZM12 17H11V18H12V17ZM35 17V18H36V17H35ZM35 12H36V11H35V12ZM20 12H19V13H20V12ZM14 4H20V2H14V4ZM12.7071 5.70711L14.7071 3.70711L13.2929 2.29289L11.2929 4.29289L12.7071 5.70711ZM13 17V5H11V17H13ZM18 16H12V18H18V16ZM20 16H18V18H20V16ZM35 16H20V18H35V16ZM34 12V17H36V12H34ZM20 13H35V11H20V13ZM19 3V12H21V3H19Z' fill='black' mask='url(%23path-7-inside-2_2374_128344)'/%3E%3Cpath d='M17 9H14V6.06448L15.0645 5H17V9Z' fill='black'/%3E%3Cpath d='M20.5 16.9999C20.5 18.3806 19.3807 19.4998 18 19.4998C16.6193 19.4998 15.5 18.3806 15.5 16.9999C15.5 15.6193 16.6193 14.5 18 14.5C19.3807 14.5 20.5 15.6193 20.5 16.9999Z' fill='inherit' stroke='black'/%3E%3Cpath d='M31.5 16.9999C31.5 18.3806 30.3807 19.4998 29 19.4998C27.6193 19.4998 26.5 18.3806 26.5 16.9999C26.5 15.6193 27.6193 14.5 29 14.5C30.3807 14.5 31.5 15.6193 31.5 16.9999Z' fill='inherit' stroke='black'/%3E%3Crect x='3' y='17' width='1.06452' height='2.12897' fill='black'/%3E%3Crect x='5' y='16' width='1.06452' height='3.19345' fill='black'/%3E%3Crect x='7' y='17' width='1.06452' height='2.12897' fill='black'/%3E%3Cpath d='M3.5 10.5H7.5V12.5H3.5V10.5Z' fill='inherit' stroke='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128344'%3E%3Crect width='36' height='21' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    case "AST042":
      // 살수차
      svgText = `data:image/svg+xml,%3Csvg width='26' height='21' viewBox='0 0 26 21' fill='${colorEncode}' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2374_128315)'%3E%3Cmask id='path-1-outside-1_2374_128315' maskUnits='userSpaceOnUse' x='0' y='0' width='26' height='21' fill='black'%3E%3Crect fill='white' width='26' height='21'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19 1H12V3H9H8H3L1 5V11V12V15L3.00131 16.9103C3.00044 16.9401 3 16.97 3 17C3 18.6569 4.34315 20 6 20C7.65685 20 9 18.6569 9 17H15C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17L23 15V12.7155C24.1652 12.0291 25 10.177 25 8C25 5.23858 23.6569 3 22 3H19V1Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19 1H12V3H9H8H3L1 5V11V12V15L3.00131 16.9103C3.00044 16.9401 3 16.97 3 17C3 18.6569 4.34315 20 6 20C7.65685 20 9 18.6569 9 17H15C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17L23 15V12.7155C24.1652 12.0291 25 10.177 25 8C25 5.23858 23.6569 3 22 3H19V1Z' fill='inherit'/%3E%3Cpath d='M12 1H11V0H12V1ZM19 1V0H20V1H19ZM12 3H13V4H12V3ZM3 3L2.29289 2.29289L2.58579 2H3V3ZM1 5H0V4.58579L0.292893 4.29289L1 5ZM1 15L0.309524 15.7234L0 15.4279V15H1ZM3.00131 16.9103L3.69179 16.187L4.01394 16.4945L4.00088 16.9397L3.00131 16.9103ZM9 17H8V16H9V17ZM15 17V16H16V17H15ZM21 17H20V16.5858L20.2929 16.2929L21 17ZM23 15H24V15.4142L23.7071 15.7071L23 15ZM23 12.7155H22V12.144L22.4924 11.8539L23 12.7155ZM19 3V4H18V3H19ZM12 0H19V2H12V0ZM11 3V1H13V3H11ZM9 2H12V4H9V2ZM8 2H9V4H8V2ZM3 2H8V4H3V2ZM0.292893 4.29289L2.29289 2.29289L3.70711 3.70711L1.70711 5.70711L0.292893 4.29289ZM0 11V5H2V11H0ZM0 12V11H2V12H0ZM0 15V12H2V15H0ZM2.31084 17.6337L0.309524 15.7234L1.69048 14.2766L3.69179 16.187L2.31084 17.6337ZM2 17C2 16.9602 2.00058 16.9206 2.00174 16.881L4.00088 16.9397C4.0003 16.9597 4 16.9798 4 17H2ZM6 21C3.79086 21 2 19.2091 2 17H4C4 18.1046 4.89543 19 6 19V21ZM10 17C10 19.2091 8.20914 21 6 21V19C7.10457 19 8 18.1046 8 17H10ZM15 18H9V16H15V18ZM18 21C15.7909 21 14 19.2091 14 17H16C16 18.1046 16.8954 19 18 19V21ZM22 17C22 19.2091 20.2091 21 18 21V19C19.1046 19 20 18.1046 20 17H22ZM23.7071 15.7071L21.7071 17.7071L20.2929 16.2929L22.2929 14.2929L23.7071 15.7071ZM24 12.7155V15H22V12.7155H24ZM26 8C26 9.21152 25.7685 10.3553 25.3551 11.313C24.947 12.2584 24.3293 13.093 23.5076 13.5771L22.4924 11.8539C22.8358 11.6516 23.2182 11.2169 23.5188 10.5204C23.8141 9.83629 24 8.96551 24 8H26ZM22 2C23.3177 2 24.3398 2.88493 24.9788 3.94997C25.6298 
      5.03492 26 6.46921 26 8H24C24 6.76937 23.6986 5.70366 23.2638 4.97896C22.8171 4.23436 22.3392 4 22 4V2ZM19 2H22V4H19V2ZM20 1V3H18V1H20Z' fill='white' mask='url(%23path-1-outside-1_2374_128315)'/%3E%3Cmask id='path-3-inside-2_2374_128315' fill='white'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 3H3L1 5V11V12V15L3.09524 17H21L23 15V11H13.1H9V4V3Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9 3H3L1 5V11V12V15L3.09524 17H21L23 15V11H13.1H9V4V3Z' fill='inherit'/%3E%3Cpath d='M3 3V2H2.58579L2.29289 2.29289L3 3ZM9 3H10V2H9V3ZM1 5L0.292893 4.29289L0 4.58579V5H1ZM1 15H0V15.4279L0.309524 15.7234L1 15ZM3.09524 17L2.40476 17.7234L2.69458 18H3.09524V17ZM21 17V18H21.4142L21.7071 17.7071L21 17ZM23 15L23.7071 15.7071L24 15.4142V15H23ZM23 11H24V10H23V11ZM9 11H8V12H9V11ZM3 4H9V2H3V4ZM1.70711 5.70711L3.70711 3.70711L2.29289 2.29289L0.292893 4.29289L1.70711 5.70711ZM2 11V5H0V11H2ZM2 12V11H0V12H2ZM2 15V12H0V15H2ZM3.78571 16.2766L1.69048 14.2766L0.309524 15.7234L2.40476 17.7234L3.78571 16.2766ZM21 16H3.09524V18H21V16ZM22.2929 14.2929L20.2929 16.2929L21.7071 17.7071L23.7071 15.7071L22.2929 14.2929ZM22 11V15H24V11H22ZM13.1 12H23V10H13.1V12ZM9 12H13.1V10H9V12ZM8 4V11H10V4H8ZM8 3V4H10V3H8Z' fill='black' mask='url(%23path-3-inside-2_2374_128315)'/%3E%3Cpath d='M3 6L4 5H6V9H3V6Z' fill='black'/%3E%3Ccircle cx='6' cy='17' r='2.5' fill='inherit' stroke='black'/%3E%3Ccircle cx='18' cy='17' r='2.5' fill='inherit' stroke='black'/%3E%3Cmask id='path-8-inside-3_2374_128315' fill='white'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19 1H12V3H8V13H22C23.6569 13 25 10.7614 25 8C25 5.23858 23.6569 3 22 3H19V1Z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19 1H12V3H8V13H22C23.6569 13 25 10.7614 25 8C25 5.23858 23.6569 3 22 3H19V1Z' fill='inherit'/%3E%3Cpath d='M12 1H11V0H12V1ZM19 1V0H20V1H19ZM12 3H13V4H12V3ZM8 3H7V2H8V3ZM8 13V14H7V13H8ZM19 3V4H18V3H19ZM12 0H19V2H12V0ZM11 3V1H13V3H11ZM12 4H8V2H12V4ZM9 3V13H7V3H9ZM8 12H22V14H8V12ZM22 12C22.3392 12 22.8171 11.7656 23.2638 11.021C23.6986 10.2963 24 9.23063 24 8H26C26 9.53079 25.6298 10.9651 24.9788 12.05C24.3398 13.1151 23.3177 14 22 14V12ZM24 8C24 6.76937 23.6986 5.70366 23.2638 4.97896C22.8171 4.23436 22.3392 4 22 4V2C23.3177 2 24.3398 2.88493 24.9788 3.94997C25.6298 5.03492 26 6.46921 26 8H24ZM22 4H19V2H22V4ZM20 1V3H18V1H20Z' fill='black' mask='url(%23path-8-inside-3_2374_128315)'/%3E%3Cpath d='M17.5 8.66667C17.5 9.64726 16.6376 
      10.5 15.5 10.5C14.3624 10.5 13.5 9.64726 13.5 8.66667C13.5 8.14977 13.7634 7.36492 14.2202 6.52693C14.581 5.86526 15.0355 5.21955 15.5 4.71156C15.9645 5.21955 16.419 5.86526 16.7798 6.52693C17.2366 7.36492 17.5 8.14977 17.5 8.66667Z' fill='%2300D1FF' stroke='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2374_128315'%3E%3Crect width='26' height='21' fill='white' transform='matrix(-1 0 0 1 26 0)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A`;
      break;
    default:
      // Etc
      // circle
      svgText = `data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='7.5' fill='${colorEncode}' stroke='${strokeColor}'/%3E%3C/svg%3E%0A`;
      break;
  }

  return svgText;
};
export const setCompanies = (companies) => {
  xitecloud.Companies = companies;
};
export const setBaseColor = (color) => {
  xitecloud.BaseColor = color;
};
export const getColorByDriverCompany = (company) => {
  let result = xitecloud.BaseColor[xitecloud.BaseColor.length - 1];
  const index = xitecloud.Companies.indexOf(company);
  if (index > -1) {
    result = xitecloud.BaseColor[index];
  }
  return result;
};

export const fnAddAsset = (streamData, showAsset) => {
  const currentTime = moment().add(-20, "minutes");
  const addHours =
    streamData.project_mng_sq_t_project_mng !== 124 ||
    streamData.project_mng_sq_t_project_mng !== "124"
      ? 2
      : 0;

  const measureTime = moment(streamData.f_measurement_time, "YYYYMMDDHHmmss").add(
    addHours,
    "hours"
  );

  if (currentTime > measureTime) {
    // 측정시각이 20분을 초과한 stale 데이터 → 엔티티 미생성(지도 미표시) & 미수용
    return false;
  }

  const isInProject = xitecloud.SelectedKeys.includes(streamData.asset_id_txf_asset_mng);

  const _asset = getAssetModel(streamData.asset_id_txf_asset_mng);

  const assetType = FLEET_ASSET_TYPES.includes(streamData.c_equip_type)
    ? streamData.c_equip_type
    : "ETC";
  const modelOption = getModelOptionByAssetType(assetType);

  const unixTime = measureTime.unix();
  if (!_asset) {
    const position = Cesium.Cartesian3.fromDegrees(
      streamData.f_latitude,
      streamData.f_longitude,
      0.0
    );

    const hpr = new Cesium.HeadingPitchRoll(
      Cesium.Math.toRadians(modelOption.initDegree - 0),
      0.0,
      0.0
    );

    const orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);

    const entity = window.cesiumViewer.entities.add({
      id: `rt_asset_${streamData.asset_id_txf_asset_mng}`,
      name: unixTime,
      position: position,
      orientation: orientation,
      model: {
        uri: modelOption.uri,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        minimumPixelSize: 50,
        maximumScale: 150,
        // color: modelOption[equipType].color,
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0,
          showAsset.isShowOnlyPoint ? 0 : 3000
        ),
      },
      // ellipse: {
      //   semiMinorAxis: 20.0,
      //   semiMajorAxis: 19.0,
      //   // material: Cesium.Color.BLUE.withAlpha(0.5),
      //   heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      //   zIndex: 1,
      //   material: modelOption.color.withAlpha(0.5),
      //   distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
      //     0,
      //     showAsset.isShowOnlyPoint ? 0 : 2400
      //   ),
      // },

      label: {
        text: streamData.asset_name + " - " + streamData.spec,
        font: "22pt",
        fillColor: Cesium.Color.BLACK,
        // outlineColor: Cesium.Color.WHITE,
        outlineWidth: 0.5,
        showBackground: true,
        backgroundColor: Cesium.Color.WHITE.withAlpha(0.7),
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        // style: Cesium.LabelStyle.FILL,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(0, -20),
        distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
          0,
          showAsset.isShowAssetName ? 3000 : 0
        ),
      },
      // point: {
      //   pixelSize: 12,
      //   maximumScale: 1,
      //   heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      //   color: modelOption.color,
      //   outlineColor: Cesium.Color.WHITE,
      //   outlineWidth: 2,
      //   distanceDisplayCondition: showAsset.isShowOnlyPoint
      //     ? new Cesium.DistanceDisplayCondition(0, Number.MAX_VALUE)
      //     : new Cesium.DistanceDisplayCondition(3000, Number.MAX_VALUE),
      // },
      billboard: {
        image: getSvg(assetType, getColorByDriverCompany(streamData.driverCompany)),
        show: [{ boolean: true }],
        distanceDisplayCondition: showAsset.isShowOnlyPoint
          ? new Cesium.DistanceDisplayCondition(0, Number.MAX_VALUE)
          : new Cesium.DistanceDisplayCondition(3000, Number.MAX_VALUE),
      },
      show: isInProject,
    });

    xitecloud.AssetModels[streamData.asset_id_txf_asset_mng] = entity;
  } else {
    const preUnixTime = parseInt(_asset.name);
    if (unixTime <= preUnixTime) return true;

    _asset.name = unixTime;
    _asset.show = isInProject;

    if (isInProject) {
      const _prePosition = _asset.position._value;

      const position = Cesium.Cartesian3.fromDegrees(
        streamData.f_longitude,
        streamData.f_latitude,
        0.0
      );

      if (
        _prePosition.x === position.x &&
        _prePosition.y === position.y &&
        _prePosition.z === position.z
      ) {
        return true;
      }

      const dire2 = angle(
        toDegrees(_prePosition)[0],
        toDegrees(_prePosition)[1],
        toDegrees(position)[0],
        toDegrees(position)[1]
      );

      const hpr = new Cesium.HeadingPitchRoll(
        Cesium.Math.toRadians(modelOption.initDegree - dire2),
        0.0,
        0.0
      );

      const orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);

      _asset.orientation = orientation;
      _asset.position = position;
    }
  }

  // 측정 20분 이내의 유효 데이터 수용됨 (엔티티 생성/갱신)
  return true;
};

// fleet entity(장비) 전체 제거
export const RemoveAllEntity = () => {
  let entity = window.cesiumViewer.entities;
  entity.removeAll();
  xitecloud.AssetModels = {};
};

export async function loadWMSbyGIS(layerName) {
  var wmsObj = new Cesium.WebMapServiceImageryProvider({
    url: `/dxfwms/${layerName.split(":")[0]}/wms`,
    parameters: {
      SERVICE: "WMS",
      VERSION: "1.1.1",
      REQUEST: "GetMap",
      format: "image/png",
      transparent: "true",
    },
    layers: layerName,
  });

  let layers = window.cesiumViewer.imageryLayers;
  layers.addImageryProvider(wmsObj);

  return wmsObj;
}

export async function loadWMSbyPath(path) {
  let wmsObj = new Cesium.TileMapServiceImageryProvider({
    url: path,
    fileExtension: "png",
  });

  let layers = window.cesiumViewer.imageryLayers;
  layers.addImageryProvider(wmsObj);

  return wmsObj;
}

export async function loadWMSbyGeoServer(path) {
  const wmsObj = new Cesium.WebMapServiceImageryProvider({
    url: `http://dev.xitecloud.io:20097/geoserver/xc-dev/wms`,
    parameters: {
      SERVICE: `WMS`,
      VERSION: `1.1.0`,
      REQUEST: `GetMap`,
      format: `image/png`,
      transparent: `true`,
    },
    // layers: `xc-dev:${path}`,
    // layers: `${path}`,
    // layers: `xc-dev:txf_h3_idx_status_summary`,
    layers: "xc-dev:pcd_83_20230710_cutfill",
  });

  const layers = window.cesiumViewer.imageryLayers;
  layers.addImageryProvider(wmsObj);

  return wmsObj;
}

export async function loadWMS(_item, path, _callBack) {
  path = `/uploads/data_pcd/${_item.project_mng_sq_t_project_mng}/${_item.f_input_date}/wms`;
  // const { data } = await Axios.get(path, {
  //   params: {},
  // });

  class DataViewObj {
    constructor(_item, _planet) {
      this.planet = wmsObj;

      this.title = _item.f_layer_nm + " WMS";
      this.dbObj = _item;
      this._3DObject = wmsObj;
      this.visible = true;
      this.gbn = "Layers";
      this.group = "topo";
      this.dataType = "wms";
      this.visible = true;
      this.toggle = () => {
        this._3DObject.visible = !this._3DObject.visible;
      };
    }
  }

  const viewer = window.cesiumViewer;
  let layers = viewer.imageryLayers;

  if (layers.length > 1) {
    layers.remove(layers._layers[1]);
  }

  var wmsObj = new Cesium.TileMapServiceImageryProvider({
    url: path,
    fileExtension: "png",
  });

  xitecloud.wmsLayer = wmsObj;

  var rtnObj = layers.addImageryProvider(wmsObj);

  let dataViewObj = new DataViewObj(_item, rtnObj);

  return { ...dataViewObj };
}

const ControlLayer = (layer, visible) => {
  if (layer) {
    for (let i = 0; i < layer.length; i++) {
      layer[i].visible = visible;
      visibleHandleOnChange(visible, layer[i]);
    }
  }
};
export const showLayer = (layer) => {
  ControlLayer(layer, true);
};
export const hideLayer = (layer) => {
  ControlLayer(layer, false);
};
export const toggleLayer = (layer) => {
  if (layer) {
    for (let i = 0; i < layer.length; i++) {
      let visible = layer[i].visible;
      layer[i].visible = !visible;
      visibleHandleOnChange(!visible, layer[i]);
    }
  }
};

// annotation title visible on/off
export const VisibleAnnotation = (obj, v) => {
  if (obj && obj.length) {
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].titleAnnotation) obj[i].titleAnnotation.visible = v;
    }
  }
};
export const showAnnotation = (obj) => {
  VisibleAnnotation(obj, true);
};
export const hideAnnotation = (obj) => {
  VisibleAnnotation(obj, false);
};
export const toggleAnnotation = (obj) => {
  if (obj && obj.length) {
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].titleAnnotation) obj[i].titleAnnotation.visible = !obj[i].titleAnnotation.visible;
    }
  }
};

export const moveViewerPositionByCesiumEntity = (
  entity,
  coordSystem,
  distance = 200,
  useAnimation = false
) => {
  if (!entity || !coordSystem) return;

  const wgs84 = new window.proj4("WGS84");
  const local = new window.proj4(coordSystem);

  // Cartesian 좌표를 LLA 좌표로 변환
  const positionWGS84 = getLLA(entity.position._value);

  // 엔티티 좌표 (위경도 -> 로컬)
  const positionEntity = window.proj4(wgs84, local, positionWGS84);

  // 방향값, 엔티티의 좌표 활용하여 카메라 위치 설정
  const target = calculateDestinationPoint3D(
    positionEntity[0],
    positionEntity[1],
    0,
    -window.viewer.scene.view.direction.x,
    -window.viewer.scene.view.direction.y,
    -window.viewer.scene.view.direction.z,
    distance
  );

  const targetPosition = new window.THREE.Vector3(target.x, target.y, target.z);
  const radius = distance * 0.9;

  if (useAnimation) {
    // 현재 위치와 타겟 위치 계산
    const startPosition = window.viewer.scene.view.position.clone();
    const startRadius = window.viewer.scene.view.radius;

    const duration = 1000; // 이동 시간
    const startTime = Date.now();

    function animateLocation() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;
      const t = Math.min(elapsedTime / duration, 1); // 0에서 1 사이의 값

      window.viewer.scene.view.position.lerpVectors(startPosition, targetPosition, t);
      window.viewer.scene.view.radius = startRadius + (radius - startRadius) * t;
      if (t < 1) {
        requestAnimationFrame(animateLocation);
      } else {
        // 렌더링 업데이트
        window.viewer.render();
      }
    }

    requestAnimationFrame(animateLocation);
  } else {
    // 예전 이동 코드
    // 확대할 위치로 이동 및 확대
    window.viewer.scene.view.position.copy(targetPosition);
    window.viewer.scene.view.radius = distance * 0.9;

    // 렌더링 업데이트
    window.viewer.render();
  }
};

window.xitecloud = xitecloud;
